const mapDataThailand = {
    "title": "Thailand",
    "version": "1.1.3",
    "type": "FeatureCollection",
    "copyright": "Copyright (c) 2020 Highsoft AS, Based on data from Natural Earth",
    "copyrightShort": "Natural Earth",
    "copyrightUrl": "http://www.naturalearthdata.com",
    "crs": {
        "type": "name",
        "properties": {
            "name": "urn:ogc:def:crs:EPSG:32647"
        }
    },
    "hc-transform": {
        "default": {
            "crs": "+proj=utm +zone=47 +datum=WGS84 +units=m +no_defs",
            "scale": 0.000427525171275,
            "jsonres": 15.5,
            "jsonmarginX": -999,
            "jsonmarginY": 9851.0,
            "xoffset": 328899.640185,
            "yoffset": 2260900.49542
        }
    },
    "features": [
        { "type": "Feature", "id": "chomthonghospital", "properties": { "name": "chomthonghospital", "name-TH": "โรงพยาบาลจอมทอง", "longitude": "98.6739622323165", "latitude": "18.4063579197221", }, "geometry": { "type": "Polygon", "coordinates": [[[0, 0],]] } },
        { "type": "Feature", "id": "dvnhospital", "properties": { "name": "dvnhospital", "name-TH": "โรงพยาบาลเทพรัตนเวชชานุกูล เฉลิมพระเกียรติ 60 พรรษา", "longitude": "98.3795304544197", "latitude": "18.4983845540987", }, "geometry": { "type": "Polygon", "coordinates": [[[0, 0],]] } },
        { "type": "Feature", "id": "tchhospital", "properties": { "name": "tchhospital", "name-TH": "โรงพยาบาลธัญญารักษ์เชียงใหม่", "longitude": "98.9411261814117", "latitude": "19.0170191363328", }, "geometry": { "type": "Polygon", "coordinates": [[[0, 0],]] } },
        { "type": "Feature", "id": "watchanhospital", "properties": { "name": "watchanhospital", "name-TH": "โรงพยาบาลวัดจันทร์เฉลิมพระเกียรติ 80 พรรษา", "longitude": "98.3158713967567", "latitude": "19.0778349784009", }, "geometry": { "type": "Polygon", "coordinates": [[[0, 0],]] } },
        { "type": "Feature", "id": "thaigl-F5M01", "properties": { "name": "thaigl-F5M01", "name-TH": "โรงพยาบาลนครพิงค์", "longitude": "98.9686883509133", "latitude": "18.8539503474299", }, "geometry": { "type": "Polygon", "coordinates": [[[0, 0],]] } },
        {
            "type": "Feature",
            "id": "TH.CT",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.57,
                "hc-middle-y": 0.50,
                "hc-key": "th-ct",
                "hc-a2": "CT",
                "labelrank": "7",
                "hasc": "TH.CT",
                "alt-name": "Chantaburi|Muang Chan",
                "woe-id": "2347172",
                "subregion": null,
                "fips": "TH48",
                "postal-code": "CT",
                "name": "Chanthaburi",
                "name-TH": "จันทบุรี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Eastern",
                "longitude": "102.139",
                "woe-name": "Chanthaburi",
                "latitude": "12.8117",
                "woe-label": "Chanthaburi, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2526,
                            4608
                        ],
                        [
                            2565,
                            4509
                        ],
                        [
                            2644,
                            4407
                        ],
                        [
                            2627,
                            4356
                        ],
                        [
                            2656,
                            4263
                        ],
                        [
                            2650,
                            4223
                        ],
                        [
                            2617,
                            4211
                        ],
                        [
                            2579,
                            4163
                        ],
                        [
                            2589,
                            4089
                        ],
                        [
                            2564,
                            4107
                        ],
                        [
                            2533,
                            4083
                        ],
                        [
                            2547,
                            4034
                        ],
                        [
                            2536,
                            4003
                        ],
                        [
                            2567,
                            3969
                        ],
                        [
                            2553,
                            3937
                        ],
                        [
                            2521,
                            3906
                        ],
                        [
                            2502,
                            3924
                        ],
                        [
                            2491,
                            3997
                        ],
                        [
                            2441,
                            3991
                        ],
                        [
                            2467,
                            3977
                        ],
                        [
                            2494,
                            3913
                        ],
                        [
                            2462,
                            3911
                        ],
                        [
                            2387,
                            3980
                        ],
                        [
                            2348,
                            4030
                        ],
                        [
                            2367,
                            4071
                        ],
                        [
                            2330,
                            4069
                        ],
                        [
                            2342,
                            4091
                        ],
                        [
                            2302,
                            4080
                        ],
                        [
                            2342,
                            4055
                        ],
                        [
                            2337,
                            4015
                        ],
                        [
                            2302,
                            4063
                        ],
                        [
                            2258,
                            4059
                        ],
                        [
                            2233,
                            4078
                        ],
                        [
                            2172,
                            4163
                        ],
                        [
                            2142,
                            4182
                        ],
                        [
                            2163,
                            4230
                        ],
                        [
                            2166,
                            4325
                        ],
                        [
                            2134,
                            4366
                        ],
                        [
                            2112,
                            4365
                        ],
                        [
                            2112,
                            4403
                        ],
                        [
                            2085,
                            4428
                        ],
                        [
                            2069,
                            4501
                        ],
                        [
                            2072,
                            4512
                        ],
                        [
                            2087,
                            4529
                        ],
                        [
                            2125,
                            4536
                        ],
                        [
                            2187,
                            4578
                        ],
                        [
                            2205,
                            4564
                        ],
                        [
                            2223,
                            4604
                        ],
                        [
                            2285,
                            4652
                        ],
                        [
                            2314,
                            4592
                        ],
                        [
                            2318,
                            4524
                        ],
                        [
                            2381,
                            4545
                        ],
                        [
                            2412,
                            4585
                        ],
                        [
                            2452,
                            4556
                        ],
                        [
                            2484,
                            4556
                        ],
                        [
                            2526,
                            4608
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.4255",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.95,
                "hc-middle-y": 0.98,
                "hc-key": "th-4255",
                "hc-a2": "NU",
                "labelrank": "20",
                "hasc": "-99",
                "alt-name": null,
                "woe-id": "-99",
                "subregion": null,
                "fips": null,
                "postal-code": null,
                "name": null,
                "country": "Thailand",
                "type-en": null,
                "region": null,
                "longitude": "99.2992",
                "woe-name": null,
                "latitude": "6.53959",
                "woe-label": null,
                "type": null
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                361,
                                -362
                            ],
                            [
                                345,
                                -359
                            ],
                            [
                                336,
                                -322
                            ],
                            [
                                365,
                                -321
                            ],
                            [
                                361,
                                -362
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                120,
                                609
                            ],
                            [
                                133,
                                606
                            ],
                            [
                                125,
                                571
                            ],
                            [
                                89,
                                613
                            ],
                            [
                                120,
                                609
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PG",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.43,
                "hc-middle-y": 0.62,
                "hc-key": "th-pg",
                "hc-a2": "PG",
                "labelrank": "7",
                "hasc": "TH.PG",
                "alt-name": null,
                "woe-id": "2347185",
                "subregion": null,
                "fips": "TH59",
                "postal-code": "PG",
                "name": "Phangnga",
                "name-TH": "พังงา",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "98.39400000000001",
                "woe-name": "Phangnga",
                "latitude": "8.576779999999999",
                "woe-label": "Phangnga, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -204,
                                813
                            ],
                            [
                                -167,
                                787
                            ],
                            [
                                -150,
                                754
                            ],
                            [
                                -149,
                                675
                            ],
                            [
                                -174,
                                670
                            ],
                            [
                                -184,
                                713
                            ],
                            [
                                -170,
                                734
                            ],
                            [
                                -208,
                                794
                            ],
                            [
                                -204,
                                813
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -142,
                                804
                            ],
                            [
                                -179,
                                816
                            ],
                            [
                                -140,
                                869
                            ],
                            [
                                -130,
                                854
                            ],
                            [
                                -142,
                                804
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -380,
                                1414
                            ],
                            [
                                -397,
                                1372
                            ],
                            [
                                -411,
                                1402
                            ],
                            [
                                -403,
                                1471
                            ],
                            [
                                -367,
                                1446
                            ],
                            [
                                -380,
                                1414
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -379,
                                1492
                            ],
                            [
                                -419,
                                1508
                            ],
                            [
                                -411,
                                1575
                            ],
                            [
                                -369,
                                1559
                            ],
                            [
                                -358,
                                1518
                            ],
                            [
                                -379,
                                1492
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -309,
                                1714
                            ],
                            [
                                -280,
                                1723
                            ],
                            [
                                -221,
                                1686
                            ],
                            [
                                -205,
                                1670
                            ],
                            [
                                -242,
                                1503
                            ],
                            [
                                -225,
                                1446
                            ],
                            [
                                -257,
                                1432
                            ],
                            [
                                -260,
                                1379
                            ],
                            [
                                -228,
                                1372
                            ],
                            [
                                -177,
                                1315
                            ],
                            [
                                -157,
                                1313
                            ],
                            [
                                -154,
                                1256
                            ],
                            [
                                -195,
                                1214
                            ],
                            [
                                -170,
                                1188
                            ],
                            [
                                -112,
                                1201
                            ],
                            [
                                -74,
                                1187
                            ],
                            [
                                -86,
                                1145
                            ],
                            [
                                -111,
                                1136
                            ],
                            [
                                -101,
                                1060
                            ],
                            [
                                -121,
                                999
                            ],
                            [
                                -158,
                                1004
                            ],
                            [
                                -222,
                                972
                            ],
                            [
                                -270,
                                967
                            ],
                            [
                                -257,
                                887
                            ],
                            [
                                -285,
                                838
                            ],
                            [
                                -310,
                                829
                            ],
                            [
                                -335,
                                865
                            ],
                            [
                                -392,
                                906
                            ],
                            [
                                -418,
                                1027
                            ],
                            [
                                -449,
                                1121
                            ],
                            [
                                -419,
                                1206
                            ],
                            [
                                -431,
                                1268
                            ],
                            [
                                -410,
                                1291
                            ],
                            [
                                -403,
                                1352
                            ],
                            [
                                -357,
                                1444
                            ],
                            [
                                -309,
                                1488
                            ],
                            [
                                -344,
                                1475
                            ],
                            [
                                -353,
                                1500
                            ],
                            [
                                -315,
                                1514
                            ],
                            [
                                -354,
                                1582
                            ],
                            [
                                -323,
                                1628
                            ],
                            [
                                -337,
                                1646
                            ],
                            [
                                -309,
                                1714
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.ST",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.31,
                "hc-middle-y": 0.55,
                "hc-key": "th-st",
                "hc-a2": "ST",
                "labelrank": "7",
                "hasc": "TH.ST",
                "alt-name": null,
                "woe-id": "2347184",
                "subregion": null,
                "fips": "TH60",
                "postal-code": "ST",
                "name": "Surat Thani",
                "name-TH": "สุราษฎร์ธานี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "99.0107",
                "woe-name": "Surat Thani",
                "latitude": "9.0048",
                "woe-label": "Surat Thani, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                925,
                                1884
                            ],
                            [
                                907,
                                1802
                            ],
                            [
                                881,
                                1777
                            ],
                            [
                                824,
                                1769
                            ],
                            [
                                809,
                                1824
                            ],
                            [
                                808,
                                1877
                            ],
                            [
                                851,
                                1887
                            ],
                            [
                                894,
                                1876
                            ],
                            [
                                925,
                                1884
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                860,
                                2047
                            ],
                            [
                                910,
                                2031
                            ],
                            [
                                927,
                                1950
                            ],
                            [
                                853,
                                1990
                            ],
                            [
                                840,
                                2023
                            ],
                            [
                                860,
                                2047
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                206,
                                2036
                            ],
                            [
                                240,
                                2041
                            ],
                            [
                                267,
                                1933
                            ],
                            [
                                328,
                                1803
                            ],
                            [
                                370,
                                1748
                            ],
                            [
                                346,
                                1747
                            ],
                            [
                                302,
                                1696
                            ],
                            [
                                320,
                                1632
                            ],
                            [
                                390,
                                1622
                            ],
                            [
                                410,
                                1603
                            ],
                            [
                                480,
                                1609
                            ],
                            [
                                514,
                                1659
                            ],
                            [
                                567,
                                1663
                            ],
                            [
                                637,
                                1693
                            ],
                            [
                                697,
                                1691
                            ],
                            [
                                682,
                                1669
                            ],
                            [
                                684,
                                1628
                            ],
                            [
                                667,
                                1574
                            ],
                            [
                                704,
                                1546
                            ],
                            [
                                708,
                                1506
                            ],
                            [
                                679,
                                1500
                            ],
                            [
                                664,
                                1442
                            ],
                            [
                                635,
                                1409
                            ],
                            [
                                561,
                                1396
                            ],
                            [
                                519,
                                1346
                            ],
                            [
                                516,
                                1264
                            ],
                            [
                                491,
                                1218
                            ],
                            [
                                464,
                                1198
                            ],
                            [
                                461,
                                1169
                            ],
                            [
                                432,
                                1142
                            ],
                            [
                                374,
                                1110
                            ],
                            [
                                342,
                                1126
                            ],
                            [
                                345,
                                1085
                            ],
                            [
                                312,
                                1020
                            ],
                            [
                                329,
                                979
                            ],
                            [
                                282,
                                965
                            ],
                            [
                                179,
                                986
                            ],
                            [
                                133,
                                959
                            ],
                            [
                                74,
                                958
                            ],
                            [
                                56,
                                1043
                            ],
                            [
                                68,
                                1065
                            ],
                            [
                                51,
                                1101
                            ],
                            [
                                81,
                                1138
                            ],
                            [
                                75,
                                1157
                            ],
                            [
                                24,
                                1199
                            ],
                            [
                                -33,
                                1222
                            ],
                            [
                                -74,
                                1187
                            ],
                            [
                                -112,
                                1201
                            ],
                            [
                                -170,
                                1188
                            ],
                            [
                                -195,
                                1214
                            ],
                            [
                                -154,
                                1256
                            ],
                            [
                                -157,
                                1313
                            ],
                            [
                                -177,
                                1315
                            ],
                            [
                                -228,
                                1372
                            ],
                            [
                                -260,
                                1379
                            ],
                            [
                                -257,
                                1432
                            ],
                            [
                                -225,
                                1446
                            ],
                            [
                                -242,
                                1503
                            ],
                            [
                                -205,
                                1670
                            ],
                            [
                                -221,
                                1686
                            ],
                            [
                                -203,
                                1713
                            ],
                            [
                                -103,
                                1723
                            ],
                            [
                                -115,
                                1771
                            ],
                            [
                                -29,
                                1862
                            ],
                            [
                                -47,
                                1902
                            ],
                            [
                                -23,
                                1958
                            ],
                            [
                                64,
                                1996
                            ],
                            [
                                160,
                                2000
                            ],
                            [
                                206,
                                2036
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.KR",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.56,
                "hc-middle-y": 0.42,
                "hc-key": "th-kr",
                "hc-a2": "KR",
                "labelrank": "7",
                "hasc": "TH.KR",
                "alt-name": null,
                "woe-id": "2347187",
                "subregion": null,
                "fips": "TH63",
                "postal-code": "KR",
                "name": "Krabi",
                "name-TH": "กระบี่",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "98.984",
                "woe-name": "Krabi",
                "latitude": "8.1333",
                "woe-label": "Krabi, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                221,
                                347
                            ],
                            [
                                177,
                                365
                            ],
                            [
                                155,
                                415
                            ],
                            [
                                150,
                                463
                            ],
                            [
                                190,
                                442
                            ],
                            [
                                198,
                                389
                            ],
                            [
                                221,
                                347
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                221,
                                433
                            ],
                            [
                                186,
                                452
                            ],
                            [
                                167,
                                482
                            ],
                            [
                                226,
                                478
                            ],
                            [
                                221,
                                433
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -121,
                                999
                            ],
                            [
                                -101,
                                1060
                            ],
                            [
                                -111,
                                1136
                            ],
                            [
                                -86,
                                1145
                            ],
                            [
                                -74,
                                1187
                            ],
                            [
                                -33,
                                1222
                            ],
                            [
                                24,
                                1199
                            ],
                            [
                                75,
                                1157
                            ],
                            [
                                81,
                                1138
                            ],
                            [
                                51,
                                1101
                            ],
                            [
                                68,
                                1065
                            ],
                            [
                                56,
                                1043
                            ],
                            [
                                74,
                                958
                            ],
                            [
                                133,
                                959
                            ],
                            [
                                179,
                                986
                            ],
                            [
                                282,
                                965
                            ],
                            [
                                329,
                                979
                            ],
                            [
                                365,
                                943
                            ],
                            [
                                366,
                                876
                            ],
                            [
                                344,
                                804
                            ],
                            [
                                387,
                                725
                            ],
                            [
                                382,
                                687
                            ],
                            [
                                377,
                                647
                            ],
                            [
                                351,
                                620
                            ],
                            [
                                384,
                                544
                            ],
                            [
                                363,
                                505
                            ],
                            [
                                322,
                                476
                            ],
                            [
                                235,
                                541
                            ],
                            [
                                217,
                                513
                            ],
                            [
                                176,
                                508
                            ],
                            [
                                159,
                                526
                            ],
                            [
                                145,
                                593
                            ],
                            [
                                180,
                                626
                            ],
                            [
                                186,
                                674
                            ],
                            [
                                155,
                                658
                            ],
                            [
                                111,
                                697
                            ],
                            [
                                108,
                                727
                            ],
                            [
                                66,
                                764
                            ],
                            [
                                53,
                                744
                            ],
                            [
                                10,
                                734
                            ],
                            [
                                -11,
                                767
                            ],
                            [
                                -33,
                                746
                            ],
                            [
                                -50,
                                779
                            ],
                            [
                                -52,
                                886
                            ],
                            [
                                -64,
                                915
                            ],
                            [
                                -79,
                                894
                            ],
                            [
                                -87,
                                955
                            ],
                            [
                                -141,
                                943
                            ],
                            [
                                -121,
                                999
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SA",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.79,
                "hc-middle-y": 0.71,
                "hc-key": "th-sa",
                "hc-a2": "SA",
                "labelrank": "7",
                "hasc": "TH.SA",
                "alt-name": null,
                "woe-id": "2347191",
                "subregion": null,
                "fips": "TH67",
                "postal-code": "SA",
                "name": "Satun",
                "name-TH": "สตูล",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "99.9633",
                "woe-name": "Satun",
                "latitude": "6.85827",
                "woe-label": "Satun, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                316,
                                -315
                            ],
                            [
                                294,
                                -343
                            ],
                            [
                                262,
                                -341
                            ],
                            [
                                278,
                                -318
                            ],
                            [
                                316,
                                -315
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                623,
                                -372
                            ],
                            [
                                575,
                                -309
                            ],
                            [
                                616,
                                -206
                            ],
                            [
                                651,
                                -327
                            ],
                            [
                                623,
                                -372
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                1013,
                                -223
                            ],
                            [
                                989,
                                -226
                            ],
                            [
                                982,
                                -281
                            ],
                            [
                                990,
                                -321
                            ],
                            [
                                974,
                                -340
                            ],
                            [
                                961,
                                -411
                            ],
                            [
                                934,
                                -380
                            ],
                            [
                                943,
                                -345
                            ],
                            [
                                914,
                                -364
                            ],
                            [
                                868,
                                -320
                            ],
                            [
                                835,
                                -249
                            ],
                            [
                                759,
                                -167
                            ],
                            [
                                739,
                                -172
                            ],
                            [
                                719,
                                -134
                            ],
                            [
                                637,
                                -93
                            ],
                            [
                                652,
                                -32
                            ],
                            [
                                633,
                                -23
                            ],
                            [
                                632,
                                16
                            ],
                            [
                                680,
                                92
                            ],
                            [
                                738,
                                101
                            ],
                            [
                                741,
                                75
                            ],
                            [
                                781,
                                47
                            ],
                            [
                                806,
                                91
                            ],
                            [
                                821,
                                92
                            ],
                            [
                                858,
                                48
                            ],
                            [
                                901,
                                43
                            ],
                            [
                                919,
                                -4
                            ],
                            [
                                955,
                                -53
                            ],
                            [
                                1023,
                                -87
                            ],
                            [
                                1010,
                                -155
                            ],
                            [
                                1013,
                                -223
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.TG",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.39,
                "hc-middle-y": 0.41,
                "hc-key": "th-tg",
                "hc-a2": "TG",
                "labelrank": "7",
                "hasc": "TH.TG",
                "alt-name": "Tab Tiang",
                "woe-id": "2347189",
                "subregion": null,
                "fips": "TH65",
                "postal-code": "TG",
                "name": "Trang",
                "name-TH": "ตรัง",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "99.6467",
                "woe-name": "Trang",
                "latitude": "7.56967",
                "woe-label": "Trang, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                461,
                                180
                            ],
                            [
                                434,
                                164
                            ],
                            [
                                415,
                                138
                            ],
                            [
                                417,
                                198
                            ],
                            [
                                461,
                                180
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                889,
                                64
                            ],
                            [
                                901,
                                43
                            ],
                            [
                                858,
                                48
                            ],
                            [
                                821,
                                92
                            ],
                            [
                                806,
                                91
                            ],
                            [
                                781,
                                47
                            ],
                            [
                                741,
                                75
                            ],
                            [
                                738,
                                101
                            ],
                            [
                                680,
                                92
                            ],
                            [
                                642,
                                82
                            ],
                            [
                                627,
                                122
                            ],
                            [
                                584,
                                97
                            ],
                            [
                                562,
                                111
                            ],
                            [
                                530,
                                175
                            ],
                            [
                                572,
                                248
                            ],
                            [
                                572,
                                272
                            ],
                            [
                                537,
                                218
                            ],
                            [
                                519,
                                224
                            ],
                            [
                                506,
                                278
                            ],
                            [
                                479,
                                201
                            ],
                            [
                                422,
                                225
                            ],
                            [
                                381,
                                277
                            ],
                            [
                                386,
                                340
                            ],
                            [
                                361,
                                383
                            ],
                            [
                                349,
                                451
                            ],
                            [
                                322,
                                476
                            ],
                            [
                                363,
                                505
                            ],
                            [
                                384,
                                544
                            ],
                            [
                                351,
                                620
                            ],
                            [
                                377,
                                647
                            ],
                            [
                                382,
                                687
                            ],
                            [
                                428,
                                648
                            ],
                            [
                                529,
                                640
                            ],
                            [
                                578,
                                714
                            ],
                            [
                                663,
                                723
                            ],
                            [
                                681,
                                713
                            ],
                            [
                                669,
                                651
                            ],
                            [
                                679,
                                620
                            ],
                            [
                                732,
                                495
                            ],
                            [
                                717,
                                439
                            ],
                            [
                                758,
                                354
                            ],
                            [
                                784,
                                275
                            ],
                            [
                                822,
                                218
                            ],
                            [
                                822,
                                181
                            ],
                            [
                                841,
                                127
                            ],
                            [
                                889,
                                64
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.TT",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.60,
                "hc-middle-y": 0.32,
                "hc-key": "th-tt",
                "hc-a2": "TT",
                "labelrank": "7",
                "hasc": "TH.TT",
                "alt-name": null,
                "woe-id": "2347173",
                "subregion": null,
                "fips": "TH49",
                "postal-code": "TT",
                "name": "Trat",
                "name-TH": "ตราด",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Eastern",
                "longitude": "102.541",
                "woe-name": "Trat",
                "latitude": "12.3925",
                "woe-label": "Trat, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                2714,
                                3471
                            ],
                            [
                                2741,
                                3445
                            ],
                            [
                                2736,
                                3356
                            ],
                            [
                                2686,
                                3386
                            ],
                            [
                                2686,
                                3441
                            ],
                            [
                                2699,
                                3494
                            ],
                            [
                                2714,
                                3471
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                2553,
                                3937
                            ],
                            [
                                2567,
                                3969
                            ],
                            [
                                2536,
                                4003
                            ],
                            [
                                2547,
                                4034
                            ],
                            [
                                2533,
                                4083
                            ],
                            [
                                2564,
                                4107
                            ],
                            [
                                2589,
                                4089
                            ],
                            [
                                2579,
                                4163
                            ],
                            [
                                2617,
                                4211
                            ],
                            [
                                2650,
                                4223
                            ],
                            [
                                2645,
                                4161
                            ],
                            [
                                2697,
                                4139
                            ],
                            [
                                2775,
                                4069
                            ],
                            [
                                2848,
                                3984
                            ],
                            [
                                2813,
                                3929
                            ],
                            [
                                2798,
                                3808
                            ],
                            [
                                2804,
                                3779
                            ],
                            [
                                2869,
                                3680
                            ],
                            [
                                2876,
                                3644
                            ],
                            [
                                2910,
                                3580
                            ],
                            [
                                2963,
                                3507
                            ],
                            [
                                2974,
                                3436
                            ],
                            [
                                2958,
                                3434
                            ],
                            [
                                2958,
                                3490
                            ],
                            [
                                2898,
                                3574
                            ],
                            [
                                2862,
                                3607
                            ],
                            [
                                2862,
                                3654
                            ],
                            [
                                2841,
                                3707
                            ],
                            [
                                2755,
                                3788
                            ],
                            [
                                2770,
                                3794
                            ],
                            [
                                2735,
                                3826
                            ],
                            [
                                2704,
                                3824
                            ],
                            [
                                2712,
                                3743
                            ],
                            [
                                2697,
                                3721
                            ],
                            [
                                2683,
                                3759
                            ],
                            [
                                2641,
                                3785
                            ],
                            [
                                2541,
                                3819
                            ],
                            [
                                2512,
                                3813
                            ],
                            [
                                2487,
                                3886
                            ],
                            [
                                2525,
                                3888
                            ],
                            [
                                2553,
                                3937
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                2512,
                                3715
                            ],
                            [
                                2479,
                                3786
                            ],
                            [
                                2491,
                                3785
                            ],
                            [
                                2523,
                                3781
                            ],
                            [
                                2564,
                                3746
                            ],
                            [
                                2620,
                                3663
                            ],
                            [
                                2609,
                                3646
                            ],
                            [
                                2574,
                                3676
                            ],
                            [
                                2572,
                                3653
                            ],
                            [
                                2510,
                                3655
                            ],
                            [
                                2512,
                                3715
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PL",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.45,
                "hc-key": "th-pl",
                "hc-a2": "PL",
                "labelrank": "7",
                "hasc": "TH.PL",
                "alt-name": null,
                "woe-id": "2347190",
                "subregion": null,
                "fips": "TH66",
                "postal-code": "PL",
                "name": "Phatthalung",
                "name-TH": "พัทลุง",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "100.062",
                "woe-name": "Phatthalung",
                "latitude": "7.47276",
                "woe-label": "Phatthalung, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1012,
                            563
                        ],
                        [
                            971,
                            524
                        ],
                        [
                            979,
                            448
                        ],
                        [
                            1002,
                            374
                        ],
                        [
                            1033,
                            345
                        ],
                        [
                            1057,
                            286
                        ],
                        [
                            1088,
                            249
                        ],
                        [
                            1137,
                            241
                        ],
                        [
                            1143,
                            225
                        ],
                        [
                            1118,
                            184
                        ],
                        [
                            1071,
                            148
                        ],
                        [
                            980,
                            129
                        ],
                        [
                            911,
                            90
                        ],
                        [
                            889,
                            64
                        ],
                        [
                            841,
                            127
                        ],
                        [
                            822,
                            181
                        ],
                        [
                            822,
                            218
                        ],
                        [
                            784,
                            275
                        ],
                        [
                            758,
                            354
                        ],
                        [
                            717,
                            439
                        ],
                        [
                            732,
                            495
                        ],
                        [
                            679,
                            620
                        ],
                        [
                            727,
                            643
                        ],
                        [
                            836,
                            659
                        ],
                        [
                            872,
                            641
                        ],
                        [
                            898,
                            601
                        ],
                        [
                            960,
                            585
                        ],
                        [
                            984,
                            581
                        ],
                        [
                            1012,
                            563
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PS",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.57,
                "hc-middle-y": 0.58,
                "hc-key": "th-ps",
                "hc-a2": "PS",
                "labelrank": "7",
                "hasc": "TH.PS",
                "alt-name": "Bisnulok|Phisanulauk|Phitsnulok|Pitsanuloke",
                "woe-id": "2347139",
                "subregion": null,
                "fips": "TH12",
                "postal-code": "PS",
                "name": "Phitsanulok",
                "name-TH": "พิษณุโลก",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.49",
                "woe-name": "Phitsanulok",
                "latitude": "16.9748",
                "woe-label": "Phitsanulok, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1509,
                            7850
                        ],
                        [
                            1461,
                            7751
                        ],
                        [
                            1498,
                            7738
                        ],
                        [
                            1460,
                            7673
                        ],
                        [
                            1489,
                            7572
                        ],
                        [
                            1537,
                            7570
                        ],
                        [
                            1610,
                            7498
                        ],
                        [
                            1592,
                            7452
                        ],
                        [
                            1563,
                            7331
                        ],
                        [
                            1565,
                            7294
                        ],
                        [
                            1593,
                            7263
                        ],
                        [
                            1571,
                            7262
                        ],
                        [
                            1474,
                            7159
                        ],
                        [
                            1496,
                            7104
                        ],
                        [
                            1459,
                            7082
                        ],
                        [
                            1434,
                            7033
                        ],
                        [
                            1435,
                            6987
                        ],
                        [
                            1402,
                            6929
                        ],
                        [
                            1342,
                            6900
                        ],
                        [
                            1316,
                            6850
                        ],
                        [
                            1254,
                            6909
                        ],
                        [
                            1230,
                            6981
                        ],
                        [
                            1139,
                            6989
                        ],
                        [
                            1045,
                            6968
                        ],
                        [
                            1007,
                            7029
                        ],
                        [
                            955,
                            7003
                        ],
                        [
                            926,
                            6972
                        ],
                        [
                            865,
                            6956
                        ],
                        [
                            842,
                            7000
                        ],
                        [
                            783,
                            7022
                        ],
                        [
                            766,
                            7056
                        ],
                        [
                            774,
                            7097
                        ],
                        [
                            793,
                            7123
                        ],
                        [
                            762,
                            7134
                        ],
                        [
                            809,
                            7227
                        ],
                        [
                            856,
                            7221
                        ],
                        [
                            864,
                            7246
                        ],
                        [
                            924,
                            7250
                        ],
                        [
                            933,
                            7294
                        ],
                        [
                            901,
                            7326
                        ],
                        [
                            848,
                            7357
                        ],
                        [
                            789,
                            7415
                        ],
                        [
                            783,
                            7446
                        ],
                        [
                            827,
                            7447
                        ],
                        [
                            864,
                            7446
                        ],
                        [
                            946,
                            7472
                        ],
                        [
                            984,
                            7471
                        ],
                        [
                            1023,
                            7511
                        ],
                        [
                            1013,
                            7549
                        ],
                        [
                            1046,
                            7596
                        ],
                        [
                            1147,
                            7632
                        ],
                        [
                            1191,
                            7623
                        ],
                        [
                            1252,
                            7640
                        ],
                        [
                            1267,
                            7665
                        ],
                        [
                            1345,
                            7718
                        ],
                        [
                            1385,
                            7773
                        ],
                        [
                            1424,
                            7804
                        ],
                        [
                            1454,
                            7849
                        ],
                        [
                            1478,
                            7835
                        ],
                        [
                            1509,
                            7850
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.KP",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.45,
                "hc-middle-y": 0.52,
                "hc-key": "th-kp",
                "hc-a2": "KP",
                "labelrank": "7",
                "hasc": "TH.KP",
                "alt-name": "Gampheang Phet|Kambhengbhej",
                "woe-id": "2347138",
                "subregion": null,
                "fips": "TH11",
                "postal-code": "KP",
                "name": "Kamphaeng Phet",
                "name-TH": "กำแพงเพชร",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "99.5098",
                "woe-name": "Kamphaeng Phet",
                "latitude": "16.4009",
                "woe-label": "Kamphaeng Phet, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            865,
                            6956
                        ],
                        [
                            827,
                            6858
                        ],
                        [
                            839,
                            6840
                        ],
                        [
                            803,
                            6796
                        ],
                        [
                            796,
                            6737
                        ],
                        [
                            765,
                            6645
                        ],
                        [
                            722,
                            6608
                        ],
                        [
                            678,
                            6538
                        ],
                        [
                            653,
                            6466
                        ],
                        [
                            607,
                            6434
                        ],
                        [
                            570,
                            6504
                        ],
                        [
                            517,
                            6530
                        ],
                        [
                            459,
                            6514
                        ],
                        [
                            389,
                            6529
                        ],
                        [
                            335,
                            6510
                        ],
                        [
                            290,
                            6541
                        ],
                        [
                            250,
                            6538
                        ],
                        [
                            191,
                            6495
                        ],
                        [
                            184,
                            6589
                        ],
                        [
                            153,
                            6613
                        ],
                        [
                            142,
                            6680
                        ],
                        [
                            151,
                            6738
                        ],
                        [
                            133,
                            6798
                        ],
                        [
                            143,
                            6886
                        ],
                        [
                            126,
                            6929
                        ],
                        [
                            139,
                            6943
                        ],
                        [
                            215,
                            6940
                        ],
                        [
                            260,
                            6976
                        ],
                        [
                            304,
                            6988
                        ],
                        [
                            316,
                            7013
                        ],
                        [
                            311,
                            7070
                        ],
                        [
                            344,
                            7121
                        ],
                        [
                            348,
                            7170
                        ],
                        [
                            365,
                            7188
                        ],
                        [
                            379,
                            7242
                        ],
                        [
                            408,
                            7226
                        ],
                        [
                            484,
                            7239
                        ],
                        [
                            508,
                            7233
                        ],
                        [
                            527,
                            7189
                        ],
                        [
                            624,
                            7128
                        ],
                        [
                            742,
                            7129
                        ],
                        [
                            774,
                            7097
                        ],
                        [
                            766,
                            7056
                        ],
                        [
                            783,
                            7022
                        ],
                        [
                            842,
                            7000
                        ],
                        [
                            865,
                            6956
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PC",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.55,
                "hc-key": "th-pc",
                "hc-a2": "PC",
                "labelrank": "7",
                "hasc": "TH.PC",
                "alt-name": null,
                "woe-id": "2347140",
                "subregion": null,
                "fips": "TH13",
                "postal-code": "PC",
                "name": "Phichit",
                "name-TH": "พิจิตร",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.374",
                "woe-name": "Phichit",
                "latitude": "16.2321",
                "woe-label": "Phichit, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            839,
                            6840
                        ],
                        [
                            827,
                            6858
                        ],
                        [
                            865,
                            6956
                        ],
                        [
                            926,
                            6972
                        ],
                        [
                            955,
                            7003
                        ],
                        [
                            1007,
                            7029
                        ],
                        [
                            1045,
                            6968
                        ],
                        [
                            1139,
                            6989
                        ],
                        [
                            1230,
                            6981
                        ],
                        [
                            1254,
                            6909
                        ],
                        [
                            1316,
                            6850
                        ],
                        [
                            1337,
                            6780
                        ],
                        [
                            1292,
                            6697
                        ],
                        [
                            1292,
                            6633
                        ],
                        [
                            1340,
                            6620
                        ],
                        [
                            1390,
                            6586
                        ],
                        [
                            1380,
                            6545
                        ],
                        [
                            1272,
                            6560
                        ],
                        [
                            1203,
                            6540
                        ],
                        [
                            1136,
                            6539
                        ],
                        [
                            1057,
                            6550
                        ],
                        [
                            1055,
                            6530
                        ],
                        [
                            1000,
                            6538
                        ],
                        [
                            965,
                            6560
                        ],
                        [
                            942,
                            6603
                        ],
                        [
                            908,
                            6697
                        ],
                        [
                            872,
                            6728
                        ],
                        [
                            860,
                            6815
                        ],
                        [
                            839,
                            6840
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SH",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.76,
                "hc-middle-y": 0.70,
                "hc-key": "th-sh",
                "hc-a2": "SH",
                "labelrank": "7",
                "hasc": "TH.SH",
                "alt-name": null,
                "woe-id": "2347175",
                "subregion": null,
                "fips": "TH51",
                "postal-code": "SH",
                "name": "Suphan Buri",
                "name-TH": "สุพรรณบุรี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.034",
                "woe-name": "Suphan Buri",
                "latitude": "14.4298",
                "woe-label": "Suphan Buri, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1014,
                            5706
                        ],
                        [
                            998,
                            5680
                        ],
                        [
                            1009,
                            5607
                        ],
                        [
                            989,
                            5545
                        ],
                        [
                            1004,
                            5502
                        ],
                        [
                            1030,
                            5484
                        ],
                        [
                            1051,
                            5423
                        ],
                        [
                            1032,
                            5294
                        ],
                        [
                            1008,
                            5257
                        ],
                        [
                            959,
                            5230
                        ],
                        [
                            840,
                            5233
                        ],
                        [
                            764,
                            5174
                        ],
                        [
                            715,
                            5171
                        ],
                        [
                            687,
                            5201
                        ],
                        [
                            683,
                            5251
                        ],
                        [
                            714,
                            5280
                        ],
                        [
                            724,
                            5318
                        ],
                        [
                            720,
                            5373
                        ],
                        [
                            724,
                            5506
                        ],
                        [
                            769,
                            5542
                        ],
                        [
                            740,
                            5575
                        ],
                        [
                            754,
                            5594
                        ],
                        [
                            697,
                            5621
                        ],
                        [
                            618,
                            5708
                        ],
                        [
                            523,
                            5709
                        ],
                        [
                            512,
                            5659
                        ],
                        [
                            462,
                            5632
                        ],
                        [
                            447,
                            5686
                        ],
                        [
                            408,
                            5687
                        ],
                        [
                            337,
                            5762
                        ],
                        [
                            355,
                            5782
                        ],
                        [
                            334,
                            5858
                        ],
                        [
                            365,
                            5911
                        ],
                        [
                            425,
                            5883
                        ],
                        [
                            433,
                            5859
                        ],
                        [
                            587,
                            5820
                        ],
                        [
                            603,
                            5853
                        ],
                        [
                            652,
                            5830
                        ],
                        [
                            703,
                            5824
                        ],
                        [
                            756,
                            5802
                        ],
                        [
                            826,
                            5793
                        ],
                        [
                            867,
                            5804
                        ],
                        [
                            885,
                            5832
                        ],
                        [
                            948,
                            5804
                        ],
                        [
                            998,
                            5827
                        ],
                        [
                            1006,
                            5794
                        ],
                        [
                            999,
                            5732
                        ],
                        [
                            1014,
                            5706
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.AT",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.95,
                "hc-middle-y": 0.52,
                "hc-key": "th-at",
                "hc-a2": "AT",
                "labelrank": "9",
                "hasc": "TH.AT",
                "alt-name": null,
                "woe-id": "2347160",
                "subregion": null,
                "fips": "TH35",
                "postal-code": "AT",
                "name": "Ang Thong",
                "name-TH": "อ่างทอง",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.357",
                "woe-name": "Ang Thong",
                "latitude": "14.6335",
                "woe-label": "Ang Thong, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1030,
                            5484
                        ],
                        [
                            1004,
                            5502
                        ],
                        [
                            989,
                            5545
                        ],
                        [
                            1009,
                            5607
                        ],
                        [
                            998,
                            5680
                        ],
                        [
                            1014,
                            5706
                        ],
                        [
                            1092,
                            5709
                        ],
                        [
                            1126,
                            5678
                        ],
                        [
                            1189,
                            5660
                        ],
                        [
                            1196,
                            5647
                        ],
                        [
                            1216,
                            5631
                        ],
                        [
                            1206,
                            5553
                        ],
                        [
                            1206,
                            5462
                        ],
                        [
                            1157,
                            5454
                        ],
                        [
                            1145,
                            5501
                        ],
                        [
                            1030,
                            5484
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.LB",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.47,
                "hc-key": "th-lb",
                "hc-a2": "LB",
                "labelrank": "7",
                "hasc": "TH.LB",
                "alt-name": null,
                "woe-id": "2347159",
                "subregion": null,
                "fips": "TH34",
                "postal-code": "LB",
                "name": "Lop Buri",
                "name-TH": "ลพบุรี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.944",
                "woe-name": "Lop Buri",
                "latitude": "15.1147",
                "woe-label": "Lop Buri, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1216,
                            5631
                        ],
                        [
                            1196,
                            5647
                        ],
                        [
                            1189,
                            5660
                        ],
                        [
                            1200,
                            5679
                        ],
                        [
                            1188,
                            5741
                        ],
                        [
                            1157,
                            5807
                        ],
                        [
                            1175,
                            5839
                        ],
                        [
                            1163,
                            5906
                        ],
                        [
                            1186,
                            5938
                        ],
                        [
                            1200,
                            5990
                        ],
                        [
                            1221,
                            6003
                        ],
                        [
                            1244,
                            6054
                        ],
                        [
                            1364,
                            6169
                        ],
                        [
                            1371,
                            6228
                        ],
                        [
                            1474,
                            6206
                        ],
                        [
                            1538,
                            6218
                        ],
                        [
                            1590,
                            6179
                        ],
                        [
                            1667,
                            6153
                        ],
                        [
                            1722,
                            6158
                        ],
                        [
                            1745,
                            6110
                        ],
                        [
                            1772,
                            6088
                        ],
                        [
                            1757,
                            6042
                        ],
                        [
                            1759,
                            5931
                        ],
                        [
                            1831,
                            5912
                        ],
                        [
                            1881,
                            5810
                        ],
                        [
                            1880,
                            5766
                        ],
                        [
                            1808,
                            5723
                        ],
                        [
                            1800,
                            5698
                        ],
                        [
                            1758,
                            5668
                        ],
                        [
                            1699,
                            5687
                        ],
                        [
                            1651,
                            5750
                        ],
                        [
                            1621,
                            5757
                        ],
                        [
                            1554,
                            5727
                        ],
                        [
                            1529,
                            5681
                        ],
                        [
                            1475,
                            5701
                        ],
                        [
                            1470,
                            5740
                        ],
                        [
                            1439,
                            5777
                        ],
                        [
                            1409,
                            5769
                        ],
                        [
                            1362,
                            5688
                        ],
                        [
                            1284,
                            5636
                        ],
                        [
                            1272,
                            5610
                        ],
                        [
                            1246,
                            5616
                        ],
                        [
                            1216,
                            5631
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PA",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.50,
                "hc-middle-y": 0.50,
                "hc-key": "th-pa",
                "hc-a2": "PA",
                "labelrank": "7",
                "hasc": "TH.PA",
                "alt-name": "Phranakhon Si Ayutthaya|Ayudhya|Ayutthaya|Phranakhornsri-ayuthaya",
                "woe-id": "2347161",
                "subregion": null,
                "fips": "TH36",
                "postal-code": "PA",
                "name": "Phra Nakhon Si Ayutthaya",
                "name-TH": "พระนครศรีอยุธยา",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.522",
                "woe-name": "Phra Nakhon Si Ayutthaya",
                "latitude": "14.402",
                "woe-label": "Phra Nakhon Si Ayutthaya, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1216,
                            5631
                        ],
                        [
                            1246,
                            5616
                        ],
                        [
                            1272,
                            5610
                        ],
                        [
                            1259,
                            5561
                        ],
                        [
                            1294,
                            5530
                        ],
                        [
                            1353,
                            5547
                        ],
                        [
                            1399,
                            5541
                        ],
                        [
                            1389,
                            5504
                        ],
                        [
                            1397,
                            5427
                        ],
                        [
                            1415,
                            5409
                        ],
                        [
                            1407,
                            5373
                        ],
                        [
                            1437,
                            5355
                        ],
                        [
                            1438,
                            5307
                        ],
                        [
                            1319,
                            5250
                        ],
                        [
                            1293,
                            5224
                        ],
                        [
                            1247,
                            5212
                        ],
                        [
                            1101,
                            5211
                        ],
                        [
                            1064,
                            5226
                        ],
                        [
                            1053,
                            5213
                        ],
                        [
                            1048,
                            5250
                        ],
                        [
                            1008,
                            5257
                        ],
                        [
                            1032,
                            5294
                        ],
                        [
                            1051,
                            5423
                        ],
                        [
                            1030,
                            5484
                        ],
                        [
                            1145,
                            5501
                        ],
                        [
                            1157,
                            5454
                        ],
                        [
                            1206,
                            5462
                        ],
                        [
                            1206,
                            5553
                        ],
                        [
                            1216,
                            5631
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.NP",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.51,
                "hc-middle-y": 0.55,
                "hc-key": "th-np",
                "hc-a2": "NP",
                "labelrank": "7",
                "hasc": "TH.NP",
                "alt-name": null,
                "woe-id": "2347177",
                "subregion": null,
                "fips": "TH53",
                "postal-code": "NP",
                "name": "Nakhon Pathom",
                "name-TH": "นครปฐม",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.072",
                "woe-name": "Nakhon Pathom",
                "latitude": "13.917",
                "woe-label": "Nathon Pathon, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1008,
                            5257
                        ],
                        [
                            1048,
                            5250
                        ],
                        [
                            1053,
                            5213
                        ],
                        [
                            1039,
                            5149
                        ],
                        [
                            1062,
                            5105
                        ],
                        [
                            1059,
                            5048
                        ],
                        [
                            1092,
                            4980
                        ],
                        [
                            1086,
                            4945
                        ],
                        [
                            1089,
                            4930
                        ],
                        [
                            1048,
                            4911
                        ],
                        [
                            1037,
                            4879
                        ],
                        [
                            908,
                            4895
                        ],
                        [
                            884,
                            4903
                        ],
                        [
                            873,
                            4935
                        ],
                        [
                            827,
                            4920
                        ],
                        [
                            814,
                            4940
                        ],
                        [
                            823,
                            5012
                        ],
                        [
                            809,
                            5072
                        ],
                        [
                            765,
                            5086
                        ],
                        [
                            713,
                            5152
                        ],
                        [
                            715,
                            5171
                        ],
                        [
                            764,
                            5174
                        ],
                        [
                            840,
                            5233
                        ],
                        [
                            959,
                            5230
                        ],
                        [
                            1008,
                            5257
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SB",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.42,
                "hc-middle-y": 0.52,
                "hc-key": "th-sb",
                "hc-a2": "SB",
                "labelrank": "9",
                "hasc": "TH.SB",
                "alt-name": null,
                "woe-id": "2347158",
                "subregion": null,
                "fips": "TH33",
                "postal-code": "SB",
                "name": "Sing Buri",
                "name-TH": "สิงห์บุรี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.343",
                "woe-name": "Sing Buri",
                "latitude": "14.9746",
                "woe-label": "Sing Buri, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1163,
                            5906
                        ],
                        [
                            1175,
                            5839
                        ],
                        [
                            1157,
                            5807
                        ],
                        [
                            1188,
                            5741
                        ],
                        [
                            1200,
                            5679
                        ],
                        [
                            1189,
                            5660
                        ],
                        [
                            1126,
                            5678
                        ],
                        [
                            1092,
                            5709
                        ],
                        [
                            1014,
                            5706
                        ],
                        [
                            999,
                            5732
                        ],
                        [
                            1006,
                            5794
                        ],
                        [
                            998,
                            5827
                        ],
                        [
                            1038,
                            5826
                        ],
                        [
                            1063,
                            5857
                        ],
                        [
                            1040,
                            5878
                        ],
                        [
                            1059,
                            5905
                        ],
                        [
                            1041,
                            5943
                        ],
                        [
                            1067,
                            5984
                        ],
                        [
                            1089,
                            5978
                        ],
                        [
                            1107,
                            5930
                        ],
                        [
                            1163,
                            5906
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.CN",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.50,
                "hc-middle-y": 0.50,
                "hc-key": "th-cn",
                "hc-a2": "CN",
                "labelrank": "7",
                "hasc": "TH.CN",
                "alt-name": "Chainat",
                "woe-id": "2347157",
                "subregion": null,
                "fips": "TH32",
                "postal-code": "CN",
                "name": "Chai Nat",
                "name-TH": "ชัยนาท",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.013",
                "woe-name": "Chai Nat",
                "latitude": "15.1055",
                "woe-label": "Chai Nat, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1067,
                            5984
                        ],
                        [
                            1041,
                            5943
                        ],
                        [
                            1059,
                            5905
                        ],
                        [
                            1040,
                            5878
                        ],
                        [
                            1063,
                            5857
                        ],
                        [
                            1038,
                            5826
                        ],
                        [
                            998,
                            5827
                        ],
                        [
                            948,
                            5804
                        ],
                        [
                            885,
                            5832
                        ],
                        [
                            867,
                            5804
                        ],
                        [
                            826,
                            5793
                        ],
                        [
                            756,
                            5802
                        ],
                        [
                            703,
                            5824
                        ],
                        [
                            652,
                            5830
                        ],
                        [
                            659,
                            5869
                        ],
                        [
                            697,
                            5894
                        ],
                        [
                            711,
                            5924
                        ],
                        [
                            672,
                            5979
                        ],
                        [
                            646,
                            6057
                        ],
                        [
                            676,
                            6091
                        ],
                        [
                            772,
                            6068
                        ],
                        [
                            846,
                            6075
                        ],
                        [
                            882,
                            6054
                        ],
                        [
                            897,
                            6092
                        ],
                        [
                            871,
                            6140
                        ],
                        [
                            887,
                            6167
                        ],
                        [
                            930,
                            6169
                        ],
                        [
                            992,
                            6123
                        ],
                        [
                            1033,
                            6072
                        ],
                        [
                            1067,
                            5984
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.BM",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.19,
                "hc-middle-y": 0.92,
                "hc-key": "th-bm",
                "hc-a2": "BM",
                "labelrank": "7",
                "hasc": "TH.BM",
                "alt-name": "Bangkok|Krung Thep|Krung Thep Maha Nakhon|Phra Nakhon-Thonburi",
                "woe-id": "2347165",
                "subregion": null,
                "fips": "TH40",
                "postal-code": "BM",
                "name": "Bangkok Metropolis",
                "name-TH": "กรุงเทพมหานคร",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.626",
                "woe-name": "Bangkok Metropolis",
                "latitude": "13.793",
                "woe-label": "Bangkok, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1187,
                            4759
                        ],
                        [
                            1160,
                            4754
                        ],
                        [
                            1139,
                            4755
                        ],
                        [
                            1147,
                            4770
                        ],
                        [
                            1131,
                            4843
                        ],
                        [
                            1099,
                            4876
                        ],
                        [
                            1089,
                            4930
                        ],
                        [
                            1086,
                            4945
                        ],
                        [
                            1092,
                            4980
                        ],
                        [
                            1201,
                            4980
                        ],
                        [
                            1225,
                            5017
                        ],
                        [
                            1245,
                            5090
                        ],
                        [
                            1337,
                            5069
                        ],
                        [
                            1498,
                            5094
                        ],
                        [
                            1493,
                            5018
                        ],
                        [
                            1513,
                            4997
                        ],
                        [
                            1460,
                            4913
                        ],
                        [
                            1465,
                            4904
                        ],
                        [
                            1362,
                            4918
                        ],
                        [
                            1328,
                            4875
                        ],
                        [
                            1271,
                            4885
                        ],
                        [
                            1278,
                            4907
                        ],
                        [
                            1210,
                            4884
                        ],
                        [
                            1206,
                            4835
                        ],
                        [
                            1184,
                            4823
                        ],
                        [
                            1187,
                            4759
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PT",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.78,
                "hc-middle-y": 0.53,
                "hc-key": "th-pt",
                "hc-a2": "PT",
                "labelrank": "9",
                "hasc": "TH.PT",
                "alt-name": null,
                "woe-id": "2347164",
                "subregion": null,
                "fips": "TH39",
                "postal-code": "PT",
                "name": "Pathum Thani",
                "name-TH": "ปทุมธานี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.625",
                "woe-name": "Pathum Thani",
                "latitude": "14.034",
                "woe-label": "Pathum Thani, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1245,
                            5090
                        ],
                        [
                            1213,
                            5089
                        ],
                        [
                            1108,
                            5130
                        ],
                        [
                            1094,
                            5160
                        ],
                        [
                            1101,
                            5211
                        ],
                        [
                            1247,
                            5212
                        ],
                        [
                            1293,
                            5224
                        ],
                        [
                            1319,
                            5250
                        ],
                        [
                            1438,
                            5307
                        ],
                        [
                            1469,
                            5321
                        ],
                        [
                            1502,
                            5287
                        ],
                        [
                            1505,
                            5146
                        ],
                        [
                            1499,
                            5098
                        ],
                        [
                            1498,
                            5094
                        ],
                        [
                            1337,
                            5069
                        ],
                        [
                            1245,
                            5090
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.NO",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.36,
                "hc-middle-y": 0.59,
                "hc-key": "th-no",
                "hc-a2": "NO",
                "labelrank": "9",
                "hasc": "TH.NO",
                "alt-name": null,
                "woe-id": "2347163",
                "subregion": null,
                "fips": "TH38",
                "postal-code": "NO",
                "name": "Nonthaburi",
                "name-TH": "นนทบุรี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.407",
                "woe-name": "Nonthaburi",
                "latitude": "13.8933",
                "woe-label": "Nonthaburi, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1101,
                            5211
                        ],
                        [
                            1094,
                            5160
                        ],
                        [
                            1108,
                            5130
                        ],
                        [
                            1213,
                            5089
                        ],
                        [
                            1245,
                            5090
                        ],
                        [
                            1225,
                            5017
                        ],
                        [
                            1201,
                            4980
                        ],
                        [
                            1092,
                            4980
                        ],
                        [
                            1059,
                            5048
                        ],
                        [
                            1062,
                            5105
                        ],
                        [
                            1039,
                            5149
                        ],
                        [
                            1053,
                            5213
                        ],
                        [
                            1064,
                            5226
                        ],
                        [
                            1101,
                            5211
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SP",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.50,
                "hc-middle-y": 0.49,
                "hc-key": "th-sp",
                "hc-a2": "SP",
                "labelrank": "9",
                "hasc": "TH.SP",
                "alt-name": "Pak Nam|Samudh Prakarn|Samudraprakar|Samut Phrakhan",
                "woe-id": "2347167",
                "subregion": null,
                "fips": "TH42",
                "postal-code": "SP",
                "name": "Samut Prakan",
                "name-TH": "สมุทรปราการ",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.704",
                "woe-name": "Samut Prakan",
                "latitude": "13.606",
                "woe-label": "Samut Prakan, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1455,
                            4748
                        ],
                        [
                            1340,
                            4770
                        ],
                        [
                            1276,
                            4802
                        ],
                        [
                            1251,
                            4770
                        ],
                        [
                            1187,
                            4759
                        ],
                        [
                            1184,
                            4823
                        ],
                        [
                            1206,
                            4835
                        ],
                        [
                            1210,
                            4884
                        ],
                        [
                            1278,
                            4907
                        ],
                        [
                            1271,
                            4885
                        ],
                        [
                            1328,
                            4875
                        ],
                        [
                            1362,
                            4918
                        ],
                        [
                            1465,
                            4904
                        ],
                        [
                            1526,
                            4880
                        ],
                        [
                            1530,
                            4859
                        ],
                        [
                            1480,
                            4802
                        ],
                        [
                            1455,
                            4748
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SS",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.83,
                "hc-middle-y": 0.40,
                "hc-key": "th-ss",
                "hc-a2": "SS",
                "labelrank": "9",
                "hasc": "TH.SS",
                "alt-name": "Krokkrak Maha Chai|Mahachai|Samudrasagara",
                "woe-id": "2347179",
                "subregion": null,
                "fips": "TH55",
                "postal-code": "SS",
                "name": "Samut Sakhon",
                "name-TH": "สมุทรสาคร",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.225",
                "woe-name": "Samut Sakhon",
                "latitude": "13.5655",
                "woe-label": "Samut Sakhon, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1139,
                            4755
                        ],
                        [
                            1094,
                            4748
                        ],
                        [
                            1049,
                            4773
                        ],
                        [
                            1022,
                            4744
                        ],
                        [
                            916,
                            4706
                        ],
                        [
                            907,
                            4727
                        ],
                        [
                            879,
                            4763
                        ],
                        [
                            891,
                            4840
                        ],
                        [
                            908,
                            4895
                        ],
                        [
                            1037,
                            4879
                        ],
                        [
                            1048,
                            4911
                        ],
                        [
                            1089,
                            4930
                        ],
                        [
                            1099,
                            4876
                        ],
                        [
                            1131,
                            4843
                        ],
                        [
                            1147,
                            4770
                        ],
                        [
                            1139,
                            4755
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SM",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.34,
                "hc-middle-y": 0.42,
                "hc-key": "th-sm",
                "hc-a2": "SM",
                "labelrank": "9",
                "hasc": "TH.SM",
                "alt-name": "Mae Klong|Samudrasonggram",
                "woe-id": "2347178",
                "subregion": null,
                "fips": "TH54",
                "postal-code": "SM",
                "name": "Samut Songkhram",
                "name-TH": "สมุทรสงคราม",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "99.97360000000001",
                "woe-name": "Samut Songkhram",
                "latitude": "13.4036",
                "woe-label": "Samut Songkhran, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            879,
                            4763
                        ],
                        [
                            907,
                            4727
                        ],
                        [
                            916,
                            4706
                        ],
                        [
                            880,
                            4689
                        ],
                        [
                            857,
                            4638
                        ],
                        [
                            825,
                            4607
                        ],
                        [
                            783,
                            4594
                        ],
                        [
                            775,
                            4568
                        ],
                        [
                            751,
                            4591
                        ],
                        [
                            751,
                            4634
                        ],
                        [
                            793,
                            4767
                        ],
                        [
                            836,
                            4754
                        ],
                        [
                            879,
                            4763
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PE",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.53,
                "hc-middle-y": 0.52,
                "hc-key": "th-pe",
                "hc-a2": "PE",
                "labelrank": "7",
                "hasc": "TH.PE",
                "alt-name": "Phetcha Buri|Bejraburi|Petchburi|Phet Buri|Tetchburit",
                "woe-id": "2347180",
                "subregion": null,
                "fips": "TH56",
                "postal-code": "PE",
                "name": "Phetchaburi",
                "name-TH": "เพชรบุรี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Western",
                "longitude": "99.5964",
                "woe-name": "Phetchaburi",
                "latitude": "12.8727",
                "woe-label": "Phetchaburi, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            751,
                            4634
                        ],
                        [
                            751,
                            4591
                        ],
                        [
                            775,
                            4568
                        ],
                        [
                            783,
                            4594
                        ],
                        [
                            825,
                            4607
                        ],
                        [
                            852,
                            4553
                        ],
                        [
                            906,
                            4506
                        ],
                        [
                            928,
                            4436
                        ],
                        [
                            897,
                            4379
                        ],
                        [
                            871,
                            4282
                        ],
                        [
                            845,
                            4240
                        ],
                        [
                            829,
                            4181
                        ],
                        [
                            826,
                            4127
                        ],
                        [
                            729,
                            4120
                        ],
                        [
                            683,
                            4087
                        ],
                        [
                            620,
                            4082
                        ],
                        [
                            585,
                            4060
                        ],
                        [
                            546,
                            4080
                        ],
                        [
                            477,
                            4089
                        ],
                        [
                            426,
                            4075
                        ],
                        [
                            418,
                            4092
                        ],
                        [
                            334,
                            4147
                        ],
                        [
                            319,
                            4179
                        ],
                        [
                            289,
                            4198
                        ],
                        [
                            286,
                            4240
                        ],
                        [
                            258,
                            4277
                        ],
                        [
                            243,
                            4388
                        ],
                        [
                            202,
                            4420
                        ],
                        [
                            208,
                            4518
                        ],
                        [
                            269,
                            4547
                        ],
                        [
                            318,
                            4522
                        ],
                        [
                            329,
                            4500
                        ],
                        [
                            367,
                            4518
                        ],
                        [
                            384,
                            4559
                        ],
                        [
                            459,
                            4526
                        ],
                        [
                            515,
                            4538
                        ],
                        [
                            554,
                            4533
                        ],
                        [
                            611,
                            4549
                        ],
                        [
                            614,
                            4587
                        ],
                        [
                            640,
                            4621
                        ],
                        [
                            679,
                            4636
                        ],
                        [
                            751,
                            4634
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.CC",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.74,
                "hc-middle-y": 0.59,
                "hc-key": "th-cc",
                "hc-a2": "CC",
                "labelrank": "7",
                "hasc": "TH.CC",
                "alt-name": "Chaxerngsao|Pad Rew|Paed Riu|Petrieu|Shajeun Dhrao",
                "woe-id": "2347169",
                "subregion": null,
                "fips": "TH44",
                "postal-code": "CC",
                "name": "Chachoengsao",
                "name-TH": "ฉะเชิงเทรา",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Eastern",
                "longitude": "101.419",
                "woe-name": "Chachoengsao",
                "latitude": "13.6342",
                "woe-label": "Chachoengsao, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1498,
                            5094
                        ],
                        [
                            1499,
                            5098
                        ],
                        [
                            1527,
                            5108
                        ],
                        [
                            1667,
                            5109
                        ],
                        [
                            1679,
                            5075
                        ],
                        [
                            1670,
                            5042
                        ],
                        [
                            1683,
                            5023
                        ],
                        [
                            1718,
                            5041
                        ],
                        [
                            1821,
                            5031
                        ],
                        [
                            1961,
                            4967
                        ],
                        [
                            1974,
                            4952
                        ],
                        [
                            1998,
                            4974
                        ],
                        [
                            2051,
                            4955
                        ],
                        [
                            2074,
                            4984
                        ],
                        [
                            2109,
                            4991
                        ],
                        [
                            2162,
                            4929
                        ],
                        [
                            2196,
                            4934
                        ],
                        [
                            2204,
                            4898
                        ],
                        [
                            2238,
                            4832
                        ],
                        [
                            2272,
                            4837
                        ],
                        [
                            2278,
                            4767
                        ],
                        [
                            2248,
                            4758
                        ],
                        [
                            2285,
                            4652
                        ],
                        [
                            2223,
                            4604
                        ],
                        [
                            2205,
                            4564
                        ],
                        [
                            2187,
                            4578
                        ],
                        [
                            2125,
                            4536
                        ],
                        [
                            2087,
                            4529
                        ],
                        [
                            2059,
                            4586
                        ],
                        [
                            2031,
                            4615
                        ],
                        [
                            1976,
                            4645
                        ],
                        [
                            1944,
                            4695
                        ],
                        [
                            1901,
                            4700
                        ],
                        [
                            1859,
                            4737
                        ],
                        [
                            1832,
                            4736
                        ],
                        [
                            1768,
                            4804
                        ],
                        [
                            1679,
                            4831
                        ],
                        [
                            1605,
                            4795
                        ],
                        [
                            1607,
                            4772
                        ],
                        [
                            1556,
                            4737
                        ],
                        [
                            1490,
                            4741
                        ],
                        [
                            1455,
                            4748
                        ],
                        [
                            1480,
                            4802
                        ],
                        [
                            1530,
                            4859
                        ],
                        [
                            1526,
                            4880
                        ],
                        [
                            1465,
                            4904
                        ],
                        [
                            1460,
                            4913
                        ],
                        [
                            1513,
                            4997
                        ],
                        [
                            1493,
                            5018
                        ],
                        [
                            1498,
                            5094
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.NN",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.55,
                "hc-middle-y": 0.36,
                "hc-key": "th-nn",
                "hc-a2": "NN",
                "labelrank": "7",
                "hasc": "TH.NN",
                "alt-name": "Nakon Nayok",
                "woe-id": "2347168",
                "subregion": null,
                "fips": "TH43",
                "postal-code": "NN",
                "name": "Nakhon Nayok",
                "name-TH": "นครนายก",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Eastern",
                "longitude": "101.21",
                "woe-name": "Nakhon Nayok",
                "latitude": "14.2249",
                "woe-label": "Nakhon Nayok, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1667,
                            5109
                        ],
                        [
                            1527,
                            5108
                        ],
                        [
                            1499,
                            5098
                        ],
                        [
                            1505,
                            5146
                        ],
                        [
                            1502,
                            5287
                        ],
                        [
                            1526,
                            5314
                        ],
                        [
                            1528,
                            5347
                        ],
                        [
                            1556,
                            5342
                        ],
                        [
                            1591,
                            5371
                        ],
                        [
                            1604,
                            5427
                        ],
                        [
                            1654,
                            5411
                        ],
                        [
                            1680,
                            5387
                        ],
                        [
                            1712,
                            5409
                        ],
                        [
                            1737,
                            5485
                        ],
                        [
                            1765,
                            5502
                        ],
                        [
                            1856,
                            5445
                        ],
                        [
                            1873,
                            5420
                        ],
                        [
                            1907,
                            5403
                        ],
                        [
                            1933,
                            5359
                        ],
                        [
                            1920,
                            5331
                        ],
                        [
                            1873,
                            5321
                        ],
                        [
                            1849,
                            5330
                        ],
                        [
                            1845,
                            5299
                        ],
                        [
                            1789,
                            5255
                        ],
                        [
                            1781,
                            5231
                        ],
                        [
                            1799,
                            5180
                        ],
                        [
                            1721,
                            5167
                        ],
                        [
                            1663,
                            5125
                        ],
                        [
                            1667,
                            5109
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.CB",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.37,
                "hc-middle-y": 0.29,
                "hc-key": "th-cb",
                "hc-a2": "CB",
                "labelrank": "7",
                "hasc": "TH.CB",
                "alt-name": null,
                "woe-id": "2347170",
                "subregion": null,
                "fips": "TH46",
                "postal-code": "CB",
                "name": "Chon Buri",
                "name-TH": "ชลบุรี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Eastern",
                "longitude": "101.278",
                "woe-name": "Chon Buri",
                "latitude": "13.2988",
                "woe-label": "Chon Buri, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2087,
                            4529
                        ],
                        [
                            2072,
                            4512
                        ],
                        [
                            2069,
                            4501
                        ],
                        [
                            2029,
                            4513
                        ],
                        [
                            1988,
                            4491
                        ],
                        [
                            1958,
                            4449
                        ],
                        [
                            1930,
                            4451
                        ],
                        [
                            1909,
                            4426
                        ],
                        [
                            1849,
                            4416
                        ],
                        [
                            1818,
                            4446
                        ],
                        [
                            1774,
                            4435
                        ],
                        [
                            1700,
                            4454
                        ],
                        [
                            1687,
                            4412
                        ],
                        [
                            1634,
                            4415
                        ],
                        [
                            1640,
                            4328
                        ],
                        [
                            1608,
                            4274
                        ],
                        [
                            1575,
                            4246
                        ],
                        [
                            1555,
                            4156
                        ],
                        [
                            1559,
                            4133
                        ],
                        [
                            1556,
                            4103
                        ],
                        [
                            1521,
                            4118
                        ],
                        [
                            1515,
                            4150
                        ],
                        [
                            1472,
                            4142
                        ],
                        [
                            1477,
                            4178
                        ],
                        [
                            1457,
                            4183
                        ],
                        [
                            1479,
                            4229
                        ],
                        [
                            1496,
                            4223
                        ],
                        [
                            1515,
                            4270
                        ],
                        [
                            1478,
                            4328
                        ],
                        [
                            1524,
                            4417
                        ],
                        [
                            1484,
                            4469
                        ],
                        [
                            1532,
                            4545
                        ],
                        [
                            1508,
                            4613
                        ],
                        [
                            1522,
                            4645
                        ],
                        [
                            1557,
                            4661
                        ],
                        [
                            1556,
                            4737
                        ],
                        [
                            1607,
                            4772
                        ],
                        [
                            1605,
                            4795
                        ],
                        [
                            1679,
                            4831
                        ],
                        [
                            1768,
                            4804
                        ],
                        [
                            1832,
                            4736
                        ],
                        [
                            1859,
                            4737
                        ],
                        [
                            1901,
                            4700
                        ],
                        [
                            1944,
                            4695
                        ],
                        [
                            1976,
                            4645
                        ],
                        [
                            2031,
                            4615
                        ],
                        [
                            2059,
                            4586
                        ],
                        [
                            2087,
                            4529
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.BR",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.60,
                "hc-middle-y": 0.51,
                "hc-key": "th-br",
                "hc-a2": "BR",
                "labelrank": "7",
                "hasc": "TH.BR",
                "alt-name": "Buri Rum",
                "woe-id": "2347153",
                "subregion": null,
                "fips": "TH28",
                "postal-code": "BR",
                "name": "Buri Ram",
                "name-TH": "บุรีรัมย์",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "102.971",
                "woe-name": "Buri Ram",
                "latitude": "14.699",
                "woe-label": "Buriram, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            3169,
                            5404
                        ],
                        [
                            3094,
                            5386
                        ],
                        [
                            3057,
                            5368
                        ],
                        [
                            3000,
                            5317
                        ],
                        [
                            2950,
                            5296
                        ],
                        [
                            2936,
                            5269
                        ],
                        [
                            2868,
                            5268
                        ],
                        [
                            2793,
                            5243
                        ],
                        [
                            2707,
                            5254
                        ],
                        [
                            2700,
                            5288
                        ],
                        [
                            2722,
                            5355
                        ],
                        [
                            2691,
                            5416
                        ],
                        [
                            2678,
                            5478
                        ],
                        [
                            2638,
                            5518
                        ],
                        [
                            2624,
                            5566
                        ],
                        [
                            2639,
                            5627
                        ],
                        [
                            2592,
                            5757
                        ],
                        [
                            2635,
                            5737
                        ],
                        [
                            2680,
                            5742
                        ],
                        [
                            2685,
                            5759
                        ],
                        [
                            2655,
                            5855
                        ],
                        [
                            2716,
                            5835
                        ],
                        [
                            2778,
                            5846
                        ],
                        [
                            2811,
                            5870
                        ],
                        [
                            2829,
                            5936
                        ],
                        [
                            2884,
                            5998
                        ],
                        [
                            2972,
                            6026
                        ],
                        [
                            2964,
                            6108
                        ],
                        [
                            2975,
                            6152
                        ],
                        [
                            2948,
                            6168
                        ],
                        [
                            2963,
                            6199
                        ],
                        [
                            2994,
                            6211
                        ],
                        [
                            2938,
                            6253
                        ],
                        [
                            2864,
                            6255
                        ],
                        [
                            2836,
                            6281
                        ],
                        [
                            2828,
                            6351
                        ],
                        [
                            2848,
                            6338
                        ],
                        [
                            2884,
                            6350
                        ],
                        [
                            2907,
                            6450
                        ],
                        [
                            2938,
                            6463
                        ],
                        [
                            2983,
                            6417
                        ],
                        [
                            2961,
                            6377
                        ],
                        [
                            3040,
                            6290
                        ],
                        [
                            3041,
                            6254
                        ],
                        [
                            3062,
                            6240
                        ],
                        [
                            3052,
                            6207
                        ],
                        [
                            3086,
                            6195
                        ],
                        [
                            3101,
                            6155
                        ],
                        [
                            3118,
                            6159
                        ],
                        [
                            3166,
                            6116
                        ],
                        [
                            3192,
                            6117
                        ],
                        [
                            3243,
                            6148
                        ],
                        [
                            3288,
                            6126
                        ],
                        [
                            3316,
                            6135
                        ],
                        [
                            3339,
                            6111
                        ],
                        [
                            3301,
                            6027
                        ],
                        [
                            3309,
                            5935
                        ],
                        [
                            3305,
                            5844
                        ],
                        [
                            3272,
                            5793
                        ],
                        [
                            3195,
                            5719
                        ],
                        [
                            3187,
                            5651
                        ],
                        [
                            3158,
                            5592
                        ],
                        [
                            3158,
                            5544
                        ],
                        [
                            3177,
                            5486
                        ],
                        [
                            3169,
                            5404
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.KK",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.72,
                "hc-middle-y": 0.31,
                "hc-key": "th-kk",
                "hc-a2": "KK",
                "labelrank": "7",
                "hasc": "TH.KK",
                "alt-name": null,
                "woe-id": "2347147",
                "subregion": null,
                "fips": "TH22",
                "postal-code": "KK",
                "name": "Khon Kaen",
                "name-TH": "ขอนแก่น",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "102.683",
                "woe-name": "Khon Kaen",
                "latitude": "16.5762",
                "woe-label": "Khon Kaen, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2938,
                            6463
                        ],
                        [
                            2907,
                            6450
                        ],
                        [
                            2884,
                            6350
                        ],
                        [
                            2848,
                            6338
                        ],
                        [
                            2828,
                            6351
                        ],
                        [
                            2785,
                            6370
                        ],
                        [
                            2758,
                            6408
                        ],
                        [
                            2690,
                            6396
                        ],
                        [
                            2634,
                            6404
                        ],
                        [
                            2565,
                            6388
                        ],
                        [
                            2531,
                            6413
                        ],
                        [
                            2500,
                            6467
                        ],
                        [
                            2502,
                            6510
                        ],
                        [
                            2541,
                            6599
                        ],
                        [
                            2461,
                            6645
                        ],
                        [
                            2451,
                            6663
                        ],
                        [
                            2495,
                            6705
                        ],
                        [
                            2548,
                            6789
                        ],
                        [
                            2579,
                            6910
                        ],
                        [
                            2549,
                            6943
                        ],
                        [
                            2519,
                            6932
                        ],
                        [
                            2441,
                            6955
                        ],
                        [
                            2409,
                            6977
                        ],
                        [
                            2315,
                            6976
                        ],
                        [
                            2242,
                            7036
                        ],
                        [
                            2225,
                            7070
                        ],
                        [
                            2151,
                            7087
                        ],
                        [
                            2103,
                            7076
                        ],
                        [
                            2080,
                            7096
                        ],
                        [
                            2104,
                            7136
                        ],
                        [
                            2106,
                            7167
                        ],
                        [
                            2163,
                            7189
                        ],
                        [
                            2228,
                            7229
                        ],
                        [
                            2243,
                            7225
                        ],
                        [
                            2303,
                            7257
                        ],
                        [
                            2398,
                            7239
                        ],
                        [
                            2427,
                            7261
                        ],
                        [
                            2462,
                            7254
                        ],
                        [
                            2492,
                            7212
                        ],
                        [
                            2559,
                            7190
                        ],
                        [
                            2623,
                            7192
                        ],
                        [
                            2653,
                            7172
                        ],
                        [
                            2687,
                            7179
                        ],
                        [
                            2730,
                            7307
                        ],
                        [
                            2741,
                            7376
                        ],
                        [
                            2765,
                            7382
                        ],
                        [
                            2808,
                            7360
                        ],
                        [
                            2833,
                            7322
                        ],
                        [
                            2842,
                            7259
                        ],
                        [
                            2889,
                            7259
                        ],
                        [
                            2929,
                            7235
                        ],
                        [
                            3039,
                            7290
                        ],
                        [
                            3055,
                            7271
                        ],
                        [
                            3048,
                            7235
                        ],
                        [
                            3088,
                            7252
                        ],
                        [
                            3098,
                            7225
                        ],
                        [
                            3081,
                            7175
                        ],
                        [
                            3079,
                            7093
                        ],
                        [
                            3030,
                            6996
                        ],
                        [
                            2974,
                            6960
                        ],
                        [
                            2924,
                            6945
                        ],
                        [
                            2936,
                            6922
                        ],
                        [
                            2897,
                            6848
                        ],
                        [
                            2866,
                            6821
                        ],
                        [
                            2876,
                            6658
                        ],
                        [
                            2911,
                            6606
                        ],
                        [
                            2907,
                            6570
                        ],
                        [
                            2930,
                            6518
                        ],
                        [
                            2938,
                            6463
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PH",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.44,
                "hc-middle-y": 0.31,
                "hc-key": "th-ph",
                "hc-a2": "PH",
                "labelrank": "7",
                "hasc": "TH.PH",
                "alt-name": null,
                "woe-id": "2347141",
                "subregion": null,
                "fips": "TH14",
                "postal-code": "PH",
                "name": "Phetchabun",
                "name-TH": "เพชรบูรณ์",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "101.21",
                "woe-name": "Phetchabun",
                "latitude": "16.2589",
                "woe-label": "Phetchabun, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2106,
                            7167
                        ],
                        [
                            2104,
                            7136
                        ],
                        [
                            2080,
                            7096
                        ],
                        [
                            2061,
                            7084
                        ],
                        [
                            2038,
                            7105
                        ],
                        [
                            1996,
                            7104
                        ],
                        [
                            1971,
                            7119
                        ],
                        [
                            1942,
                            7095
                        ],
                        [
                            1909,
                            7097
                        ],
                        [
                            1902,
                            7053
                        ],
                        [
                            1911,
                            7004
                        ],
                        [
                            1878,
                            6979
                        ],
                        [
                            1880,
                            6955
                        ],
                        [
                            1835,
                            6899
                        ],
                        [
                            1819,
                            6863
                        ],
                        [
                            1809,
                            6779
                        ],
                        [
                            1782,
                            6656
                        ],
                        [
                            1795,
                            6587
                        ],
                        [
                            1826,
                            6566
                        ],
                        [
                            1808,
                            6514
                        ],
                        [
                            1786,
                            6492
                        ],
                        [
                            1789,
                            6419
                        ],
                        [
                            1836,
                            6380
                        ],
                        [
                            1816,
                            6276
                        ],
                        [
                            1821,
                            6165
                        ],
                        [
                            1772,
                            6088
                        ],
                        [
                            1745,
                            6110
                        ],
                        [
                            1722,
                            6158
                        ],
                        [
                            1667,
                            6153
                        ],
                        [
                            1590,
                            6179
                        ],
                        [
                            1538,
                            6218
                        ],
                        [
                            1474,
                            6206
                        ],
                        [
                            1371,
                            6228
                        ],
                        [
                            1411,
                            6270
                        ],
                        [
                            1437,
                            6322
                        ],
                        [
                            1435,
                            6362
                        ],
                        [
                            1409,
                            6452
                        ],
                        [
                            1411,
                            6496
                        ],
                        [
                            1380,
                            6545
                        ],
                        [
                            1390,
                            6586
                        ],
                        [
                            1340,
                            6620
                        ],
                        [
                            1292,
                            6633
                        ],
                        [
                            1292,
                            6697
                        ],
                        [
                            1337,
                            6780
                        ],
                        [
                            1316,
                            6850
                        ],
                        [
                            1342,
                            6900
                        ],
                        [
                            1402,
                            6929
                        ],
                        [
                            1435,
                            6987
                        ],
                        [
                            1434,
                            7033
                        ],
                        [
                            1459,
                            7082
                        ],
                        [
                            1496,
                            7104
                        ],
                        [
                            1474,
                            7159
                        ],
                        [
                            1571,
                            7262
                        ],
                        [
                            1593,
                            7263
                        ],
                        [
                            1631,
                            7279
                        ],
                        [
                            1640,
                            7359
                        ],
                        [
                            1665,
                            7366
                        ],
                        [
                            1693,
                            7418
                        ],
                        [
                            1771,
                            7381
                        ],
                        [
                            1876,
                            7388
                        ],
                        [
                            1915,
                            7367
                        ],
                        [
                            1946,
                            7331
                        ],
                        [
                            2002,
                            7368
                        ],
                        [
                            2054,
                            7256
                        ],
                        [
                            2055,
                            7171
                        ],
                        [
                            2106,
                            7167
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.KL",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.46,
                "hc-middle-y": 0.49,
                "hc-key": "th-kl",
                "hc-a2": "KL",
                "labelrank": "7",
                "hasc": "TH.KL",
                "alt-name": null,
                "woe-id": "2347148",
                "subregion": null,
                "fips": "TH23",
                "postal-code": "KL",
                "name": "Kalasin",
                "name-TH": "กาฬสินธุ์",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "103.679",
                "woe-name": "Kalasin",
                "latitude": "16.6224",
                "woe-label": "Kalasin, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            3079,
                            7093
                        ],
                        [
                            3081,
                            7175
                        ],
                        [
                            3098,
                            7225
                        ],
                        [
                            3088,
                            7252
                        ],
                        [
                            3048,
                            7235
                        ],
                        [
                            3055,
                            7271
                        ],
                        [
                            3039,
                            7290
                        ],
                        [
                            3059,
                            7324
                        ],
                        [
                            3126,
                            7329
                        ],
                        [
                            3242,
                            7288
                        ],
                        [
                            3268,
                            7233
                        ],
                        [
                            3299,
                            7287
                        ],
                        [
                            3302,
                            7330
                        ],
                        [
                            3318,
                            7355
                        ],
                        [
                            3316,
                            7393
                        ],
                        [
                            3369,
                            7436
                        ],
                        [
                            3417,
                            7395
                        ],
                        [
                            3515,
                            7330
                        ],
                        [
                            3513,
                            7301
                        ],
                        [
                            3559,
                            7251
                        ],
                        [
                            3625,
                            7206
                        ],
                        [
                            3639,
                            7232
                        ],
                        [
                            3688,
                            7262
                        ],
                        [
                            3720,
                            7247
                        ],
                        [
                            3802,
                            7127
                        ],
                        [
                            3804,
                            7087
                        ],
                        [
                            3843,
                            7026
                        ],
                        [
                            3849,
                            6956
                        ],
                        [
                            3793,
                            6964
                        ],
                        [
                            3722,
                            6927
                        ],
                        [
                            3704,
                            6959
                        ],
                        [
                            3629,
                            6957
                        ],
                        [
                            3582,
                            6976
                        ],
                        [
                            3538,
                            6967
                        ],
                        [
                            3469,
                            6912
                        ],
                        [
                            3500,
                            6857
                        ],
                        [
                            3485,
                            6792
                        ],
                        [
                            3439,
                            6792
                        ],
                        [
                            3420,
                            6771
                        ],
                        [
                            3343,
                            6780
                        ],
                        [
                            3292,
                            6766
                        ],
                        [
                            3265,
                            6830
                        ],
                        [
                            3231,
                            6851
                        ],
                        [
                            3181,
                            6917
                        ],
                        [
                            3122,
                            6888
                        ],
                        [
                            3097,
                            6895
                        ],
                        [
                            3107,
                            6941
                        ],
                        [
                            3091,
                            6988
                        ],
                        [
                            3102,
                            7019
                        ],
                        [
                            3093,
                            7060
                        ],
                        [
                            3104,
                            7087
                        ],
                        [
                            3079,
                            7093
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SR",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.55,
                "hc-middle-y": 0.44,
                "hc-key": "th-sr",
                "hc-a2": "SR",
                "labelrank": "7",
                "hasc": "TH.SR",
                "alt-name": "Sara Buri",
                "woe-id": "2347162",
                "subregion": null,
                "fips": "TH37",
                "postal-code": "SR",
                "name": "Saraburi",
                "name-TH": "สระบุรี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.909",
                "woe-name": "Saraburi",
                "latitude": "14.4914",
                "woe-label": "Sara Buri, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1699,
                            5687
                        ],
                        [
                            1711,
                            5559
                        ],
                        [
                            1697,
                            5533
                        ],
                        [
                            1737,
                            5485
                        ],
                        [
                            1712,
                            5409
                        ],
                        [
                            1680,
                            5387
                        ],
                        [
                            1654,
                            5411
                        ],
                        [
                            1604,
                            5427
                        ],
                        [
                            1591,
                            5371
                        ],
                        [
                            1556,
                            5342
                        ],
                        [
                            1528,
                            5347
                        ],
                        [
                            1526,
                            5314
                        ],
                        [
                            1502,
                            5287
                        ],
                        [
                            1469,
                            5321
                        ],
                        [
                            1438,
                            5307
                        ],
                        [
                            1437,
                            5355
                        ],
                        [
                            1407,
                            5373
                        ],
                        [
                            1415,
                            5409
                        ],
                        [
                            1397,
                            5427
                        ],
                        [
                            1389,
                            5504
                        ],
                        [
                            1399,
                            5541
                        ],
                        [
                            1353,
                            5547
                        ],
                        [
                            1294,
                            5530
                        ],
                        [
                            1259,
                            5561
                        ],
                        [
                            1272,
                            5610
                        ],
                        [
                            1284,
                            5636
                        ],
                        [
                            1362,
                            5688
                        ],
                        [
                            1409,
                            5769
                        ],
                        [
                            1439,
                            5777
                        ],
                        [
                            1470,
                            5740
                        ],
                        [
                            1475,
                            5701
                        ],
                        [
                            1529,
                            5681
                        ],
                        [
                            1554,
                            5727
                        ],
                        [
                            1621,
                            5757
                        ],
                        [
                            1651,
                            5750
                        ],
                        [
                            1699,
                            5687
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.NR",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.50,
                "hc-middle-y": 0.47,
                "hc-key": "th-nr",
                "hc-a2": "NR",
                "labelrank": "7",
                "hasc": "TH.NR",
                "alt-name": "Khorat|Nagara Rajasima|Nakaun Rachasima",
                "woe-id": "2347152",
                "subregion": null,
                "fips": "TH32",
                "postal-code": "NR",
                "name": "Nakhon Ratchasima",
                "name-TH": "นครราชสีมา",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "102.103",
                "woe-name": "Nakhon Ratchasima",
                "latitude": "14.8923",
                "woe-label": "Nakhon Ratchasima, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1737,
                            5485
                        ],
                        [
                            1697,
                            5533
                        ],
                        [
                            1711,
                            5559
                        ],
                        [
                            1699,
                            5687
                        ],
                        [
                            1758,
                            5668
                        ],
                        [
                            1800,
                            5698
                        ],
                        [
                            1808,
                            5723
                        ],
                        [
                            1880,
                            5766
                        ],
                        [
                            1881,
                            5810
                        ],
                        [
                            1831,
                            5912
                        ],
                        [
                            1759,
                            5931
                        ],
                        [
                            1757,
                            6042
                        ],
                        [
                            1772,
                            6088
                        ],
                        [
                            1826,
                            6058
                        ],
                        [
                            1848,
                            6024
                        ],
                        [
                            1961,
                            6055
                        ],
                        [
                            2017,
                            6099
                        ],
                        [
                            2148,
                            6156
                        ],
                        [
                            2187,
                            6154
                        ],
                        [
                            2198,
                            6187
                        ],
                        [
                            2239,
                            6217
                        ],
                        [
                            2233,
                            6264
                        ],
                        [
                            2270,
                            6308
                        ],
                        [
                            2295,
                            6356
                        ],
                        [
                            2327,
                            6328
                        ],
                        [
                            2370,
                            6375
                        ],
                        [
                            2390,
                            6421
                        ],
                        [
                            2436,
                            6427
                        ],
                        [
                            2500,
                            6467
                        ],
                        [
                            2531,
                            6413
                        ],
                        [
                            2565,
                            6388
                        ],
                        [
                            2634,
                            6404
                        ],
                        [
                            2690,
                            6396
                        ],
                        [
                            2758,
                            6408
                        ],
                        [
                            2785,
                            6370
                        ],
                        [
                            2828,
                            6351
                        ],
                        [
                            2836,
                            6281
                        ],
                        [
                            2864,
                            6255
                        ],
                        [
                            2938,
                            6253
                        ],
                        [
                            2994,
                            6211
                        ],
                        [
                            2963,
                            6199
                        ],
                        [
                            2948,
                            6168
                        ],
                        [
                            2975,
                            6152
                        ],
                        [
                            2964,
                            6108
                        ],
                        [
                            2972,
                            6026
                        ],
                        [
                            2884,
                            5998
                        ],
                        [
                            2829,
                            5936
                        ],
                        [
                            2811,
                            5870
                        ],
                        [
                            2778,
                            5846
                        ],
                        [
                            2716,
                            5835
                        ],
                        [
                            2655,
                            5855
                        ],
                        [
                            2685,
                            5759
                        ],
                        [
                            2680,
                            5742
                        ],
                        [
                            2635,
                            5737
                        ],
                        [
                            2592,
                            5757
                        ],
                        [
                            2639,
                            5627
                        ],
                        [
                            2624,
                            5566
                        ],
                        [
                            2638,
                            5518
                        ],
                        [
                            2678,
                            5478
                        ],
                        [
                            2691,
                            5416
                        ],
                        [
                            2722,
                            5355
                        ],
                        [
                            2700,
                            5288
                        ],
                        [
                            2707,
                            5254
                        ],
                        [
                            2668,
                            5232
                        ],
                        [
                            2675,
                            5212
                        ],
                        [
                            2641,
                            5216
                        ],
                        [
                            2636,
                            5248
                        ],
                        [
                            2540,
                            5257
                        ],
                        [
                            2498,
                            5236
                        ],
                        [
                            2453,
                            5243
                        ],
                        [
                            2425,
                            5276
                        ],
                        [
                            2400,
                            5241
                        ],
                        [
                            2343,
                            5255
                        ],
                        [
                            2319,
                            5275
                        ],
                        [
                            2252,
                            5327
                        ],
                        [
                            2242,
                            5347
                        ],
                        [
                            2267,
                            5390
                        ],
                        [
                            2248,
                            5416
                        ],
                        [
                            2233,
                            5403
                        ],
                        [
                            2205,
                            5426
                        ],
                        [
                            2188,
                            5407
                        ],
                        [
                            2111,
                            5392
                        ],
                        [
                            2100,
                            5369
                        ],
                        [
                            2007,
                            5452
                        ],
                        [
                            1955,
                            5448
                        ],
                        [
                            1914,
                            5471
                        ],
                        [
                            1856,
                            5445
                        ],
                        [
                            1765,
                            5502
                        ],
                        [
                            1737,
                            5485
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SI",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.61,
                "hc-key": "th-si",
                "hc-a2": "SI",
                "labelrank": "7",
                "hasc": "TH.SI",
                "alt-name": "Sisaket|Khukhan|Khukhandh|Srisaket",
                "woe-id": "2347155",
                "subregion": null,
                "fips": "TH30",
                "postal-code": "SI",
                "name": "Si Sa Ket",
                "name-TH": "ศรีสะเกษ",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "104.418",
                "woe-name": "Si Sa Ket",
                "latitude": "14.8248",
                "woe-label": "Sisaket, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            3684,
                            6200
                        ],
                        [
                            3752,
                            6294
                        ],
                        [
                            3784,
                            6316
                        ],
                        [
                            3800,
                            6269
                        ],
                        [
                            3876,
                            6173
                        ],
                        [
                            3906,
                            6155
                        ],
                        [
                            3975,
                            6137
                        ],
                        [
                            3995,
                            6115
                        ],
                        [
                            4026,
                            6099
                        ],
                        [
                            4114,
                            6086
                        ],
                        [
                            4126,
                            6096
                        ],
                        [
                            4185,
                            6091
                        ],
                        [
                            4224,
                            6037
                        ],
                        [
                            4191,
                            5984
                        ],
                        [
                            4198,
                            5889
                        ],
                        [
                            4215,
                            5862
                        ],
                        [
                            4267,
                            5846
                        ],
                        [
                            4296,
                            5811
                        ],
                        [
                            4289,
                            5774
                        ],
                        [
                            4324,
                            5707
                        ],
                        [
                            4362,
                            5660
                        ],
                        [
                            4327,
                            5659
                        ],
                        [
                            4305,
                            5589
                        ],
                        [
                            4327,
                            5559
                        ],
                        [
                            4325,
                            5502
                        ],
                        [
                            4347,
                            5503
                        ],
                        [
                            4367,
                            5468
                        ],
                        [
                            4307,
                            5480
                        ],
                        [
                            4263,
                            5499
                        ],
                        [
                            4222,
                            5474
                        ],
                        [
                            4137,
                            5474
                        ],
                        [
                            4101,
                            5437
                        ],
                        [
                            4064,
                            5446
                        ],
                        [
                            4043,
                            5433
                        ],
                        [
                            3944,
                            5446
                        ],
                        [
                            3888,
                            5462
                        ],
                        [
                            3855,
                            5444
                        ],
                        [
                            3844,
                            5463
                        ],
                        [
                            3818,
                            5437
                        ],
                        [
                            3790,
                            5444
                        ],
                        [
                            3744,
                            5426
                        ],
                        [
                            3754,
                            5498
                        ],
                        [
                            3741,
                            5570
                        ],
                        [
                            3748,
                            5652
                        ],
                        [
                            3710,
                            5704
                        ],
                        [
                            3698,
                            5758
                        ],
                        [
                            3653,
                            5774
                        ],
                        [
                            3654,
                            5823
                        ],
                        [
                            3713,
                            5927
                        ],
                        [
                            3678,
                            6026
                        ],
                        [
                            3694,
                            6097
                        ],
                        [
                            3746,
                            6151
                        ],
                        [
                            3738,
                            6195
                        ],
                        [
                            3684,
                            6200
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.RE",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.62,
                "hc-key": "th-re",
                "hc-a2": "RE",
                "labelrank": "7",
                "hasc": "TH.RE",
                "alt-name": null,
                "woe-id": "2347150",
                "subregion": null,
                "fips": "TH25",
                "postal-code": "RE",
                "name": "Roi Et",
                "name-TH": "ร้อยเอ็ด",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "103.827",
                "woe-name": "Roi Et",
                "latitude": "15.9601",
                "woe-label": "Roi Et, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            3784,
                            6316
                        ],
                        [
                            3752,
                            6294
                        ],
                        [
                            3684,
                            6200
                        ],
                        [
                            3677,
                            6213
                        ],
                        [
                            3622,
                            6227
                        ],
                        [
                            3618,
                            6242
                        ],
                        [
                            3541,
                            6217
                        ],
                        [
                            3437,
                            6223
                        ],
                        [
                            3401,
                            6234
                        ],
                        [
                            3355,
                            6211
                        ],
                        [
                            3302,
                            6217
                        ],
                        [
                            3278,
                            6204
                        ],
                        [
                            3294,
                            6265
                        ],
                        [
                            3213,
                            6298
                        ],
                        [
                            3191,
                            6334
                        ],
                        [
                            3219,
                            6391
                        ],
                        [
                            3245,
                            6411
                        ],
                        [
                            3289,
                            6420
                        ],
                        [
                            3308,
                            6526
                        ],
                        [
                            3326,
                            6575
                        ],
                        [
                            3304,
                            6683
                        ],
                        [
                            3309,
                            6721
                        ],
                        [
                            3343,
                            6780
                        ],
                        [
                            3420,
                            6771
                        ],
                        [
                            3439,
                            6792
                        ],
                        [
                            3485,
                            6792
                        ],
                        [
                            3500,
                            6857
                        ],
                        [
                            3469,
                            6912
                        ],
                        [
                            3538,
                            6967
                        ],
                        [
                            3582,
                            6976
                        ],
                        [
                            3629,
                            6957
                        ],
                        [
                            3704,
                            6959
                        ],
                        [
                            3722,
                            6927
                        ],
                        [
                            3793,
                            6964
                        ],
                        [
                            3849,
                            6956
                        ],
                        [
                            3897,
                            6973
                        ],
                        [
                            3914,
                            6882
                        ],
                        [
                            3931,
                            6878
                        ],
                        [
                            3912,
                            6831
                        ],
                        [
                            3883,
                            6823
                        ],
                        [
                            3846,
                            6761
                        ],
                        [
                            3759,
                            6706
                        ],
                        [
                            3761,
                            6623
                        ],
                        [
                            3698,
                            6617
                        ],
                        [
                            3694,
                            6486
                        ],
                        [
                            3739,
                            6503
                        ],
                        [
                            3738,
                            6522
                        ],
                        [
                            3781,
                            6480
                        ],
                        [
                            3780,
                            6417
                        ],
                        [
                            3808,
                            6406
                        ],
                        [
                            3841,
                            6348
                        ],
                        [
                            3784,
                            6316
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.LE",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.61,
                "hc-middle-y": 0.51,
                "hc-key": "th-le",
                "hc-a2": "LE",
                "labelrank": "7",
                "hasc": "TH.LE",
                "alt-name": null,
                "woe-id": "2347145",
                "subregion": null,
                "fips": "TH18",
                "postal-code": "LE",
                "name": "Loei",
                "name-TH": "เลย",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "101.517",
                "woe-name": "Loei",
                "latitude": "17.4099",
                "woe-label": "Loei, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2303,
                            7257
                        ],
                        [
                            2243,
                            7225
                        ],
                        [
                            2228,
                            7229
                        ],
                        [
                            2163,
                            7189
                        ],
                        [
                            2106,
                            7167
                        ],
                        [
                            2055,
                            7171
                        ],
                        [
                            2054,
                            7256
                        ],
                        [
                            2002,
                            7368
                        ],
                        [
                            1946,
                            7331
                        ],
                        [
                            1915,
                            7367
                        ],
                        [
                            1876,
                            7388
                        ],
                        [
                            1771,
                            7381
                        ],
                        [
                            1693,
                            7418
                        ],
                        [
                            1665,
                            7366
                        ],
                        [
                            1640,
                            7359
                        ],
                        [
                            1631,
                            7279
                        ],
                        [
                            1593,
                            7263
                        ],
                        [
                            1565,
                            7294
                        ],
                        [
                            1563,
                            7331
                        ],
                        [
                            1592,
                            7452
                        ],
                        [
                            1610,
                            7498
                        ],
                        [
                            1537,
                            7570
                        ],
                        [
                            1489,
                            7572
                        ],
                        [
                            1460,
                            7673
                        ],
                        [
                            1498,
                            7738
                        ],
                        [
                            1529,
                            7733
                        ],
                        [
                            1577,
                            7695
                        ],
                        [
                            1635,
                            7671
                        ],
                        [
                            1659,
                            7707
                        ],
                        [
                            1684,
                            7716
                        ],
                        [
                            1715,
                            7767
                        ],
                        [
                            1792,
                            7832
                        ],
                        [
                            1823,
                            7873
                        ],
                        [
                            1861,
                            7885
                        ],
                        [
                            1870,
                            7863
                        ],
                        [
                            1893,
                            7897
                        ],
                        [
                            1931,
                            7917
                        ],
                        [
                            1945,
                            7973
                        ],
                        [
                            1961,
                            7963
                        ],
                        [
                            1986,
                            7993
                        ],
                        [
                            2051,
                            8007
                        ],
                        [
                            2075,
                            8101
                        ],
                        [
                            2092,
                            8126
                        ],
                        [
                            2158,
                            8095
                        ],
                        [
                            2173,
                            8100
                        ],
                        [
                            2288,
                            8228
                        ],
                        [
                            2313,
                            8231
                        ],
                        [
                            2289,
                            8177
                        ],
                        [
                            2280,
                            8140
                        ],
                        [
                            2258,
                            8061
                        ],
                        [
                            2278,
                            7947
                        ],
                        [
                            2261,
                            7879
                        ],
                        [
                            2269,
                            7834
                        ],
                        [
                            2290,
                            7847
                        ],
                        [
                            2330,
                            7770
                        ],
                        [
                            2345,
                            7715
                        ],
                        [
                            2300,
                            7673
                        ],
                        [
                            2242,
                            7670
                        ],
                        [
                            2240,
                            7637
                        ],
                        [
                            2263,
                            7607
                        ],
                        [
                            2264,
                            7574
                        ],
                        [
                            2236,
                            7541
                        ],
                        [
                            2212,
                            7485
                        ],
                        [
                            2235,
                            7448
                        ],
                        [
                            2313,
                            7418
                        ],
                        [
                            2355,
                            7353
                        ],
                        [
                            2277,
                            7301
                        ],
                        [
                            2303,
                            7257
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.NK",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.76,
                "hc-middle-y": 0.44,
                "hc-key": "th-nk",
                "hc-a2": "NK",
                "labelrank": "7",
                "hasc": "TH.NK",
                "alt-name": null,
                "woe-id": "2347144",
                "subregion": null,
                "fips": "TH17",
                "postal-code": "NK",
                "name": "Nong Khai",
                "name-TH": "หนองคาย",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "102.754",
                "woe-name": "Nong Khai",
                "latitude": "17.7553",
                "woe-label": "Nong Khai, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2280,
                            8140
                        ],
                        [
                            2289,
                            8177
                        ],
                        [
                            2313,
                            8231
                        ],
                        [
                            2358,
                            8223
                        ],
                        [
                            2373,
                            8188
                        ],
                        [
                            2455,
                            8116
                        ],
                        [
                            2497,
                            8107
                        ],
                        [
                            2530,
                            8075
                        ],
                        [
                            2579,
                            8059
                        ],
                        [
                            2639,
                            8060
                        ],
                        [
                            2671,
                            8020
                        ],
                        [
                            2661,
                            7971
                        ],
                        [
                            2723,
                            7943
                        ],
                        [
                            2711,
                            7972
                        ],
                        [
                            2840,
                            8065
                        ],
                        [
                            2899,
                            8093
                        ],
                        [
                            2970,
                            8081
                        ],
                        [
                            2994,
                            8115
                        ],
                        [
                            2987,
                            8157
                        ],
                        [
                            2997,
                            8188
                        ],
                        [
                            3037,
                            8212
                        ],
                        [
                            3045,
                            8252
                        ],
                        [
                            3069,
                            8280
                        ],
                        [
                            3130,
                            8295
                        ],
                        [
                            3146,
                            8309
                        ],
                        [
                            3150,
                            8265
                        ],
                        [
                            3192,
                            8254
                        ],
                        [
                            3201,
                            8232
                        ],
                        [
                            3162,
                            8179
                        ],
                        [
                            3168,
                            8149
                        ],
                        [
                            3249,
                            8087
                        ],
                        [
                            3211,
                            8078
                        ],
                        [
                            3227,
                            8045
                        ],
                        [
                            3226,
                            7996
                        ],
                        [
                            3170,
                            7971
                        ],
                        [
                            3131,
                            8003
                        ],
                        [
                            3098,
                            7990
                        ],
                        [
                            3062,
                            7945
                        ],
                        [
                            2984,
                            8005
                        ],
                        [
                            2937,
                            7957
                        ],
                        [
                            2909,
                            7996
                        ],
                        [
                            2864,
                            8001
                        ],
                        [
                            2840,
                            7946
                        ],
                        [
                            2850,
                            7884
                        ],
                        [
                            2763,
                            7790
                        ],
                        [
                            2709,
                            7787
                        ],
                        [
                            2675,
                            7802
                        ],
                        [
                            2673,
                            7854
                        ],
                        [
                            2623,
                            7898
                        ],
                        [
                            2576,
                            7900
                        ],
                        [
                            2529,
                            7965
                        ],
                        [
                            2515,
                            8001
                        ],
                        [
                            2444,
                            8059
                        ],
                        [
                            2384,
                            8090
                        ],
                        [
                            2347,
                            8072
                        ],
                        [
                            2320,
                            8119
                        ],
                        [
                            2280,
                            8140
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.AC",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.45,
                "hc-middle-y": 0.61,
                "hc-key": "th-ac",
                "hc-a2": "AC",
                "labelrank": "7",
                "hasc": "TH.AC",
                "alt-name": null,
                "woe-id": "2347201",
                "subregion": null,
                "fips": "TH77",
                "postal-code": "AC",
                "name": "Amnat Charoen",
                "name-TH": "อำนาจเจริญ",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "104.766",
                "woe-name": "Amnat Charoen",
                "latitude": "15.8583",
                "woe-label": "Amnat Charoen, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            4258,
                            6789
                        ],
                        [
                            4304,
                            6803
                        ],
                        [
                            4381,
                            6869
                        ],
                        [
                            4409,
                            6843
                        ],
                        [
                            4423,
                            6758
                        ],
                        [
                            4470,
                            6725
                        ],
                        [
                            4459,
                            6695
                        ],
                        [
                            4420,
                            6653
                        ],
                        [
                            4438,
                            6583
                        ],
                        [
                            4412,
                            6554
                        ],
                        [
                            4415,
                            6509
                        ],
                        [
                            4390,
                            6460
                        ],
                        [
                            4360,
                            6367
                        ],
                        [
                            4360,
                            6291
                        ],
                        [
                            4341,
                            6263
                        ],
                        [
                            4305,
                            6288
                        ],
                        [
                            4280,
                            6282
                        ],
                        [
                            4254,
                            6327
                        ],
                        [
                            4208,
                            6336
                        ],
                        [
                            4178,
                            6373
                        ],
                        [
                            4148,
                            6368
                        ],
                        [
                            4161,
                            6348
                        ],
                        [
                            4117,
                            6319
                        ],
                        [
                            4056,
                            6336
                        ],
                        [
                            4005,
                            6375
                        ],
                        [
                            3991,
                            6436
                        ],
                        [
                            4017,
                            6578
                        ],
                        [
                            4041,
                            6610
                        ],
                        [
                            4083,
                            6701
                        ],
                        [
                            4120,
                            6734
                        ],
                        [
                            4255,
                            6767
                        ],
                        [
                            4258,
                            6789
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.MD",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.50,
                "hc-middle-y": 0.48,
                "hc-key": "th-md",
                "hc-a2": "MD",
                "labelrank": "7",
                "hasc": "TH.MD",
                "alt-name": null,
                "woe-id": "2347197",
                "subregion": null,
                "fips": "TH78",
                "postal-code": "MD",
                "name": "Mukdahan",
                "name-TH": "มุกดาหาร",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "104.531",
                "woe-name": "Mukdahan",
                "latitude": "16.5636",
                "woe-label": "Mukdahan, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            4381,
                            6869
                        ],
                        [
                            4304,
                            6803
                        ],
                        [
                            4258,
                            6789
                        ],
                        [
                            4187,
                            6804
                        ],
                        [
                            4155,
                            6820
                        ],
                        [
                            4129,
                            6804
                        ],
                        [
                            4096,
                            6830
                        ],
                        [
                            4076,
                            6870
                        ],
                        [
                            4031,
                            6894
                        ],
                        [
                            3964,
                            6895
                        ],
                        [
                            3931,
                            6878
                        ],
                        [
                            3914,
                            6882
                        ],
                        [
                            3897,
                            6973
                        ],
                        [
                            3849,
                            6956
                        ],
                        [
                            3843,
                            7026
                        ],
                        [
                            3804,
                            7087
                        ],
                        [
                            3802,
                            7127
                        ],
                        [
                            3720,
                            7247
                        ],
                        [
                            3740,
                            7251
                        ],
                        [
                            3768,
                            7294
                        ],
                        [
                            3837,
                            7297
                        ],
                        [
                            3883,
                            7267
                        ],
                        [
                            3910,
                            7279
                        ],
                        [
                            3952,
                            7268
                        ],
                        [
                            4019,
                            7268
                        ],
                        [
                            4052,
                            7243
                        ],
                        [
                            4091,
                            7258
                        ],
                        [
                            4151,
                            7251
                        ],
                        [
                            4155,
                            7214
                        ],
                        [
                            4199,
                            7204
                        ],
                        [
                            4190,
                            7239
                        ],
                        [
                            4206,
                            7251
                        ],
                        [
                            4223,
                            7175
                        ],
                        [
                            4207,
                            7100
                        ],
                        [
                            4210,
                            7037
                        ],
                        [
                            4293,
                            6973
                        ],
                        [
                            4322,
                            6911
                        ],
                        [
                            4381,
                            6869
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SN",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.37,
                "hc-middle-y": 0.44,
                "hc-key": "th-sn",
                "hc-a2": "SN",
                "labelrank": "7",
                "hasc": "TH.SN",
                "alt-name": null,
                "woe-id": "2347146",
                "subregion": null,
                "fips": "TH20",
                "postal-code": "SN",
                "name": "Sakon Nakhon",
                "name-TH": "สกลนคร",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "103.845",
                "woe-name": "Sakon Nakhon",
                "latitude": "17.3577",
                "woe-label": "Sakon Nakhon, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            3837,
                            7297
                        ],
                        [
                            3768,
                            7294
                        ],
                        [
                            3740,
                            7251
                        ],
                        [
                            3720,
                            7247
                        ],
                        [
                            3688,
                            7262
                        ],
                        [
                            3639,
                            7232
                        ],
                        [
                            3625,
                            7206
                        ],
                        [
                            3559,
                            7251
                        ],
                        [
                            3513,
                            7301
                        ],
                        [
                            3515,
                            7330
                        ],
                        [
                            3417,
                            7395
                        ],
                        [
                            3417,
                            7441
                        ],
                        [
                            3373,
                            7480
                        ],
                        [
                            3347,
                            7483
                        ],
                        [
                            3290,
                            7520
                        ],
                        [
                            3235,
                            7520
                        ],
                        [
                            3193,
                            7542
                        ],
                        [
                            3145,
                            7553
                        ],
                        [
                            3128,
                            7588
                        ],
                        [
                            3158,
                            7639
                        ],
                        [
                            3142,
                            7676
                        ],
                        [
                            3149,
                            7707
                        ],
                        [
                            3190,
                            7786
                        ],
                        [
                            3228,
                            7797
                        ],
                        [
                            3227,
                            7909
                        ],
                        [
                            3205,
                            7936
                        ],
                        [
                            3226,
                            7996
                        ],
                        [
                            3227,
                            8045
                        ],
                        [
                            3211,
                            8078
                        ],
                        [
                            3249,
                            8087
                        ],
                        [
                            3278,
                            8127
                        ],
                        [
                            3322,
                            8142
                        ],
                        [
                            3389,
                            8106
                        ],
                        [
                            3381,
                            8077
                        ],
                        [
                            3468,
                            8037
                        ],
                        [
                            3478,
                            8060
                        ],
                        [
                            3506,
                            8001
                        ],
                        [
                            3577,
                            8011
                        ],
                        [
                            3594,
                            7965
                        ],
                        [
                            3629,
                            7934
                        ],
                        [
                            3657,
                            7958
                        ],
                        [
                            3667,
                            7926
                        ],
                        [
                            3698,
                            7905
                        ],
                        [
                            3706,
                            7867
                        ],
                        [
                            3675,
                            7833
                        ],
                        [
                            3688,
                            7805
                        ],
                        [
                            3663,
                            7714
                        ],
                        [
                            3700,
                            7654
                        ],
                        [
                            3748,
                            7653
                        ],
                        [
                            3771,
                            7675
                        ],
                        [
                            3820,
                            7672
                        ],
                        [
                            3886,
                            7686
                        ],
                        [
                            3949,
                            7687
                        ],
                        [
                            3953,
                            7640
                        ],
                        [
                            3975,
                            7561
                        ],
                        [
                            3948,
                            7507
                        ],
                        [
                            3944,
                            7465
                        ],
                        [
                            3920,
                            7437
                        ],
                        [
                            3944,
                            7404
                        ],
                        [
                            3895,
                            7358
                        ],
                        [
                            3881,
                            7327
                        ],
                        [
                            3837,
                            7297
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.NW",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.46,
                "hc-middle-y": 0.52,
                "hc-key": "th-nw",
                "hc-a2": "NW",
                "labelrank": "7",
                "hasc": "TH.NW",
                "alt-name": null,
                "woe-id": "2347156",
                "subregion": null,
                "fips": "TH31",
                "postal-code": "NW",
                "name": "Narathiwat",
                "name-TH": "นราธิวาส",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "101.727",
                "woe-name": "Narathiwat",
                "latitude": "6.17758",
                "woe-label": "Narathiwat, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2041,
                            -325
                        ],
                        [
                            2034,
                            -276
                        ],
                        [
                            2070,
                            -271
                        ],
                        [
                            2105,
                            -311
                        ],
                        [
                            2131,
                            -310
                        ],
                        [
                            2193,
                            -390
                        ],
                        [
                            2267,
                            -436
                        ],
                        [
                            2349,
                            -513
                        ],
                        [
                            2389,
                            -541
                        ],
                        [
                            2388,
                            -637
                        ],
                        [
                            2380,
                            -661
                        ],
                        [
                            2306,
                            -722
                        ],
                        [
                            2277,
                            -774
                        ],
                        [
                            2273,
                            -834
                        ],
                        [
                            2209,
                            -892
                        ],
                        [
                            2190,
                            -922
                        ],
                        [
                            2146,
                            -891
                        ],
                        [
                            2107,
                            -907
                        ],
                        [
                            2080,
                            -891
                        ],
                        [
                            2068,
                            -838
                        ],
                        [
                            2027,
                            -801
                        ],
                        [
                            1969,
                            -811
                        ],
                        [
                            1958,
                            -744
                        ],
                        [
                            1960,
                            -699
                        ],
                        [
                            1882,
                            -588
                        ],
                        [
                            1897,
                            -567
                        ],
                        [
                            1920,
                            -430
                        ],
                        [
                            1994,
                            -407
                        ],
                        [
                            2050,
                            -341
                        ],
                        [
                            2041,
                            -325
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PI",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.57,
                "hc-middle-y": 0.21,
                "hc-key": "th-pi",
                "hc-a2": "PI",
                "labelrank": "7",
                "hasc": "TH.PI",
                "alt-name": null,
                "woe-id": "2347193",
                "subregion": null,
                "fips": "TH69",
                "postal-code": "PI",
                "name": "Pattani",
                "name-TH": "ปัตตานี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "101.381",
                "woe-name": "Pattani",
                "latitude": "6.7391",
                "woe-label": "Pattani, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2131,
                            -310
                        ],
                        [
                            2105,
                            -311
                        ],
                        [
                            2070,
                            -271
                        ],
                        [
                            2034,
                            -276
                        ],
                        [
                            2041,
                            -325
                        ],
                        [
                            2009,
                            -332
                        ],
                        [
                            1973,
                            -295
                        ],
                        [
                            1939,
                            -314
                        ],
                        [
                            1854,
                            -329
                        ],
                        [
                            1823,
                            -293
                        ],
                        [
                            1820,
                            -241
                        ],
                        [
                            1772,
                            -291
                        ],
                        [
                            1716,
                            -293
                        ],
                        [
                            1674,
                            -266
                        ],
                        [
                            1646,
                            -254
                        ],
                        [
                            1628,
                            -196
                        ],
                        [
                            1630,
                            -148
                        ],
                        [
                            1649,
                            -105
                        ],
                        [
                            1740,
                            -101
                        ],
                        [
                            1778,
                            -72
                        ],
                        [
                            1857,
                            -90
                        ],
                        [
                            1840,
                            -60
                        ],
                        [
                            1791,
                            -40
                        ],
                        [
                            1834,
                            -37
                        ],
                        [
                            1881,
                            -69
                        ],
                        [
                            1945,
                            -84
                        ],
                        [
                            2014,
                            -122
                        ],
                        [
                            2131,
                            -310
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.RN",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.11,
                "hc-middle-y": 0.84,
                "hc-key": "th-rn",
                "hc-a2": "RN",
                "labelrank": "7",
                "hasc": "TH.RN",
                "alt-name": null,
                "woe-id": "2347183",
                "subregion": null,
                "fips": "TH59",
                "postal-code": "RN",
                "name": "Ranong",
                "name-TH": "ระนอง",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "98.58",
                "woe-name": "Ranong",
                "latitude": "9.51717",
                "woe-label": "Ranong, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -221,
                            1686
                        ],
                        [
                            -280,
                            1723
                        ],
                        [
                            -309,
                            1714
                        ],
                        [
                            -283,
                            1779
                        ],
                        [
                            -260,
                            1864
                        ],
                        [
                            -238,
                            1849
                        ],
                        [
                            -206,
                            1876
                        ],
                        [
                            -255,
                            1904
                        ],
                        [
                            -218,
                            1941
                        ],
                        [
                            -228,
                            1989
                        ],
                        [
                            -197,
                            1979
                        ],
                        [
                            -181,
                            2006
                        ],
                        [
                            -223,
                            2029
                        ],
                        [
                            -180,
                            2055
                        ],
                        [
                            -219,
                            2075
                        ],
                        [
                            -176,
                            2132
                        ],
                        [
                            -132,
                            2167
                        ],
                        [
                            -153,
                            2189
                        ],
                        [
                            -110,
                            2257
                        ],
                        [
                            -68,
                            2361
                        ],
                        [
                            -61,
                            2408
                        ],
                        [
                            -16,
                            2575
                        ],
                        [
                            -27,
                            2621
                        ],
                        [
                            -48,
                            2651
                        ],
                        [
                            -34,
                            2699
                        ],
                        [
                            12,
                            2753
                        ],
                        [
                            47,
                            2772
                        ],
                        [
                            80,
                            2738
                        ],
                        [
                            68,
                            2698
                        ],
                        [
                            93,
                            2682
                        ],
                        [
                            116,
                            2630
                        ],
                        [
                            111,
                            2587
                        ],
                        [
                            71,
                            2548
                        ],
                        [
                            65,
                            2505
                        ],
                        [
                            95,
                            2472
                        ],
                        [
                            99,
                            2444
                        ],
                        [
                            72,
                            2404
                        ],
                        [
                            60,
                            2332
                        ],
                        [
                            90,
                            2286
                        ],
                        [
                            65,
                            2207
                        ],
                        [
                            29,
                            2189
                        ],
                        [
                            6,
                            2156
                        ],
                        [
                            -30,
                            2150
                        ],
                        [
                            -68,
                            2090
                        ],
                        [
                            -126,
                            2037
                        ],
                        [
                            -129,
                            2014
                        ],
                        [
                            -108,
                            1942
                        ],
                        [
                            -47,
                            1902
                        ],
                        [
                            -29,
                            1862
                        ],
                        [
                            -115,
                            1771
                        ],
                        [
                            -103,
                            1723
                        ],
                        [
                            -203,
                            1713
                        ],
                        [
                            -221,
                            1686
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.NT",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.75,
                "hc-key": "th-nt",
                "hc-a2": "NT",
                "labelrank": "7",
                "hasc": "TH.NT",
                "alt-name": "Nakhon Thammarat|Nagara Sridharmaraj|Nakhon Sri Thammarat|Nakhornsrithamrat|Nakornsrithamaraj",
                "woe-id": "2347188",
                "subregion": null,
                "fips": "TH64",
                "postal-code": "NT",
                "name": "Nakhon Si Thammarat",
                "name-TH": "นครศรีธรรมราช",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "99.78189999999999",
                "woe-name": "Nakhon Si Thammarat",
                "latitude": "8.37448",
                "woe-label": "Nakhon Si Thammarat, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            382,
                            687
                        ],
                        [
                            387,
                            725
                        ],
                        [
                            344,
                            804
                        ],
                        [
                            366,
                            876
                        ],
                        [
                            365,
                            943
                        ],
                        [
                            329,
                            979
                        ],
                        [
                            312,
                            1020
                        ],
                        [
                            345,
                            1085
                        ],
                        [
                            342,
                            1126
                        ],
                        [
                            374,
                            1110
                        ],
                        [
                            432,
                            1142
                        ],
                        [
                            461,
                            1169
                        ],
                        [
                            464,
                            1198
                        ],
                        [
                            491,
                            1218
                        ],
                        [
                            516,
                            1264
                        ],
                        [
                            519,
                            1346
                        ],
                        [
                            561,
                            1396
                        ],
                        [
                            635,
                            1409
                        ],
                        [
                            664,
                            1442
                        ],
                        [
                            679,
                            1500
                        ],
                        [
                            708,
                            1506
                        ],
                        [
                            704,
                            1546
                        ],
                        [
                            667,
                            1574
                        ],
                        [
                            684,
                            1628
                        ],
                        [
                            682,
                            1669
                        ],
                        [
                            697,
                            1691
                        ],
                        [
                            719,
                            1698
                        ],
                        [
                            756,
                            1678
                        ],
                        [
                            780,
                            1578
                        ],
                        [
                            802,
                            1537
                        ],
                        [
                            814,
                            1463
                        ],
                        [
                            805,
                            1448
                        ],
                        [
                            834,
                            1197
                        ],
                        [
                            852,
                            1154
                        ],
                        [
                            894,
                            1129
                        ],
                        [
                            940,
                            1036
                        ],
                        [
                            979,
                            1013
                        ],
                        [
                            1000,
                            1021
                        ],
                        [
                            984,
                            1097
                        ],
                        [
                            1025,
                            1059
                        ],
                        [
                            1063,
                            963
                        ],
                        [
                            1086,
                            817
                        ],
                        [
                            1115,
                            685
                        ],
                        [
                            1069,
                            676
                        ],
                        [
                            979,
                            638
                        ],
                        [
                            960,
                            585
                        ],
                        [
                            898,
                            601
                        ],
                        [
                            872,
                            641
                        ],
                        [
                            836,
                            659
                        ],
                        [
                            727,
                            643
                        ],
                        [
                            679,
                            620
                        ],
                        [
                            669,
                            651
                        ],
                        [
                            681,
                            713
                        ],
                        [
                            663,
                            723
                        ],
                        [
                            578,
                            714
                        ],
                        [
                            529,
                            640
                        ],
                        [
                            428,
                            648
                        ],
                        [
                            382,
                            687
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SG",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.68,
                "hc-key": "th-sg",
                "hc-a2": "SG",
                "labelrank": "7",
                "hasc": "TH.SG",
                "alt-name": null,
                "woe-id": "2347192",
                "subregion": null,
                "fips": "TH68",
                "postal-code": "SG",
                "name": "Songkhla",
                "name-TH": "สงขลา",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "100.568",
                "woe-name": "Songkhla",
                "latitude": "6.81212",
                "woe-label": "Songkhla, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                901,
                                43
                            ],
                            [
                                889,
                                64
                            ],
                            [
                                911,
                                90
                            ],
                            [
                                980,
                                129
                            ],
                            [
                                1071,
                                148
                            ],
                            [
                                1118,
                                184
                            ],
                            [
                                1143,
                                225
                            ],
                            [
                                1148,
                                193
                            ],
                            [
                                1179,
                                178
                            ],
                            [
                                1154,
                                161
                            ],
                            [
                                1177,
                                123
                            ],
                            [
                                1222,
                                100
                            ],
                            [
                                1273,
                                104
                            ],
                            [
                                1297,
                                130
                            ],
                            [
                                1295,
                                163
                            ],
                            [
                                1427,
                                -14
                            ],
                            [
                                1473,
                                -37
                            ],
                            [
                                1489,
                                -29
                            ],
                            [
                                1561,
                                -88
                            ],
                            [
                                1598,
                                -106
                            ],
                            [
                                1649,
                                -105
                            ],
                            [
                                1630,
                                -148
                            ],
                            [
                                1628,
                                -196
                            ],
                            [
                                1646,
                                -254
                            ],
                            [
                                1674,
                                -266
                            ],
                            [
                                1676,
                                -305
                            ],
                            [
                                1622,
                                -384
                            ],
                            [
                                1546,
                                -416
                            ],
                            [
                                1543,
                                -485
                            ],
                            [
                                1515,
                                -513
                            ],
                            [
                                1472,
                                -515
                            ],
                            [
                                1458,
                                -430
                            ],
                            [
                                1412,
                                -404
                            ],
                            [
                                1390,
                                -373
                            ],
                            [
                                1343,
                                -407
                            ],
                            [
                                1247,
                                -382
                            ],
                            [
                                1210,
                                -359
                            ],
                            [
                                1151,
                                -353
                            ],
                            [
                                1100,
                                -313
                            ],
                            [
                                1073,
                                -230
                            ],
                            [
                                1013,
                                -223
                            ],
                            [
                                1010,
                                -155
                            ],
                            [
                                1023,
                                -87
                            ],
                            [
                                955,
                                -53
                            ],
                            [
                                919,
                                -4
                            ],
                            [
                                901,
                                43
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                1012,
                                563
                            ],
                            [
                                984,
                                581
                            ],
                            [
                                960,
                                585
                            ],
                            [
                                979,
                                638
                            ],
                            [
                                1069,
                                676
                            ],
                            [
                                1115,
                                685
                            ],
                            [
                                1188,
                                347
                            ],
                            [
                                1232,
                                243
                            ],
                            [
                                1281,
                                166
                            ],
                            [
                                1268,
                                142
                            ],
                            [
                                1212,
                                188
                            ],
                            [
                                1178,
                                194
                            ],
                            [
                                1187,
                                213
                            ],
                            [
                                1165,
                                275
                            ],
                            [
                                1163,
                                384
                            ],
                            [
                                1151,
                                413
                            ],
                            [
                                1104,
                                419
                            ],
                            [
                                1078,
                                377
                            ],
                            [
                                1067,
                                420
                            ],
                            [
                                1102,
                                449
                            ],
                            [
                                1090,
                                553
                            ],
                            [
                                1063,
                                580
                            ],
                            [
                                1012,
                                563
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PR",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.66,
                "hc-middle-y": 0.52,
                "hc-key": "th-pr",
                "hc-a2": "PR",
                "labelrank": "7",
                "hasc": "TH.PR",
                "alt-name": null,
                "woe-id": "2347134",
                "subregion": null,
                "fips": "TH07",
                "postal-code": "PR",
                "name": "Phrae",
                "name-TH": "แพร่",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northern",
                "longitude": "99.9263",
                "woe-name": "Phrae",
                "latitude": "18.0577",
                "woe-label": "Phrae, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            918,
                            8655
                        ],
                        [
                            951,
                            8668
                        ],
                        [
                            1079,
                            8658
                        ],
                        [
                            1109,
                            8594
                        ],
                        [
                            1093,
                            8573
                        ],
                        [
                            1098,
                            8532
                        ],
                        [
                            1117,
                            8527
                        ],
                        [
                            1104,
                            8486
                        ],
                        [
                            1120,
                            8425
                        ],
                        [
                            1177,
                            8423
                        ],
                        [
                            1205,
                            8410
                        ],
                        [
                            1214,
                            8375
                        ],
                        [
                            1185,
                            8315
                        ],
                        [
                            1188,
                            8264
                        ],
                        [
                            1150,
                            8171
                        ],
                        [
                            1120,
                            8157
                        ],
                        [
                            1132,
                            8073
                        ],
                        [
                            1092,
                            8041
                        ],
                        [
                            1073,
                            7984
                        ],
                        [
                            1039,
                            8030
                        ],
                        [
                            993,
                            8005
                        ],
                        [
                            928,
                            7955
                        ],
                        [
                            835,
                            7933
                        ],
                        [
                            803,
                            7899
                        ],
                        [
                            764,
                            7915
                        ],
                        [
                            686,
                            7900
                        ],
                        [
                            655,
                            7855
                        ],
                        [
                            600,
                            7909
                        ],
                        [
                            556,
                            7924
                        ],
                        [
                            521,
                            7916
                        ],
                        [
                            467,
                            7859
                        ],
                        [
                            402,
                            7821
                        ],
                        [
                            381,
                            7825
                        ],
                        [
                            356,
                            7861
                        ],
                        [
                            356,
                            7888
                        ],
                        [
                            398,
                            7895
                        ],
                        [
                            497,
                            8015
                        ],
                        [
                            564,
                            8084
                        ],
                        [
                            589,
                            8075
                        ],
                        [
                            642,
                            8110
                        ],
                        [
                            705,
                            8219
                        ],
                        [
                            742,
                            8260
                        ],
                        [
                            775,
                            8274
                        ],
                        [
                            812,
                            8339
                        ],
                        [
                            837,
                            8356
                        ],
                        [
                            875,
                            8429
                        ],
                        [
                            880,
                            8465
                        ],
                        [
                            914,
                            8474
                        ],
                        [
                            921,
                            8502
                        ],
                        [
                            909,
                            8595
                        ],
                        [
                            918,
                            8655
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PY",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.56,
                "hc-middle-y": 0.57,
                "hc-key": "th-py",
                "hc-a2": "PY",
                "labelrank": "7",
                "hasc": "TH.PY",
                "alt-name": null,
                "woe-id": "2347166",
                "subregion": null,
                "fips": "TH41",
                "postal-code": "PY",
                "name": "Phayao",
                "name-TH": "พะเยา",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northern",
                "longitude": "100.16",
                "woe-name": "Phayao",
                "latitude": "19.1866",
                "woe-label": "Phayao, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1079,
                            8658
                        ],
                        [
                            951,
                            8668
                        ],
                        [
                            918,
                            8655
                        ],
                        [
                            884,
                            8664
                        ],
                        [
                            865,
                            8713
                        ],
                        [
                            808,
                            8748
                        ],
                        [
                            784,
                            8781
                        ],
                        [
                            723,
                            8792
                        ],
                        [
                            708,
                            8829
                        ],
                        [
                            686,
                            8835
                        ],
                        [
                            629,
                            8959
                        ],
                        [
                            629,
                            9025
                        ],
                        [
                            613,
                            9106
                        ],
                        [
                            654,
                            9126
                        ],
                        [
                            767,
                            9146
                        ],
                        [
                            769,
                            9084
                        ],
                        [
                            793,
                            9074
                        ],
                        [
                            833,
                            9106
                        ],
                        [
                            887,
                            9108
                        ],
                        [
                            922,
                            9138
                        ],
                        [
                            959,
                            9244
                        ],
                        [
                            1013,
                            9260
                        ],
                        [
                            1069,
                            9290
                        ],
                        [
                            1100,
                            9325
                        ],
                        [
                            1121,
                            9259
                        ],
                        [
                            1146,
                            9223
                        ],
                        [
                            1151,
                            9188
                        ],
                        [
                            1212,
                            9158
                        ],
                        [
                            1230,
                            9168
                        ],
                        [
                            1225,
                            9135
                        ],
                        [
                            1187,
                            9080
                        ],
                        [
                            1204,
                            9047
                        ],
                        [
                            1230,
                            9050
                        ],
                        [
                            1255,
                            9027
                        ],
                        [
                            1246,
                            8979
                        ],
                        [
                            1273,
                            8895
                        ],
                        [
                            1225,
                            8861
                        ],
                        [
                            1231,
                            8821
                        ],
                        [
                            1166,
                            8832
                        ],
                        [
                            1155,
                            8791
                        ],
                        [
                            1181,
                            8784
                        ],
                        [
                            1163,
                            8757
                        ],
                        [
                            1125,
                            8747
                        ],
                        [
                            1079,
                            8658
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SO",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.34,
                "hc-middle-y": 0.70,
                "hc-key": "th-so",
                "hc-a2": "SO",
                "labelrank": "7",
                "hasc": "TH.SO",
                "alt-name": "Sawankhalokt|Sukhotai|Sukothai|Svargalok",
                "woe-id": "2347136",
                "subregion": null,
                "fips": "TH09",
                "postal-code": "SO",
                "name": "Sukhothai",
                "name-TH": "สุโขทัย",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "99.7009",
                "woe-name": "Sukhothai",
                "latitude": "17.2435",
                "woe-label": "Sukhothai, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            764,
                            7915
                        ],
                        [
                            816,
                            7842
                        ],
                        [
                            816,
                            7778
                        ],
                        [
                            788,
                            7750
                        ],
                        [
                            803,
                            7723
                        ],
                        [
                            852,
                            7673
                        ],
                        [
                            863,
                            7643
                        ],
                        [
                            839,
                            7627
                        ],
                        [
                            849,
                            7557
                        ],
                        [
                            819,
                            7513
                        ],
                        [
                            827,
                            7447
                        ],
                        [
                            783,
                            7446
                        ],
                        [
                            789,
                            7415
                        ],
                        [
                            848,
                            7357
                        ],
                        [
                            901,
                            7326
                        ],
                        [
                            933,
                            7294
                        ],
                        [
                            924,
                            7250
                        ],
                        [
                            864,
                            7246
                        ],
                        [
                            856,
                            7221
                        ],
                        [
                            809,
                            7227
                        ],
                        [
                            762,
                            7134
                        ],
                        [
                            793,
                            7123
                        ],
                        [
                            774,
                            7097
                        ],
                        [
                            742,
                            7129
                        ],
                        [
                            624,
                            7128
                        ],
                        [
                            527,
                            7189
                        ],
                        [
                            508,
                            7233
                        ],
                        [
                            484,
                            7239
                        ],
                        [
                            408,
                            7226
                        ],
                        [
                            379,
                            7242
                        ],
                        [
                            334,
                            7271
                        ],
                        [
                            325,
                            7297
                        ],
                        [
                            332,
                            7368
                        ],
                        [
                            360,
                            7404
                        ],
                        [
                            358,
                            7515
                        ],
                        [
                            380,
                            7510
                        ],
                        [
                            410,
                            7474
                        ],
                        [
                            445,
                            7491
                        ],
                        [
                            471,
                            7586
                        ],
                        [
                            439,
                            7612
                        ],
                        [
                            444,
                            7640
                        ],
                        [
                            426,
                            7664
                        ],
                        [
                            442,
                            7708
                        ],
                        [
                            430,
                            7739
                        ],
                        [
                            453,
                            7765
                        ],
                        [
                            469,
                            7818
                        ],
                        [
                            467,
                            7859
                        ],
                        [
                            521,
                            7916
                        ],
                        [
                            556,
                            7924
                        ],
                        [
                            600,
                            7909
                        ],
                        [
                            655,
                            7855
                        ],
                        [
                            686,
                            7900
                        ],
                        [
                            764,
                            7915
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.UD",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.43,
                "hc-middle-y": 0.59,
                "hc-key": "th-ud",
                "hc-a2": "UD",
                "labelrank": "7",
                "hasc": "TH.UD",
                "alt-name": null,
                "woe-id": "2347137",
                "subregion": null,
                "fips": "TH10",
                "postal-code": "UD",
                "name": "Uttaradit",
                "name-TH": "อุตรดิตถ์",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northern",
                "longitude": "100.531",
                "woe-name": "Uttaradit",
                "latitude": "17.7188",
                "woe-label": "Uttaradit, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            827,
                            7447
                        ],
                        [
                            819,
                            7513
                        ],
                        [
                            849,
                            7557
                        ],
                        [
                            839,
                            7627
                        ],
                        [
                            863,
                            7643
                        ],
                        [
                            852,
                            7673
                        ],
                        [
                            803,
                            7723
                        ],
                        [
                            788,
                            7750
                        ],
                        [
                            816,
                            7778
                        ],
                        [
                            816,
                            7842
                        ],
                        [
                            764,
                            7915
                        ],
                        [
                            803,
                            7899
                        ],
                        [
                            835,
                            7933
                        ],
                        [
                            928,
                            7955
                        ],
                        [
                            993,
                            8005
                        ],
                        [
                            1039,
                            8030
                        ],
                        [
                            1073,
                            7984
                        ],
                        [
                            1092,
                            8041
                        ],
                        [
                            1132,
                            8073
                        ],
                        [
                            1198,
                            8075
                        ],
                        [
                            1238,
                            8098
                        ],
                        [
                            1370,
                            8082
                        ],
                        [
                            1425,
                            8125
                        ],
                        [
                            1480,
                            8247
                        ],
                        [
                            1587,
                            8338
                        ],
                        [
                            1644,
                            8303
                        ],
                        [
                            1626,
                            8246
                        ],
                        [
                            1648,
                            8216
                        ],
                        [
                            1636,
                            8157
                        ],
                        [
                            1654,
                            8105
                        ],
                        [
                            1617,
                            8074
                        ],
                        [
                            1585,
                            8017
                        ],
                        [
                            1545,
                            7988
                        ],
                        [
                            1536,
                            7931
                        ],
                        [
                            1515,
                            7916
                        ],
                        [
                            1509,
                            7850
                        ],
                        [
                            1478,
                            7835
                        ],
                        [
                            1454,
                            7849
                        ],
                        [
                            1424,
                            7804
                        ],
                        [
                            1385,
                            7773
                        ],
                        [
                            1345,
                            7718
                        ],
                        [
                            1267,
                            7665
                        ],
                        [
                            1252,
                            7640
                        ],
                        [
                            1191,
                            7623
                        ],
                        [
                            1147,
                            7632
                        ],
                        [
                            1046,
                            7596
                        ],
                        [
                            1013,
                            7549
                        ],
                        [
                            1023,
                            7511
                        ],
                        [
                            984,
                            7471
                        ],
                        [
                            946,
                            7472
                        ],
                        [
                            864,
                            7446
                        ],
                        [
                            827,
                            7447
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.KN",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.65,
                "hc-middle-y": 0.65,
                "hc-key": "th-kn",
                "hc-a2": "KN",
                "labelrank": "7",
                "hasc": "TH.KN",
                "alt-name": "Kan Buri|Park Prag",
                "woe-id": "2347174",
                "subregion": null,
                "fips": "TH50",
                "postal-code": "KN",
                "name": "Kanchanaburi",
                "name-TH": "กาญจนบุรี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Western",
                "longitude": "99.29689999999999",
                "woe-name": "Kanchanaburi",
                "latitude": "14.3317",
                "woe-label": "Kanchanaburi, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            240,
                            4923
                        ],
                        [
                            213,
                            4951
                        ],
                        [
                            201,
                            5025
                        ],
                        [
                            146,
                            5080
                        ],
                        [
                            101,
                            5146
                        ],
                        [
                            96,
                            5176
                        ],
                        [
                            44,
                            5208
                        ],
                        [
                            -41,
                            5272
                        ],
                        [
                            -75,
                            5323
                        ],
                        [
                            -101,
                            5322
                        ],
                        [
                            -156,
                            5361
                        ],
                        [
                            -188,
                            5402
                        ],
                        [
                            -238,
                            5504
                        ],
                        [
                            -256,
                            5513
                        ],
                        [
                            -280,
                            5571
                        ],
                        [
                            -366,
                            5654
                        ],
                        [
                            -405,
                            5716
                        ],
                        [
                            -420,
                            5801
                        ],
                        [
                            -439,
                            5843
                        ],
                        [
                            -436,
                            5897
                        ],
                        [
                            -460,
                            5951
                        ],
                        [
                            -441,
                            5990
                        ],
                        [
                            -451,
                            6021
                        ],
                        [
                            -424,
                            6019
                        ],
                        [
                            -375,
                            6071
                        ],
                        [
                            -298,
                            6048
                        ],
                        [
                            -308,
                            6076
                        ],
                        [
                            -294,
                            6119
                        ],
                        [
                            -239,
                            6139
                        ],
                        [
                            -197,
                            6097
                        ],
                        [
                            -178,
                            6119
                        ],
                        [
                            -173,
                            6190
                        ],
                        [
                            -189,
                            6299
                        ],
                        [
                            -189,
                            6353
                        ],
                        [
                            -104,
                            6311
                        ],
                        [
                            -57,
                            6236
                        ],
                        [
                            46,
                            6087
                        ],
                        [
                            57,
                            6063
                        ],
                        [
                            121,
                            6020
                        ],
                        [
                            136,
                            5915
                        ],
                        [
                            192,
                            5867
                        ],
                        [
                            231,
                            5874
                        ],
                        [
                            312,
                            5853
                        ],
                        [
                            334,
                            5858
                        ],
                        [
                            355,
                            5782
                        ],
                        [
                            337,
                            5762
                        ],
                        [
                            408,
                            5687
                        ],
                        [
                            447,
                            5686
                        ],
                        [
                            462,
                            5632
                        ],
                        [
                            512,
                            5659
                        ],
                        [
                            523,
                            5709
                        ],
                        [
                            618,
                            5708
                        ],
                        [
                            697,
                            5621
                        ],
                        [
                            754,
                            5594
                        ],
                        [
                            740,
                            5575
                        ],
                        [
                            769,
                            5542
                        ],
                        [
                            724,
                            5506
                        ],
                        [
                            720,
                            5373
                        ],
                        [
                            724,
                            5318
                        ],
                        [
                            714,
                            5280
                        ],
                        [
                            683,
                            5251
                        ],
                        [
                            687,
                            5201
                        ],
                        [
                            715,
                            5171
                        ],
                        [
                            713,
                            5152
                        ],
                        [
                            765,
                            5086
                        ],
                        [
                            706,
                            4991
                        ],
                        [
                            628,
                            4996
                        ],
                        [
                            548,
                            4970
                        ],
                        [
                            527,
                            4949
                        ],
                        [
                            478,
                            4976
                        ],
                        [
                            389,
                            4944
                        ],
                        [
                            312,
                            4953
                        ],
                        [
                            281,
                            4928
                        ],
                        [
                            240,
                            4923
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.TK",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.68,
                "hc-middle-y": 0.29,
                "hc-key": "th-tk",
                "hc-a2": "TK",
                "labelrank": "7",
                "hasc": "TH.TK",
                "alt-name": null,
                "woe-id": "2347135",
                "subregion": null,
                "fips": "TH08",
                "postal-code": "TK",
                "name": "Tak",
                "name-TH": "ตาก",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Western",
                "longitude": "98.8441",
                "woe-name": "Tak",
                "latitude": "17.0043",
                "woe-label": "Tak, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -189,
                            6353
                        ],
                        [
                            -190,
                            6397
                        ],
                        [
                            -167,
                            6471
                        ],
                        [
                            -171,
                            6533
                        ],
                        [
                            -160,
                            6574
                        ],
                        [
                            -180,
                            6632
                        ],
                        [
                            -141,
                            6626
                        ],
                        [
                            -107,
                            6676
                        ],
                        [
                            -80,
                            6684
                        ],
                        [
                            -19,
                            6666
                        ],
                        [
                            18,
                            6697
                        ],
                        [
                            24,
                            6744
                        ],
                        [
                            52,
                            6781
                        ],
                        [
                            66,
                            6857
                        ],
                        [
                            54,
                            6889
                        ],
                        [
                            1,
                            6913
                        ],
                        [
                            -15,
                            6866
                        ],
                        [
                            -90,
                            6792
                        ],
                        [
                            -108,
                            6812
                        ],
                        [
                            -128,
                            6894
                        ],
                        [
                            -126,
                            6931
                        ],
                        [
                            -173,
                            6996
                        ],
                        [
                            -185,
                            7046
                        ],
                        [
                            -210,
                            7063
                        ],
                        [
                            -249,
                            7122
                        ],
                        [
                            -236,
                            7161
                        ],
                        [
                            -204,
                            7188
                        ],
                        [
                            -211,
                            7246
                        ],
                        [
                            -263,
                            7333
                        ],
                        [
                            -288,
                            7354
                        ],
                        [
                            -349,
                            7363
                        ],
                        [
                            -381,
                            7404
                        ],
                        [
                            -373,
                            7425
                        ],
                        [
                            -414,
                            7472
                        ],
                        [
                            -499,
                            7547
                        ],
                        [
                            -507,
                            7599
                        ],
                        [
                            -544,
                            7623
                        ],
                        [
                            -581,
                            7696
                        ],
                        [
                            -633,
                            7733
                        ],
                        [
                            -592,
                            7744
                        ],
                        [
                            -494,
                            7794
                        ],
                        [
                            -426,
                            7799
                        ],
                        [
                            -393,
                            7827
                        ],
                        [
                            -355,
                            7835
                        ],
                        [
                            -387,
                            7789
                        ],
                        [
                            -386,
                            7750
                        ],
                        [
                            -352,
                            7739
                        ],
                        [
                            -342,
                            7708
                        ],
                        [
                            -347,
                            7613
                        ],
                        [
                            -332,
                            7546
                        ],
                        [
                            -277,
                            7508
                        ],
                        [
                            -173,
                            7536
                        ],
                        [
                            -167,
                            7577
                        ],
                        [
                            -182,
                            7591
                        ],
                        [
                            -170,
                            7634
                        ],
                        [
                            -194,
                            7668
                        ],
                        [
                            -174,
                            7734
                        ],
                        [
                            -138,
                            7745
                        ],
                        [
                            -128,
                            7768
                        ],
                        [
                            -138,
                            7812
                        ],
                        [
                            -101,
                            7864
                        ],
                        [
                            -69,
                            7878
                        ],
                        [
                            -44,
                            7826
                        ],
                        [
                            -72,
                            7811
                        ],
                        [
                            -76,
                            7771
                        ],
                        [
                            -61,
                            7680
                        ],
                        [
                            -25,
                            7679
                        ],
                        [
                            40,
                            7714
                        ],
                        [
                            60,
                            7777
                        ],
                        [
                            87,
                            7796
                        ],
                        [
                            143,
                            7772
                        ],
                        [
                            158,
                            7693
                        ],
                        [
                            144,
                            7634
                        ],
                        [
                            167,
                            7604
                        ],
                        [
                            256,
                            7569
                        ],
                        [
                            289,
                            7614
                        ],
                        [
                            325,
                            7612
                        ],
                        [
                            333,
                            7557
                        ],
                        [
                            358,
                            7515
                        ],
                        [
                            360,
                            7404
                        ],
                        [
                            332,
                            7368
                        ],
                        [
                            325,
                            7297
                        ],
                        [
                            334,
                            7271
                        ],
                        [
                            379,
                            7242
                        ],
                        [
                            365,
                            7188
                        ],
                        [
                            348,
                            7170
                        ],
                        [
                            344,
                            7121
                        ],
                        [
                            311,
                            7070
                        ],
                        [
                            316,
                            7013
                        ],
                        [
                            304,
                            6988
                        ],
                        [
                            260,
                            6976
                        ],
                        [
                            215,
                            6940
                        ],
                        [
                            139,
                            6943
                        ],
                        [
                            126,
                            6929
                        ],
                        [
                            143,
                            6886
                        ],
                        [
                            133,
                            6798
                        ],
                        [
                            151,
                            6738
                        ],
                        [
                            142,
                            6680
                        ],
                        [
                            153,
                            6613
                        ],
                        [
                            184,
                            6589
                        ],
                        [
                            191,
                            6495
                        ],
                        [
                            195,
                            6467
                        ],
                        [
                            221,
                            6422
                        ],
                        [
                            223,
                            6384
                        ],
                        [
                            208,
                            6317
                        ],
                        [
                            167,
                            6264
                        ],
                        [
                            182,
                            6213
                        ],
                        [
                            175,
                            6149
                        ],
                        [
                            146,
                            6053
                        ],
                        [
                            121,
                            6020
                        ],
                        [
                            57,
                            6063
                        ],
                        [
                            46,
                            6087
                        ],
                        [
                            -57,
                            6236
                        ],
                        [
                            -104,
                            6311
                        ],
                        [
                            -189,
                            6353
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.UT",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.51,
                "hc-middle-y": 0.54,
                "hc-key": "th-ut",
                "hc-a2": "UT",
                "labelrank": "7",
                "hasc": "TH.UT",
                "alt-name": null,
                "woe-id": "2347142",
                "subregion": null,
                "fips": "TH15",
                "postal-code": "UT",
                "name": "Uthai Thani",
                "name-TH": "อุทัยธานี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "99.5275",
                "woe-name": "Uthai Thani",
                "latitude": "15.27",
                "woe-label": "Uthai Thani, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            221,
                            6422
                        ],
                        [
                            250,
                            6425
                        ],
                        [
                            307,
                            6383
                        ],
                        [
                            395,
                            6337
                        ],
                        [
                            408,
                            6312
                        ],
                        [
                            468,
                            6272
                        ],
                        [
                            498,
                            6269
                        ],
                        [
                            605,
                            6346
                        ],
                        [
                            651,
                            6357
                        ],
                        [
                            685,
                            6327
                        ],
                        [
                            740,
                            6325
                        ],
                        [
                            754,
                            6274
                        ],
                        [
                            784,
                            6238
                        ],
                        [
                            826,
                            6231
                        ],
                        [
                            879,
                            6187
                        ],
                        [
                            887,
                            6167
                        ],
                        [
                            871,
                            6140
                        ],
                        [
                            897,
                            6092
                        ],
                        [
                            882,
                            6054
                        ],
                        [
                            846,
                            6075
                        ],
                        [
                            772,
                            6068
                        ],
                        [
                            676,
                            6091
                        ],
                        [
                            646,
                            6057
                        ],
                        [
                            672,
                            5979
                        ],
                        [
                            711,
                            5924
                        ],
                        [
                            697,
                            5894
                        ],
                        [
                            659,
                            5869
                        ],
                        [
                            652,
                            5830
                        ],
                        [
                            603,
                            5853
                        ],
                        [
                            587,
                            5820
                        ],
                        [
                            433,
                            5859
                        ],
                        [
                            425,
                            5883
                        ],
                        [
                            365,
                            5911
                        ],
                        [
                            334,
                            5858
                        ],
                        [
                            312,
                            5853
                        ],
                        [
                            231,
                            5874
                        ],
                        [
                            192,
                            5867
                        ],
                        [
                            136,
                            5915
                        ],
                        [
                            121,
                            6020
                        ],
                        [
                            146,
                            6053
                        ],
                        [
                            175,
                            6149
                        ],
                        [
                            182,
                            6213
                        ],
                        [
                            167,
                            6264
                        ],
                        [
                            208,
                            6317
                        ],
                        [
                            223,
                            6384
                        ],
                        [
                            221,
                            6422
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.NS",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.66,
                "hc-middle-y": 0.51,
                "hc-key": "th-ns",
                "hc-a2": "NS",
                "labelrank": "7",
                "hasc": "TH.NS",
                "alt-name": null,
                "woe-id": "2347143",
                "subregion": null,
                "fips": "TH16",
                "postal-code": "NS",
                "name": "Nakhon Sawan",
                "name-TH": "นครสวรรค์",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Central",
                "longitude": "100.25",
                "woe-name": "Nakhon Sawan",
                "latitude": "15.6943",
                "woe-label": "Nakhon Sawan, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            887,
                            6167
                        ],
                        [
                            879,
                            6187
                        ],
                        [
                            826,
                            6231
                        ],
                        [
                            784,
                            6238
                        ],
                        [
                            754,
                            6274
                        ],
                        [
                            740,
                            6325
                        ],
                        [
                            685,
                            6327
                        ],
                        [
                            651,
                            6357
                        ],
                        [
                            605,
                            6346
                        ],
                        [
                            498,
                            6269
                        ],
                        [
                            468,
                            6272
                        ],
                        [
                            408,
                            6312
                        ],
                        [
                            395,
                            6337
                        ],
                        [
                            307,
                            6383
                        ],
                        [
                            250,
                            6425
                        ],
                        [
                            221,
                            6422
                        ],
                        [
                            195,
                            6467
                        ],
                        [
                            191,
                            6495
                        ],
                        [
                            250,
                            6538
                        ],
                        [
                            290,
                            6541
                        ],
                        [
                            335,
                            6510
                        ],
                        [
                            389,
                            6529
                        ],
                        [
                            459,
                            6514
                        ],
                        [
                            517,
                            6530
                        ],
                        [
                            570,
                            6504
                        ],
                        [
                            607,
                            6434
                        ],
                        [
                            653,
                            6466
                        ],
                        [
                            678,
                            6538
                        ],
                        [
                            722,
                            6608
                        ],
                        [
                            765,
                            6645
                        ],
                        [
                            796,
                            6737
                        ],
                        [
                            803,
                            6796
                        ],
                        [
                            839,
                            6840
                        ],
                        [
                            860,
                            6815
                        ],
                        [
                            872,
                            6728
                        ],
                        [
                            908,
                            6697
                        ],
                        [
                            942,
                            6603
                        ],
                        [
                            965,
                            6560
                        ],
                        [
                            1000,
                            6538
                        ],
                        [
                            1055,
                            6530
                        ],
                        [
                            1057,
                            6550
                        ],
                        [
                            1136,
                            6539
                        ],
                        [
                            1203,
                            6540
                        ],
                        [
                            1272,
                            6560
                        ],
                        [
                            1380,
                            6545
                        ],
                        [
                            1411,
                            6496
                        ],
                        [
                            1409,
                            6452
                        ],
                        [
                            1435,
                            6362
                        ],
                        [
                            1437,
                            6322
                        ],
                        [
                            1411,
                            6270
                        ],
                        [
                            1371,
                            6228
                        ],
                        [
                            1364,
                            6169
                        ],
                        [
                            1244,
                            6054
                        ],
                        [
                            1221,
                            6003
                        ],
                        [
                            1200,
                            5990
                        ],
                        [
                            1186,
                            5938
                        ],
                        [
                            1163,
                            5906
                        ],
                        [
                            1107,
                            5930
                        ],
                        [
                            1089,
                            5978
                        ],
                        [
                            1067,
                            5984
                        ],
                        [
                            1033,
                            6072
                        ],
                        [
                            992,
                            6123
                        ],
                        [
                            930,
                            6169
                        ],
                        [
                            887,
                            6167
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PK",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.66,
                "hc-middle-y": 0.19,
                "hc-key": "th-pk",
                "hc-a2": "PK",
                "labelrank": "7",
                "hasc": "TH.PK",
                "alt-name": "Korh Luxk|Prachuab Girikhand|Prachuapkirikhan|Prachut Khirikhan",
                "woe-id": "2347181",
                "subregion": null,
                "fips": "TH57",
                "postal-code": "PK",
                "name": "Prachuap Khiri Khan",
                "name-TH": "ประจวบคีรีขันธ์",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Western",
                "longitude": "99.7274",
                "woe-name": "Prachuap Khiri Khan",
                "latitude": "12.3053",
                "woe-label": "Prachuap Khiri Khan, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            237,
                            2956
                        ],
                        [
                            289,
                            3006
                        ],
                        [
                            311,
                            3072
                        ],
                        [
                            363,
                            3162
                        ],
                        [
                            398,
                            3203
                        ],
                        [
                            408,
                            3246
                        ],
                        [
                            444,
                            3291
                        ],
                        [
                            453,
                            3365
                        ],
                        [
                            472,
                            3384
                        ],
                        [
                            518,
                            3389
                        ],
                        [
                            573,
                            3459
                        ],
                        [
                            590,
                            3525
                        ],
                        [
                            549,
                            3556
                        ],
                        [
                            535,
                            3583
                        ],
                        [
                            549,
                            3643
                        ],
                        [
                            509,
                            3679
                        ],
                        [
                            528,
                            3756
                        ],
                        [
                            471,
                            3752
                        ],
                        [
                            464,
                            3848
                        ],
                        [
                            446,
                            3877
                        ],
                        [
                            438,
                            3941
                        ],
                        [
                            414,
                            4001
                        ],
                        [
                            426,
                            4075
                        ],
                        [
                            477,
                            4089
                        ],
                        [
                            546,
                            4080
                        ],
                        [
                            585,
                            4060
                        ],
                        [
                            620,
                            4082
                        ],
                        [
                            683,
                            4087
                        ],
                        [
                            729,
                            4120
                        ],
                        [
                            826,
                            4127
                        ],
                        [
                            841,
                            4057
                        ],
                        [
                            841,
                            3994
                        ],
                        [
                            863,
                            3942
                        ],
                        [
                            842,
                            3866
                        ],
                        [
                            870,
                            3802
                        ],
                        [
                            847,
                            3773
                        ],
                        [
                            824,
                            3714
                        ],
                        [
                            752,
                            3637
                        ],
                        [
                            721,
                            3537
                        ],
                        [
                            725,
                            3471
                        ],
                        [
                            678,
                            3448
                        ],
                        [
                            599,
                            3311
                        ],
                        [
                            587,
                            3250
                        ],
                        [
                            547,
                            3172
                        ],
                        [
                            544,
                            3130
                        ],
                        [
                            559,
                            3084
                        ],
                        [
                            508,
                            3054
                        ],
                        [
                            492,
                            3011
                        ],
                        [
                            505,
                            2969
                        ],
                        [
                            499,
                            2925
                        ],
                        [
                            433,
                            2895
                        ],
                        [
                            327,
                            2896
                        ],
                        [
                            246,
                            2930
                        ],
                        [
                            237,
                            2956
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.UR",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.60,
                "hc-middle-y": 0.58,
                "hc-key": "th-ur",
                "hc-a2": "UR",
                "labelrank": "7",
                "hasc": "TH.UR",
                "alt-name": null,
                "woe-id": "2347199",
                "subregion": null,
                "fips": "TH75",
                "postal-code": "UR",
                "name": "Ubon Ratchathani",
                "name-TH": "อุบลราชธานี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "105.016",
                "woe-name": "Ubon Ratchathani",
                "latitude": "15.0137",
                "woe-label": "Ubon Ratchathani, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            4470,
                            6725
                        ],
                        [
                            4563,
                            6695
                        ],
                        [
                            4684,
                            6675
                        ],
                        [
                            4694,
                            6658
                        ],
                        [
                            4655,
                            6627
                        ],
                        [
                            4654,
                            6601
                        ],
                        [
                            4694,
                            6514
                        ],
                        [
                            4720,
                            6489
                        ],
                        [
                            4775,
                            6490
                        ],
                        [
                            4839,
                            6461
                        ],
                        [
                            4868,
                            6397
                        ],
                        [
                            4828,
                            6241
                        ],
                        [
                            4756,
                            6202
                        ],
                        [
                            4755,
                            6172
                        ],
                        [
                            4809,
                            6167
                        ],
                        [
                            4814,
                            6129
                        ],
                        [
                            4772,
                            6097
                        ],
                        [
                            4738,
                            6055
                        ],
                        [
                            4738,
                            5995
                        ],
                        [
                            4785,
                            5976
                        ],
                        [
                            4812,
                            5931
                        ],
                        [
                            4841,
                            5921
                        ],
                        [
                            4800,
                            5878
                        ],
                        [
                            4813,
                            5855
                        ],
                        [
                            4790,
                            5836
                        ],
                        [
                            4792,
                            5804
                        ],
                        [
                            4771,
                            5769
                        ],
                        [
                            4784,
                            5732
                        ],
                        [
                            4778,
                            5676
                        ],
                        [
                            4790,
                            5627
                        ],
                        [
                            4781,
                            5585
                        ],
                        [
                            4726,
                            5503
                        ],
                        [
                            4669,
                            5470
                        ],
                        [
                            4635,
                            5475
                        ],
                        [
                            4621,
                            5453
                        ],
                        [
                            4541,
                            5426
                        ],
                        [
                            4504,
                            5351
                        ],
                        [
                            4465,
                            5338
                        ],
                        [
                            4436,
                            5359
                        ],
                        [
                            4413,
                            5401
                        ],
                        [
                            4409,
                            5460
                        ],
                        [
                            4367,
                            5468
                        ],
                        [
                            4347,
                            5503
                        ],
                        [
                            4325,
                            5502
                        ],
                        [
                            4327,
                            5559
                        ],
                        [
                            4305,
                            5589
                        ],
                        [
                            4327,
                            5659
                        ],
                        [
                            4362,
                            5660
                        ],
                        [
                            4324,
                            5707
                        ],
                        [
                            4289,
                            5774
                        ],
                        [
                            4296,
                            5811
                        ],
                        [
                            4267,
                            5846
                        ],
                        [
                            4215,
                            5862
                        ],
                        [
                            4198,
                            5889
                        ],
                        [
                            4191,
                            5984
                        ],
                        [
                            4224,
                            6037
                        ],
                        [
                            4185,
                            6091
                        ],
                        [
                            4126,
                            6096
                        ],
                        [
                            4114,
                            6086
                        ],
                        [
                            4026,
                            6099
                        ],
                        [
                            3995,
                            6115
                        ],
                        [
                            4008,
                            6163
                        ],
                        [
                            3973,
                            6197
                        ],
                        [
                            3966,
                            6224
                        ],
                        [
                            3980,
                            6294
                        ],
                        [
                            4043,
                            6300
                        ],
                        [
                            4056,
                            6336
                        ],
                        [
                            4117,
                            6319
                        ],
                        [
                            4161,
                            6348
                        ],
                        [
                            4148,
                            6368
                        ],
                        [
                            4178,
                            6373
                        ],
                        [
                            4208,
                            6336
                        ],
                        [
                            4254,
                            6327
                        ],
                        [
                            4280,
                            6282
                        ],
                        [
                            4305,
                            6288
                        ],
                        [
                            4341,
                            6263
                        ],
                        [
                            4360,
                            6291
                        ],
                        [
                            4360,
                            6367
                        ],
                        [
                            4390,
                            6460
                        ],
                        [
                            4415,
                            6509
                        ],
                        [
                            4412,
                            6554
                        ],
                        [
                            4438,
                            6583
                        ],
                        [
                            4420,
                            6653
                        ],
                        [
                            4459,
                            6695
                        ],
                        [
                            4470,
                            6725
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SK",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.37,
                "hc-middle-y": 0.37,
                "hc-key": "th-sk",
                "hc-a2": "SK",
                "labelrank": "7",
                "hasc": "TH.SK",
                "alt-name": "Srakaeo",
                "woe-id": "20069925",
                "subregion": null,
                "fips": "TH80",
                "postal-code": "SK",
                "name": "Sa Kaeo",
                "name-TH": "สระแก้ว",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Eastern",
                "longitude": "102.384",
                "woe-name": "Sa Kaeo",
                "latitude": "13.8589",
                "woe-label": null,
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2936,
                            5269
                        ],
                        [
                            2910,
                            5200
                        ],
                        [
                            2906,
                            5163
                        ],
                        [
                            2837,
                            5100
                        ],
                        [
                            2786,
                            4971
                        ],
                        [
                            2698,
                            4920
                        ],
                        [
                            2674,
                            4886
                        ],
                        [
                            2715,
                            4855
                        ],
                        [
                            2655,
                            4826
                        ],
                        [
                            2525,
                            4822
                        ],
                        [
                            2526,
                            4608
                        ],
                        [
                            2484,
                            4556
                        ],
                        [
                            2452,
                            4556
                        ],
                        [
                            2412,
                            4585
                        ],
                        [
                            2381,
                            4545
                        ],
                        [
                            2318,
                            4524
                        ],
                        [
                            2314,
                            4592
                        ],
                        [
                            2285,
                            4652
                        ],
                        [
                            2248,
                            4758
                        ],
                        [
                            2278,
                            4767
                        ],
                        [
                            2272,
                            4837
                        ],
                        [
                            2238,
                            4832
                        ],
                        [
                            2204,
                            4898
                        ],
                        [
                            2196,
                            4934
                        ],
                        [
                            2216,
                            4958
                        ],
                        [
                            2217,
                            4998
                        ],
                        [
                            2180,
                            5027
                        ],
                        [
                            2190,
                            5088
                        ],
                        [
                            2219,
                            5112
                        ],
                        [
                            2216,
                            5153
                        ],
                        [
                            2275,
                            5188
                        ],
                        [
                            2314,
                            5235
                        ],
                        [
                            2319,
                            5275
                        ],
                        [
                            2343,
                            5255
                        ],
                        [
                            2400,
                            5241
                        ],
                        [
                            2425,
                            5276
                        ],
                        [
                            2453,
                            5243
                        ],
                        [
                            2498,
                            5236
                        ],
                        [
                            2540,
                            5257
                        ],
                        [
                            2636,
                            5248
                        ],
                        [
                            2641,
                            5216
                        ],
                        [
                            2675,
                            5212
                        ],
                        [
                            2668,
                            5232
                        ],
                        [
                            2707,
                            5254
                        ],
                        [
                            2793,
                            5243
                        ],
                        [
                            2868,
                            5268
                        ],
                        [
                            2936,
                            5269
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.RY",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.55,
                "hc-key": "th-ry",
                "hc-a2": "RY",
                "labelrank": "7",
                "hasc": "TH.RY",
                "alt-name": null,
                "woe-id": "2347171",
                "subregion": null,
                "fips": "TH47",
                "postal-code": "RY",
                "name": "Rayong",
                "name-TH": "ระยอง",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Eastern",
                "longitude": "101.402",
                "woe-name": "Rayong",
                "latitude": "12.8125",
                "woe-label": "Rayong, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2142,
                            4182
                        ],
                        [
                            2068,
                            4184
                        ],
                        [
                            2037,
                            4146
                        ],
                        [
                            1993,
                            4147
                        ],
                        [
                            1986,
                            4132
                        ],
                        [
                            1941,
                            4136
                        ],
                        [
                            1893,
                            4125
                        ],
                        [
                            1883,
                            4105
                        ],
                        [
                            1807,
                            4137
                        ],
                        [
                            1753,
                            4150
                        ],
                        [
                            1637,
                            4164
                        ],
                        [
                            1559,
                            4133
                        ],
                        [
                            1555,
                            4156
                        ],
                        [
                            1575,
                            4246
                        ],
                        [
                            1608,
                            4274
                        ],
                        [
                            1640,
                            4328
                        ],
                        [
                            1634,
                            4415
                        ],
                        [
                            1687,
                            4412
                        ],
                        [
                            1700,
                            4454
                        ],
                        [
                            1774,
                            4435
                        ],
                        [
                            1818,
                            4446
                        ],
                        [
                            1849,
                            4416
                        ],
                        [
                            1909,
                            4426
                        ],
                        [
                            1930,
                            4451
                        ],
                        [
                            1958,
                            4449
                        ],
                        [
                            1988,
                            4491
                        ],
                        [
                            2029,
                            4513
                        ],
                        [
                            2069,
                            4501
                        ],
                        [
                            2085,
                            4428
                        ],
                        [
                            2112,
                            4403
                        ],
                        [
                            2112,
                            4365
                        ],
                        [
                            2134,
                            4366
                        ],
                        [
                            2166,
                            4325
                        ],
                        [
                            2163,
                            4230
                        ],
                        [
                            2142,
                            4182
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.CY",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.45,
                "hc-key": "th-cy",
                "hc-a2": "CY",
                "labelrank": "7",
                "hasc": "TH.CY",
                "alt-name": null,
                "woe-id": "2347151",
                "subregion": null,
                "fips": "TH26",
                "postal-code": "CY",
                "name": "Chaiyaphum",
                "name-TH": "ชัยภูมิ",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "101.877",
                "woe-name": "Chaiyaphum",
                "latitude": "16.0138",
                "woe-label": "Chaiyaphum, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1772,
                            6088
                        ],
                        [
                            1821,
                            6165
                        ],
                        [
                            1816,
                            6276
                        ],
                        [
                            1836,
                            6380
                        ],
                        [
                            1789,
                            6419
                        ],
                        [
                            1786,
                            6492
                        ],
                        [
                            1808,
                            6514
                        ],
                        [
                            1826,
                            6566
                        ],
                        [
                            1795,
                            6587
                        ],
                        [
                            1782,
                            6656
                        ],
                        [
                            1809,
                            6779
                        ],
                        [
                            1819,
                            6863
                        ],
                        [
                            1835,
                            6899
                        ],
                        [
                            1880,
                            6955
                        ],
                        [
                            1878,
                            6979
                        ],
                        [
                            1911,
                            7004
                        ],
                        [
                            1902,
                            7053
                        ],
                        [
                            1909,
                            7097
                        ],
                        [
                            1942,
                            7095
                        ],
                        [
                            1971,
                            7119
                        ],
                        [
                            1996,
                            7104
                        ],
                        [
                            2038,
                            7105
                        ],
                        [
                            2061,
                            7084
                        ],
                        [
                            2080,
                            7096
                        ],
                        [
                            2103,
                            7076
                        ],
                        [
                            2151,
                            7087
                        ],
                        [
                            2225,
                            7070
                        ],
                        [
                            2242,
                            7036
                        ],
                        [
                            2315,
                            6976
                        ],
                        [
                            2409,
                            6977
                        ],
                        [
                            2441,
                            6955
                        ],
                        [
                            2519,
                            6932
                        ],
                        [
                            2549,
                            6943
                        ],
                        [
                            2579,
                            6910
                        ],
                        [
                            2548,
                            6789
                        ],
                        [
                            2495,
                            6705
                        ],
                        [
                            2451,
                            6663
                        ],
                        [
                            2461,
                            6645
                        ],
                        [
                            2541,
                            6599
                        ],
                        [
                            2502,
                            6510
                        ],
                        [
                            2500,
                            6467
                        ],
                        [
                            2436,
                            6427
                        ],
                        [
                            2390,
                            6421
                        ],
                        [
                            2370,
                            6375
                        ],
                        [
                            2327,
                            6328
                        ],
                        [
                            2295,
                            6356
                        ],
                        [
                            2270,
                            6308
                        ],
                        [
                            2233,
                            6264
                        ],
                        [
                            2239,
                            6217
                        ],
                        [
                            2198,
                            6187
                        ],
                        [
                            2187,
                            6154
                        ],
                        [
                            2148,
                            6156
                        ],
                        [
                            2017,
                            6099
                        ],
                        [
                            1961,
                            6055
                        ],
                        [
                            1848,
                            6024
                        ],
                        [
                            1826,
                            6058
                        ],
                        [
                            1772,
                            6088
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.SU",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.57,
                "hc-middle-y": 0.62,
                "hc-key": "th-su",
                "hc-a2": "SU",
                "labelrank": "7",
                "hasc": "TH.SU",
                "alt-name": null,
                "woe-id": "2347154",
                "subregion": null,
                "fips": "TH29",
                "postal-code": "SU",
                "name": "Surin",
                "name-TH": "สุรินทร์",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "103.588",
                "woe-name": "Surin",
                "latitude": "14.9355",
                "woe-label": "Surin, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            3744,
                            5426
                        ],
                        [
                            3712,
                            5417
                        ],
                        [
                            3693,
                            5433
                        ],
                        [
                            3619,
                            5413
                        ],
                        [
                            3585,
                            5431
                        ],
                        [
                            3483,
                            5440
                        ],
                        [
                            3475,
                            5474
                        ],
                        [
                            3443,
                            5479
                        ],
                        [
                            3421,
                            5454
                        ],
                        [
                            3388,
                            5466
                        ],
                        [
                            3322,
                            5430
                        ],
                        [
                            3297,
                            5437
                        ],
                        [
                            3239,
                            5411
                        ],
                        [
                            3169,
                            5404
                        ],
                        [
                            3177,
                            5486
                        ],
                        [
                            3158,
                            5544
                        ],
                        [
                            3158,
                            5592
                        ],
                        [
                            3187,
                            5651
                        ],
                        [
                            3195,
                            5719
                        ],
                        [
                            3272,
                            5793
                        ],
                        [
                            3305,
                            5844
                        ],
                        [
                            3309,
                            5935
                        ],
                        [
                            3301,
                            6027
                        ],
                        [
                            3339,
                            6111
                        ],
                        [
                            3316,
                            6135
                        ],
                        [
                            3288,
                            6126
                        ],
                        [
                            3243,
                            6148
                        ],
                        [
                            3192,
                            6117
                        ],
                        [
                            3166,
                            6116
                        ],
                        [
                            3118,
                            6159
                        ],
                        [
                            3101,
                            6155
                        ],
                        [
                            3086,
                            6195
                        ],
                        [
                            3052,
                            6207
                        ],
                        [
                            3062,
                            6240
                        ],
                        [
                            3145,
                            6217
                        ],
                        [
                            3226,
                            6184
                        ],
                        [
                            3278,
                            6204
                        ],
                        [
                            3302,
                            6217
                        ],
                        [
                            3355,
                            6211
                        ],
                        [
                            3401,
                            6234
                        ],
                        [
                            3437,
                            6223
                        ],
                        [
                            3541,
                            6217
                        ],
                        [
                            3618,
                            6242
                        ],
                        [
                            3622,
                            6227
                        ],
                        [
                            3677,
                            6213
                        ],
                        [
                            3684,
                            6200
                        ],
                        [
                            3738,
                            6195
                        ],
                        [
                            3746,
                            6151
                        ],
                        [
                            3694,
                            6097
                        ],
                        [
                            3678,
                            6026
                        ],
                        [
                            3713,
                            5927
                        ],
                        [
                            3654,
                            5823
                        ],
                        [
                            3653,
                            5774
                        ],
                        [
                            3698,
                            5758
                        ],
                        [
                            3710,
                            5704
                        ],
                        [
                            3748,
                            5652
                        ],
                        [
                            3741,
                            5570
                        ],
                        [
                            3754,
                            5498
                        ],
                        [
                            3744,
                            5426
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.NF",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.40,
                "hc-middle-y": 0.31,
                "hc-key": "th-nf",
                "hc-a2": "NF",
                "labelrank": "7",
                "hasc": "TH.NF",
                "alt-name": null,
                "woe-id": "2347196",
                "subregion": null,
                "fips": "TH73",
                "postal-code": "NF",
                "name": "Nakhon Phanom",
                "name-TH": "นครพนม",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "104.628",
                "woe-name": "Nakhon Phanom",
                "latitude": "17.2227",
                "woe-label": "Nakhon Phanom, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            3789,
                            8122
                        ],
                        [
                            3851,
                            8005
                        ],
                        [
                            3898,
                            7979
                        ],
                        [
                            3950,
                            7892
                        ],
                        [
                            3993,
                            7849
                        ],
                        [
                            4104,
                            7795
                        ],
                        [
                            4160,
                            7762
                        ],
                        [
                            4235,
                            7660
                        ],
                        [
                            4239,
                            7562
                        ],
                        [
                            4235,
                            7511
                        ],
                        [
                            4192,
                            7402
                        ],
                        [
                            4206,
                            7251
                        ],
                        [
                            4190,
                            7239
                        ],
                        [
                            4199,
                            7204
                        ],
                        [
                            4155,
                            7214
                        ],
                        [
                            4151,
                            7251
                        ],
                        [
                            4091,
                            7258
                        ],
                        [
                            4052,
                            7243
                        ],
                        [
                            4019,
                            7268
                        ],
                        [
                            3952,
                            7268
                        ],
                        [
                            3910,
                            7279
                        ],
                        [
                            3883,
                            7267
                        ],
                        [
                            3837,
                            7297
                        ],
                        [
                            3881,
                            7327
                        ],
                        [
                            3895,
                            7358
                        ],
                        [
                            3944,
                            7404
                        ],
                        [
                            3920,
                            7437
                        ],
                        [
                            3944,
                            7465
                        ],
                        [
                            3948,
                            7507
                        ],
                        [
                            3975,
                            7561
                        ],
                        [
                            3953,
                            7640
                        ],
                        [
                            3949,
                            7687
                        ],
                        [
                            3886,
                            7686
                        ],
                        [
                            3820,
                            7672
                        ],
                        [
                            3771,
                            7675
                        ],
                        [
                            3748,
                            7653
                        ],
                        [
                            3700,
                            7654
                        ],
                        [
                            3663,
                            7714
                        ],
                        [
                            3688,
                            7805
                        ],
                        [
                            3675,
                            7833
                        ],
                        [
                            3706,
                            7867
                        ],
                        [
                            3698,
                            7905
                        ],
                        [
                            3667,
                            7926
                        ],
                        [
                            3657,
                            7958
                        ],
                        [
                            3642,
                            8002
                        ],
                        [
                            3652,
                            8048
                        ],
                        [
                            3678,
                            8057
                        ],
                        [
                            3698,
                            8018
                        ],
                        [
                            3727,
                            8008
                        ],
                        [
                            3742,
                            8041
                        ],
                        [
                            3737,
                            8108
                        ],
                        [
                            3789,
                            8122
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.BK",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.62,
                "hc-middle-y": 0.50,
                "hc-key": "th-bk",
                "hc-a2": "BK",
                "labelrank": "7",
                "hasc": "TH.BK",
                "alt-name": "??????",
                "woe-id": "-2347144",
                "subregion": null,
                "fips": "TH81",
                "postal-code": "BK",
                "name": "Bueng Kan",
                "name-TH": "บึงกาฬ",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "103.752",
                "woe-name": null,
                "latitude": "18.1565",
                "woe-label": null,
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            3146,
                            8309
                        ],
                        [
                            3106,
                            8338
                        ],
                        [
                            3119,
                            8386
                        ],
                        [
                            3151,
                            8405
                        ],
                        [
                            3207,
                            8418
                        ],
                        [
                            3362,
                            8392
                        ],
                        [
                            3435,
                            8356
                        ],
                        [
                            3476,
                            8355
                        ],
                        [
                            3560,
                            8313
                        ],
                        [
                            3605,
                            8348
                        ],
                        [
                            3640,
                            8339
                        ],
                        [
                            3690,
                            8264
                        ],
                        [
                            3722,
                            8191
                        ],
                        [
                            3789,
                            8122
                        ],
                        [
                            3737,
                            8108
                        ],
                        [
                            3742,
                            8041
                        ],
                        [
                            3727,
                            8008
                        ],
                        [
                            3698,
                            8018
                        ],
                        [
                            3678,
                            8057
                        ],
                        [
                            3652,
                            8048
                        ],
                        [
                            3642,
                            8002
                        ],
                        [
                            3657,
                            7958
                        ],
                        [
                            3629,
                            7934
                        ],
                        [
                            3594,
                            7965
                        ],
                        [
                            3577,
                            8011
                        ],
                        [
                            3506,
                            8001
                        ],
                        [
                            3478,
                            8060
                        ],
                        [
                            3468,
                            8037
                        ],
                        [
                            3381,
                            8077
                        ],
                        [
                            3389,
                            8106
                        ],
                        [
                            3322,
                            8142
                        ],
                        [
                            3278,
                            8127
                        ],
                        [
                            3249,
                            8087
                        ],
                        [
                            3168,
                            8149
                        ],
                        [
                            3162,
                            8179
                        ],
                        [
                            3201,
                            8232
                        ],
                        [
                            3192,
                            8254
                        ],
                        [
                            3150,
                            8265
                        ],
                        [
                            3146,
                            8309
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.MH",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.55,
                "hc-middle-y": 0.23,
                "hc-key": "th-mh",
                "hc-a2": "MH",
                "labelrank": "7",
                "hasc": "TH.MH",
                "alt-name": null,
                "woe-id": "2347128",
                "subregion": null,
                "fips": "TH01",
                "postal-code": "MH",
                "name": "Mae Hong Son",
                "name-TH": "แม่ฮ่องสอน",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northern",
                "longitude": "97.89109999999999",
                "woe-name": "Mae Hong Son",
                "latitude": "18.4043",
                "woe-label": "Mae Hong Son, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -633,
                            7733
                        ],
                        [
                            -730,
                            7825
                        ],
                        [
                            -744,
                            7869
                        ],
                        [
                            -795,
                            7936
                        ],
                        [
                            -763,
                            8019
                        ],
                        [
                            -739,
                            8037
                        ],
                        [
                            -763,
                            8099
                        ],
                        [
                            -782,
                            8112
                        ],
                        [
                            -787,
                            8167
                        ],
                        [
                            -833,
                            8238
                        ],
                        [
                            -819,
                            8285
                        ],
                        [
                            -873,
                            8302
                        ],
                        [
                            -896,
                            8256
                        ],
                        [
                            -949,
                            8306
                        ],
                        [
                            -955,
                            8357
                        ],
                        [
                            -999,
                            8444
                        ],
                        [
                            -973,
                            8426
                        ],
                        [
                            -908,
                            8422
                        ],
                        [
                            -832,
                            8466
                        ],
                        [
                            -742,
                            8479
                        ],
                        [
                            -732,
                            8517
                        ],
                        [
                            -759,
                            8694
                        ],
                        [
                            -802,
                            8739
                        ],
                        [
                            -770,
                            8767
                        ],
                        [
                            -752,
                            8821
                        ],
                        [
                            -694,
                            8875
                        ],
                        [
                            -691,
                            8933
                        ],
                        [
                            -723,
                            8996
                        ],
                        [
                            -696,
                            9014
                        ],
                        [
                            -723,
                            9085
                        ],
                        [
                            -666,
                            9155
                        ],
                        [
                            -672,
                            9200
                        ],
                        [
                            -554,
                            9261
                        ],
                        [
                            -556,
                            9323
                        ],
                        [
                            -542,
                            9381
                        ],
                        [
                            -482,
                            9362
                        ],
                        [
                            -412,
                            9318
                        ],
                        [
                            -395,
                            9279
                        ],
                        [
                            -346,
                            9297
                        ],
                        [
                            -254,
                            9295
                        ],
                        [
                            -228,
                            9308
                        ],
                        [
                            -225,
                            9278
                        ],
                        [
                            -177,
                            9234
                        ],
                        [
                            -156,
                            9164
                        ],
                        [
                            -138,
                            9142
                        ],
                        [
                            -148,
                            9076
                        ],
                        [
                            -137,
                            8993
                        ],
                        [
                            -152,
                            8940
                        ],
                        [
                            -127,
                            8913
                        ],
                        [
                            -106,
                            8865
                        ],
                        [
                            -118,
                            8831
                        ],
                        [
                            -191,
                            8810
                        ],
                        [
                            -225,
                            8818
                        ],
                        [
                            -243,
                            8796
                        ],
                        [
                            -270,
                            8810
                        ],
                        [
                            -328,
                            8817
                        ],
                        [
                            -390,
                            8895
                        ],
                        [
                            -420,
                            8912
                        ],
                        [
                            -453,
                            8898
                        ],
                        [
                            -480,
                            8849
                        ],
                        [
                            -470,
                            8822
                        ],
                        [
                            -486,
                            8793
                        ],
                        [
                            -477,
                            8755
                        ],
                        [
                            -505,
                            8668
                        ],
                        [
                            -480,
                            8626
                        ],
                        [
                            -494,
                            8529
                        ],
                        [
                            -484,
                            8454
                        ],
                        [
                            -454,
                            8414
                        ],
                        [
                            -419,
                            8395
                        ],
                        [
                            -448,
                            8378
                        ],
                        [
                            -495,
                            8308
                        ],
                        [
                            -482,
                            8285
                        ],
                        [
                            -501,
                            8232
                        ],
                        [
                            -478,
                            8125
                        ],
                        [
                            -508,
                            8077
                        ],
                        [
                            -495,
                            8035
                        ],
                        [
                            -457,
                            8007
                        ],
                        [
                            -397,
                            7936
                        ],
                        [
                            -419,
                            7896
                        ],
                        [
                            -395,
                            7852
                        ],
                        [
                            -355,
                            7835
                        ],
                        [
                            -393,
                            7827
                        ],
                        [
                            -426,
                            7799
                        ],
                        [
                            -494,
                            7794
                        ],
                        [
                            -592,
                            7744
                        ],
                        [
                            -633,
                            7733
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PU",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.50,
                "hc-middle-y": 0.50,
                "hc-key": "th-pu",
                "hc-a2": "PU",
                "labelrank": "9",
                "hasc": "TH.PU",
                "alt-name": null,
                "woe-id": "2347186",
                "subregion": null,
                "fips": "TH62",
                "postal-code": "PU",
                "name": "Phuket",
                "name-TH": "ภูเก็ต",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "98.3472",
                "woe-name": "Phuket",
                "latitude": "7.97108",
                "woe-label": "Phuket, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -344,
                            607
                        ],
                        [
                            -370,
                            559
                        ],
                        [
                            -386,
                            577
                        ],
                        [
                            -410,
                            677
                        ],
                        [
                            -390,
                            731
                        ],
                        [
                            -395,
                            780
                        ],
                        [
                            -384,
                            868
                        ],
                        [
                            -354,
                            854
                        ],
                        [
                            -332,
                            816
                        ],
                        [
                            -275,
                            777
                        ],
                        [
                            -305,
                            696
                        ],
                        [
                            -274,
                            646
                        ],
                        [
                            -304,
                            630
                        ],
                        [
                            -305,
                            594
                        ],
                        [
                            -344,
                            607
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.CP",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.80,
                "hc-middle-y": 0.16,
                "hc-key": "th-cp",
                "hc-a2": "CP",
                "labelrank": "7",
                "hasc": "TH.CP",
                "alt-name": null,
                "woe-id": "2347182",
                "subregion": null,
                "fips": "TH58",
                "postal-code": "CP",
                "name": "Chumphon",
                "name-TH": "ชุมพร",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "99.07550000000001",
                "woe-name": "Chumphon",
                "latitude": "10.3809",
                "woe-label": "Chumphon, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            499,
                            2925
                        ],
                        [
                            494,
                            2886
                        ],
                        [
                            505,
                            2829
                        ],
                        [
                            462,
                            2836
                        ],
                        [
                            450,
                            2782
                        ],
                        [
                            407,
                            2716
                        ],
                        [
                            354,
                            2656
                        ],
                        [
                            314,
                            2519
                        ],
                        [
                            344,
                            2496
                        ],
                        [
                            337,
                            2456
                        ],
                        [
                            305,
                            2446
                        ],
                        [
                            280,
                            2471
                        ],
                        [
                            245,
                            2456
                        ],
                        [
                            250,
                            2416
                        ],
                        [
                            310,
                            2351
                        ],
                        [
                            281,
                            2348
                        ],
                        [
                            251,
                            2288
                        ],
                        [
                            246,
                            2250
                        ],
                        [
                            262,
                            2204
                        ],
                        [
                            250,
                            2187
                        ],
                        [
                            257,
                            2080
                        ],
                        [
                            240,
                            2041
                        ],
                        [
                            206,
                            2036
                        ],
                        [
                            160,
                            2000
                        ],
                        [
                            64,
                            1996
                        ],
                        [
                            -23,
                            1958
                        ],
                        [
                            -47,
                            1902
                        ],
                        [
                            -108,
                            1942
                        ],
                        [
                            -129,
                            2014
                        ],
                        [
                            -126,
                            2037
                        ],
                        [
                            -68,
                            2090
                        ],
                        [
                            -30,
                            2150
                        ],
                        [
                            6,
                            2156
                        ],
                        [
                            29,
                            2189
                        ],
                        [
                            65,
                            2207
                        ],
                        [
                            90,
                            2286
                        ],
                        [
                            60,
                            2332
                        ],
                        [
                            72,
                            2404
                        ],
                        [
                            99,
                            2444
                        ],
                        [
                            95,
                            2472
                        ],
                        [
                            65,
                            2505
                        ],
                        [
                            71,
                            2548
                        ],
                        [
                            111,
                            2587
                        ],
                        [
                            116,
                            2630
                        ],
                        [
                            93,
                            2682
                        ],
                        [
                            68,
                            2698
                        ],
                        [
                            80,
                            2738
                        ],
                        [
                            47,
                            2772
                        ],
                        [
                            66,
                            2791
                        ],
                        [
                            116,
                            2798
                        ],
                        [
                            122,
                            2875
                        ],
                        [
                            136,
                            2896
                        ],
                        [
                            175,
                            2887
                        ],
                        [
                            190,
                            2924
                        ],
                        [
                            237,
                            2956
                        ],
                        [
                            246,
                            2930
                        ],
                        [
                            327,
                            2896
                        ],
                        [
                            433,
                            2895
                        ],
                        [
                            499,
                            2925
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.YL",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.36,
                "hc-key": "th-yl",
                "hc-a2": "YL",
                "labelrank": "7",
                "hasc": "TH.YL",
                "alt-name": null,
                "woe-id": "2347194",
                "subregion": null,
                "fips": "TH70",
                "postal-code": "YL",
                "name": "Yala",
                "name-TH": "ยะลา",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Southern",
                "longitude": "101.218",
                "woe-name": "Yala",
                "latitude": "6.14264",
                "woe-label": "Yala, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1969,
                            -811
                        ],
                        [
                            1785,
                            -889
                        ],
                        [
                            1768,
                            -954
                        ],
                        [
                            1713,
                            -998
                        ],
                        [
                            1680,
                            -999
                        ],
                        [
                            1630,
                            -935
                        ],
                        [
                            1596,
                            -926
                        ],
                        [
                            1578,
                            -894
                        ],
                        [
                            1613,
                            -808
                        ],
                        [
                            1654,
                            -792
                        ],
                        [
                            1671,
                            -671
                        ],
                        [
                            1640,
                            -635
                        ],
                        [
                            1667,
                            -595
                        ],
                        [
                            1661,
                            -553
                        ],
                        [
                            1618,
                            -557
                        ],
                        [
                            1582,
                            -534
                        ],
                        [
                            1535,
                            -561
                        ],
                        [
                            1479,
                            -561
                        ],
                        [
                            1472,
                            -515
                        ],
                        [
                            1515,
                            -513
                        ],
                        [
                            1543,
                            -485
                        ],
                        [
                            1546,
                            -416
                        ],
                        [
                            1622,
                            -384
                        ],
                        [
                            1676,
                            -305
                        ],
                        [
                            1674,
                            -266
                        ],
                        [
                            1716,
                            -293
                        ],
                        [
                            1772,
                            -291
                        ],
                        [
                            1820,
                            -241
                        ],
                        [
                            1823,
                            -293
                        ],
                        [
                            1854,
                            -329
                        ],
                        [
                            1939,
                            -314
                        ],
                        [
                            1973,
                            -295
                        ],
                        [
                            2009,
                            -332
                        ],
                        [
                            2041,
                            -325
                        ],
                        [
                            2050,
                            -341
                        ],
                        [
                            1994,
                            -407
                        ],
                        [
                            1920,
                            -430
                        ],
                        [
                            1897,
                            -567
                        ],
                        [
                            1882,
                            -588
                        ],
                        [
                            1960,
                            -699
                        ],
                        [
                            1958,
                            -744
                        ],
                        [
                            1969,
                            -811
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.CR",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.50,
                "hc-middle-y": 0.37,
                "hc-key": "th-cr",
                "hc-a2": "CR",
                "labelrank": "7",
                "hasc": "TH.CR",
                "alt-name": null,
                "woe-id": "2347130",
                "subregion": null,
                "fips": "TH03",
                "postal-code": "CR",
                "name": "Chiang Rai",
                "name-TH": "เชียงราย",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northern",
                "longitude": "99.9059",
                "woe-name": "Chiang Rai",
                "latitude": "19.9607",
                "woe-label": "Chiang Rai, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            487,
                            9636
                        ],
                        [
                            499,
                            9668
                        ],
                        [
                            471,
                            9704
                        ],
                        [
                            457,
                            9760
                        ],
                        [
                            426,
                            9799
                        ],
                        [
                            483,
                            9777
                        ],
                        [
                            586,
                            9749
                        ],
                        [
                            667,
                            9766
                        ],
                        [
                            691,
                            9781
                        ],
                        [
                            714,
                            9831
                        ],
                        [
                            786,
                            9851
                        ],
                        [
                            817,
                            9809
                        ],
                        [
                            851,
                            9799
                        ],
                        [
                            895,
                            9759
                        ],
                        [
                            898,
                            9719
                        ],
                        [
                            920,
                            9702
                        ],
                        [
                            943,
                            9712
                        ],
                        [
                            942,
                            9741
                        ],
                        [
                            971,
                            9756
                        ],
                        [
                            979,
                            9783
                        ],
                        [
                            1038,
                            9820
                        ],
                        [
                            1078,
                            9798
                        ],
                        [
                            1119,
                            9711
                        ],
                        [
                            1146,
                            9668
                        ],
                        [
                            1194,
                            9638
                        ],
                        [
                            1207,
                            9644
                        ],
                        [
                            1204,
                            9577
                        ],
                        [
                            1158,
                            9429
                        ],
                        [
                            1128,
                            9409
                        ],
                        [
                            1095,
                            9354
                        ],
                        [
                            1100,
                            9325
                        ],
                        [
                            1069,
                            9290
                        ],
                        [
                            1013,
                            9260
                        ],
                        [
                            959,
                            9244
                        ],
                        [
                            922,
                            9138
                        ],
                        [
                            887,
                            9108
                        ],
                        [
                            833,
                            9106
                        ],
                        [
                            793,
                            9074
                        ],
                        [
                            769,
                            9084
                        ],
                        [
                            767,
                            9146
                        ],
                        [
                            654,
                            9126
                        ],
                        [
                            613,
                            9106
                        ],
                        [
                            581,
                            9159
                        ],
                        [
                            545,
                            9137
                        ],
                        [
                            531,
                            9086
                        ],
                        [
                            538,
                            9006
                        ],
                        [
                            524,
                            8976
                        ],
                        [
                            514,
                            8906
                        ],
                        [
                            526,
                            8882
                        ],
                        [
                            507,
                            8844
                        ],
                        [
                            475,
                            8836
                        ],
                        [
                            443,
                            8798
                        ],
                        [
                            414,
                            8789
                        ],
                        [
                            406,
                            8822
                        ],
                        [
                            362,
                            8881
                        ],
                        [
                            350,
                            8927
                        ],
                        [
                            373,
                            8992
                        ],
                        [
                            366,
                            9061
                        ],
                        [
                            340,
                            9157
                        ],
                        [
                            358,
                            9191
                        ],
                        [
                            323,
                            9237
                        ],
                        [
                            323,
                            9275
                        ],
                        [
                            373,
                            9309
                        ],
                        [
                            402,
                            9378
                        ],
                        [
                            425,
                            9390
                        ],
                        [
                            403,
                            9446
                        ],
                        [
                            441,
                            9504
                        ],
                        [
                            497,
                            9497
                        ],
                        [
                            518,
                            9462
                        ],
                        [
                            544,
                            9530
                        ],
                        [
                            489,
                            9564
                        ],
                        [
                            488,
                            9586
                        ],
                        [
                            526,
                            9615
                        ],
                        [
                            487,
                            9636
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.CM",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.53,
                "hc-middle-y": 0.40,
                "hc-key": "th-cm",
                "hc-a2": "CM",
                "labelrank": "7",
                "hasc": "TH.CM",
                "alt-name": null,
                "woe-id": "2347129",
                "subregion": null,
                "fips": "TH02",
                "postal-code": "CM",
                "name": "Chiang Mai",
                "name-TH": "เชียงใหม่",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northern",
                "longitude": "98.69670000000001",
                "woe-name": "Chiang Mai",
                "latitude": "18.8368",
                "woe-label": "Chiang Mai, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -228,
                            9308
                        ],
                        [
                            -190,
                            9286
                        ],
                        [
                            -114,
                            9337
                        ],
                        [
                            -39,
                            9350
                        ],
                        [
                            1,
                            9382
                        ],
                        [
                            54,
                            9337
                        ],
                        [
                            117,
                            9368
                        ],
                        [
                            141,
                            9411
                        ],
                        [
                            134,
                            9456
                        ],
                        [
                            146,
                            9554
                        ],
                        [
                            160,
                            9579
                        ],
                        [
                            216,
                            9610
                        ],
                        [
                            258,
                            9613
                        ],
                        [
                            340,
                            9570
                        ],
                        [
                            441,
                            9598
                        ],
                        [
                            487,
                            9636
                        ],
                        [
                            526,
                            9615
                        ],
                        [
                            488,
                            9586
                        ],
                        [
                            489,
                            9564
                        ],
                        [
                            544,
                            9530
                        ],
                        [
                            518,
                            9462
                        ],
                        [
                            497,
                            9497
                        ],
                        [
                            441,
                            9504
                        ],
                        [
                            403,
                            9446
                        ],
                        [
                            425,
                            9390
                        ],
                        [
                            402,
                            9378
                        ],
                        [
                            373,
                            9309
                        ],
                        [
                            323,
                            9275
                        ],
                        [
                            323,
                            9237
                        ],
                        [
                            358,
                            9191
                        ],
                        [
                            340,
                            9157
                        ],
                        [
                            366,
                            9061
                        ],
                        [
                            373,
                            8992
                        ],
                        [
                            350,
                            8927
                        ],
                        [
                            362,
                            8881
                        ],
                        [
                            406,
                            8822
                        ],
                        [
                            414,
                            8789
                        ],
                        [
                            394,
                            8772
                        ],
                        [
                            392,
                            8715
                        ],
                        [
                            363,
                            8694
                        ],
                        [
                            377,
                            8681
                        ],
                        [
                            390,
                            8618
                        ],
                        [
                            361,
                            8515
                        ],
                        [
                            382,
                            8502
                        ],
                        [
                            355,
                            8446
                        ],
                        [
                            289,
                            8491
                        ],
                        [
                            290,
                            8533
                        ],
                        [
                            258,
                            8575
                        ],
                        [
                            235,
                            8573
                        ],
                        [
                            165,
                            8537
                        ],
                        [
                            142,
                            8547
                        ],
                        [
                            83,
                            8445
                        ],
                        [
                            -23,
                            8382
                        ],
                        [
                            -75,
                            8367
                        ],
                        [
                            -70,
                            8305
                        ],
                        [
                            -89,
                            8278
                        ],
                        [
                            -19,
                            8243
                        ],
                        [
                            6,
                            8162
                        ],
                        [
                            -3,
                            8058
                        ],
                        [
                            30,
                            8035
                        ],
                        [
                            72,
                            7924
                        ],
                        [
                            63,
                            7871
                        ],
                        [
                            22,
                            7848
                        ],
                        [
                            -40,
                            7879
                        ],
                        [
                            -69,
                            7878
                        ],
                        [
                            -101,
                            7864
                        ],
                        [
                            -138,
                            7812
                        ],
                        [
                            -128,
                            7768
                        ],
                        [
                            -138,
                            7745
                        ],
                        [
                            -174,
                            7734
                        ],
                        [
                            -194,
                            7668
                        ],
                        [
                            -170,
                            7634
                        ],
                        [
                            -182,
                            7591
                        ],
                        [
                            -167,
                            7577
                        ],
                        [
                            -173,
                            7536
                        ],
                        [
                            -277,
                            7508
                        ],
                        [
                            -332,
                            7546
                        ],
                        [
                            -347,
                            7613
                        ],
                        [
                            -342,
                            7708
                        ],
                        [
                            -352,
                            7739
                        ],
                        [
                            -386,
                            7750
                        ],
                        [
                            -387,
                            7789
                        ],
                        [
                            -355,
                            7835
                        ],
                        [
                            -395,
                            7852
                        ],
                        [
                            -419,
                            7896
                        ],
                        [
                            -397,
                            7936
                        ],
                        [
                            -457,
                            8007
                        ],
                        [
                            -495,
                            8035
                        ],
                        [
                            -508,
                            8077
                        ],
                        [
                            -478,
                            8125
                        ],
                        [
                            -501,
                            8232
                        ],
                        [
                            -482,
                            8285
                        ],
                        [
                            -495,
                            8308
                        ],
                        [
                            -448,
                            8378
                        ],
                        [
                            -419,
                            8395
                        ],
                        [
                            -454,
                            8414
                        ],
                        [
                            -484,
                            8454
                        ],
                        [
                            -494,
                            8529
                        ],
                        [
                            -480,
                            8626
                        ],
                        [
                            -505,
                            8668
                        ],
                        [
                            -477,
                            8755
                        ],
                        [
                            -486,
                            8793
                        ],
                        [
                            -470,
                            8822
                        ],
                        [
                            -480,
                            8849
                        ],
                        [
                            -453,
                            8898
                        ],
                        [
                            -420,
                            8912
                        ],
                        [
                            -390,
                            8895
                        ],
                        [
                            -328,
                            8817
                        ],
                        [
                            -270,
                            8810
                        ],
                        [
                            -243,
                            8796
                        ],
                        [
                            -225,
                            8818
                        ],
                        [
                            -191,
                            8810
                        ],
                        [
                            -118,
                            8831
                        ],
                        [
                            -106,
                            8865
                        ],
                        [
                            -127,
                            8913
                        ],
                        [
                            -152,
                            8940
                        ],
                        [
                            -137,
                            8993
                        ],
                        [
                            -148,
                            9076
                        ],
                        [
                            -138,
                            9142
                        ],
                        [
                            -156,
                            9164
                        ],
                        [
                            -177,
                            9234
                        ],
                        [
                            -225,
                            9278
                        ],
                        [
                            -228,
                            9308
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.LN",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.53,
                "hc-middle-y": 0.16,
                "hc-key": "th-ln",
                "hc-a2": "LN",
                "labelrank": "7",
                "hasc": "TH.LN",
                "alt-name": "Hariphunchai|Lampoon",
                "woe-id": "2347132",
                "subregion": null,
                "fips": "TH05",
                "postal-code": "LN",
                "name": "Lamphun",
                "name-TH": "ลำพูน",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northern",
                "longitude": "98.9979",
                "woe-name": "Lamphun",
                "latitude": "18.1333",
                "woe-label": "Lamphun, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -69,
                            7878
                        ],
                        [
                            -40,
                            7879
                        ],
                        [
                            22,
                            7848
                        ],
                        [
                            63,
                            7871
                        ],
                        [
                            72,
                            7924
                        ],
                        [
                            30,
                            8035
                        ],
                        [
                            -3,
                            8058
                        ],
                        [
                            6,
                            8162
                        ],
                        [
                            -19,
                            8243
                        ],
                        [
                            -89,
                            8278
                        ],
                        [
                            -70,
                            8305
                        ],
                        [
                            -75,
                            8367
                        ],
                        [
                            -23,
                            8382
                        ],
                        [
                            83,
                            8445
                        ],
                        [
                            142,
                            8547
                        ],
                        [
                            165,
                            8537
                        ],
                        [
                            235,
                            8573
                        ],
                        [
                            258,
                            8575
                        ],
                        [
                            290,
                            8533
                        ],
                        [
                            289,
                            8491
                        ],
                        [
                            355,
                            8446
                        ],
                        [
                            352,
                            8424
                        ],
                        [
                            300,
                            8406
                        ],
                        [
                            208,
                            8258
                        ],
                        [
                            146,
                            8235
                        ],
                        [
                            175,
                            8156
                        ],
                        [
                            179,
                            8098
                        ],
                        [
                            201,
                            8053
                        ],
                        [
                            212,
                            7998
                        ],
                        [
                            259,
                            7956
                        ],
                        [
                            251,
                            7919
                        ],
                        [
                            210,
                            7910
                        ],
                        [
                            220,
                            7890
                        ],
                        [
                            178,
                            7821
                        ],
                        [
                            173,
                            7779
                        ],
                        [
                            143,
                            7772
                        ],
                        [
                            87,
                            7796
                        ],
                        [
                            60,
                            7777
                        ],
                        [
                            40,
                            7714
                        ],
                        [
                            -25,
                            7679
                        ],
                        [
                            -61,
                            7680
                        ],
                        [
                            -76,
                            7771
                        ],
                        [
                            -72,
                            7811
                        ],
                        [
                            -44,
                            7826
                        ],
                        [
                            -69,
                            7878
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.NA",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.47,
                "hc-middle-y": 0.51,
                "hc-key": "th-na",
                "hc-a2": "NA",
                "labelrank": "7",
                "hasc": "TH.NA",
                "alt-name": null,
                "woe-id": "2347131",
                "subregion": null,
                "fips": "TH04",
                "postal-code": "NA",
                "name": "Nan",
                "name-TH": "น่าน",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northern",
                "longitude": "100.837",
                "woe-name": "Nan",
                "latitude": "18.8264",
                "woe-label": "Nan, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1230,
                            9168
                        ],
                        [
                            1270,
                            9193
                        ],
                        [
                            1327,
                            9172
                        ],
                        [
                            1354,
                            9150
                        ],
                        [
                            1438,
                            9247
                        ],
                        [
                            1507,
                            9248
                        ],
                        [
                            1612,
                            9214
                        ],
                        [
                            1670,
                            9232
                        ],
                        [
                            1696,
                            9219
                        ],
                        [
                            1704,
                            9184
                        ],
                        [
                            1692,
                            9147
                        ],
                        [
                            1660,
                            9132
                        ],
                        [
                            1651,
                            9054
                        ],
                        [
                            1668,
                            9048
                        ],
                        [
                            1688,
                            8966
                        ],
                        [
                            1689,
                            8905
                        ],
                        [
                            1751,
                            8838
                        ],
                        [
                            1758,
                            8816
                        ],
                        [
                            1728,
                            8787
                        ],
                        [
                            1693,
                            8721
                        ],
                        [
                            1691,
                            8650
                        ],
                        [
                            1680,
                            8589
                        ],
                        [
                            1701,
                            8561
                        ],
                        [
                            1651,
                            8511
                        ],
                        [
                            1642,
                            8474
                        ],
                        [
                            1588,
                            8440
                        ],
                        [
                            1556,
                            8379
                        ],
                        [
                            1587,
                            8338
                        ],
                        [
                            1480,
                            8247
                        ],
                        [
                            1425,
                            8125
                        ],
                        [
                            1370,
                            8082
                        ],
                        [
                            1238,
                            8098
                        ],
                        [
                            1198,
                            8075
                        ],
                        [
                            1132,
                            8073
                        ],
                        [
                            1120,
                            8157
                        ],
                        [
                            1150,
                            8171
                        ],
                        [
                            1188,
                            8264
                        ],
                        [
                            1185,
                            8315
                        ],
                        [
                            1214,
                            8375
                        ],
                        [
                            1205,
                            8410
                        ],
                        [
                            1177,
                            8423
                        ],
                        [
                            1120,
                            8425
                        ],
                        [
                            1104,
                            8486
                        ],
                        [
                            1117,
                            8527
                        ],
                        [
                            1098,
                            8532
                        ],
                        [
                            1093,
                            8573
                        ],
                        [
                            1109,
                            8594
                        ],
                        [
                            1079,
                            8658
                        ],
                        [
                            1125,
                            8747
                        ],
                        [
                            1163,
                            8757
                        ],
                        [
                            1181,
                            8784
                        ],
                        [
                            1155,
                            8791
                        ],
                        [
                            1166,
                            8832
                        ],
                        [
                            1231,
                            8821
                        ],
                        [
                            1225,
                            8861
                        ],
                        [
                            1273,
                            8895
                        ],
                        [
                            1246,
                            8979
                        ],
                        [
                            1255,
                            9027
                        ],
                        [
                            1230,
                            9050
                        ],
                        [
                            1204,
                            9047
                        ],
                        [
                            1187,
                            9080
                        ],
                        [
                            1225,
                            9135
                        ],
                        [
                            1230,
                            9168
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.LG",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.61,
                "hc-middle-y": 0.36,
                "hc-key": "th-lg",
                "hc-a2": "LG",
                "labelrank": "7",
                "hasc": "TH.LG",
                "alt-name": null,
                "woe-id": "2347133",
                "subregion": null,
                "fips": "TH06",
                "postal-code": "LG",
                "name": "Lampang",
                "name-TH": "ลำปาง",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northern",
                "longitude": "99.5707",
                "woe-name": "Lampang",
                "latitude": "18.6296",
                "woe-label": "Lampang, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            918,
                            8655
                        ],
                        [
                            909,
                            8595
                        ],
                        [
                            921,
                            8502
                        ],
                        [
                            914,
                            8474
                        ],
                        [
                            880,
                            8465
                        ],
                        [
                            875,
                            8429
                        ],
                        [
                            837,
                            8356
                        ],
                        [
                            812,
                            8339
                        ],
                        [
                            775,
                            8274
                        ],
                        [
                            742,
                            8260
                        ],
                        [
                            705,
                            8219
                        ],
                        [
                            642,
                            8110
                        ],
                        [
                            589,
                            8075
                        ],
                        [
                            564,
                            8084
                        ],
                        [
                            497,
                            8015
                        ],
                        [
                            398,
                            7895
                        ],
                        [
                            356,
                            7888
                        ],
                        [
                            356,
                            7861
                        ],
                        [
                            381,
                            7825
                        ],
                        [
                            402,
                            7821
                        ],
                        [
                            467,
                            7859
                        ],
                        [
                            469,
                            7818
                        ],
                        [
                            453,
                            7765
                        ],
                        [
                            430,
                            7739
                        ],
                        [
                            442,
                            7708
                        ],
                        [
                            426,
                            7664
                        ],
                        [
                            444,
                            7640
                        ],
                        [
                            439,
                            7612
                        ],
                        [
                            471,
                            7586
                        ],
                        [
                            445,
                            7491
                        ],
                        [
                            410,
                            7474
                        ],
                        [
                            380,
                            7510
                        ],
                        [
                            358,
                            7515
                        ],
                        [
                            333,
                            7557
                        ],
                        [
                            325,
                            7612
                        ],
                        [
                            289,
                            7614
                        ],
                        [
                            256,
                            7569
                        ],
                        [
                            167,
                            7604
                        ],
                        [
                            144,
                            7634
                        ],
                        [
                            158,
                            7693
                        ],
                        [
                            143,
                            7772
                        ],
                        [
                            173,
                            7779
                        ],
                        [
                            178,
                            7821
                        ],
                        [
                            220,
                            7890
                        ],
                        [
                            210,
                            7910
                        ],
                        [
                            251,
                            7919
                        ],
                        [
                            259,
                            7956
                        ],
                        [
                            212,
                            7998
                        ],
                        [
                            201,
                            8053
                        ],
                        [
                            179,
                            8098
                        ],
                        [
                            175,
                            8156
                        ],
                        [
                            146,
                            8235
                        ],
                        [
                            208,
                            8258
                        ],
                        [
                            300,
                            8406
                        ],
                        [
                            352,
                            8424
                        ],
                        [
                            355,
                            8446
                        ],
                        [
                            382,
                            8502
                        ],
                        [
                            361,
                            8515
                        ],
                        [
                            390,
                            8618
                        ],
                        [
                            377,
                            8681
                        ],
                        [
                            363,
                            8694
                        ],
                        [
                            392,
                            8715
                        ],
                        [
                            394,
                            8772
                        ],
                        [
                            414,
                            8789
                        ],
                        [
                            443,
                            8798
                        ],
                        [
                            475,
                            8836
                        ],
                        [
                            507,
                            8844
                        ],
                        [
                            526,
                            8882
                        ],
                        [
                            514,
                            8906
                        ],
                        [
                            524,
                            8976
                        ],
                        [
                            538,
                            9006
                        ],
                        [
                            531,
                            9086
                        ],
                        [
                            545,
                            9137
                        ],
                        [
                            581,
                            9159
                        ],
                        [
                            613,
                            9106
                        ],
                        [
                            629,
                            9025
                        ],
                        [
                            629,
                            8959
                        ],
                        [
                            686,
                            8835
                        ],
                        [
                            708,
                            8829
                        ],
                        [
                            723,
                            8792
                        ],
                        [
                            784,
                            8781
                        ],
                        [
                            808,
                            8748
                        ],
                        [
                            865,
                            8713
                        ],
                        [
                            884,
                            8664
                        ],
                        [
                            918,
                            8655
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.PB",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.69,
                "hc-middle-y": 0.34,
                "hc-key": "th-pb",
                "hc-a2": "PB",
                "labelrank": "7",
                "hasc": "TH.PB",
                "alt-name": null,
                "woe-id": "20069926",
                "subregion": null,
                "fips": "TH74",
                "postal-code": "PB",
                "name": "Prachin Buri",
                "name-TH": "ปราจีนบุรี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Eastern",
                "longitude": "101.594",
                "woe-name": "Prachin Buri",
                "latitude": "14.1081",
                "woe-label": "Prachin Buri, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1667,
                            5109
                        ],
                        [
                            1663,
                            5125
                        ],
                        [
                            1721,
                            5167
                        ],
                        [
                            1799,
                            5180
                        ],
                        [
                            1781,
                            5231
                        ],
                        [
                            1789,
                            5255
                        ],
                        [
                            1845,
                            5299
                        ],
                        [
                            1849,
                            5330
                        ],
                        [
                            1873,
                            5321
                        ],
                        [
                            1920,
                            5331
                        ],
                        [
                            1933,
                            5359
                        ],
                        [
                            1907,
                            5403
                        ],
                        [
                            1873,
                            5420
                        ],
                        [
                            1856,
                            5445
                        ],
                        [
                            1914,
                            5471
                        ],
                        [
                            1955,
                            5448
                        ],
                        [
                            2007,
                            5452
                        ],
                        [
                            2100,
                            5369
                        ],
                        [
                            2111,
                            5392
                        ],
                        [
                            2188,
                            5407
                        ],
                        [
                            2205,
                            5426
                        ],
                        [
                            2233,
                            5403
                        ],
                        [
                            2248,
                            5416
                        ],
                        [
                            2267,
                            5390
                        ],
                        [
                            2242,
                            5347
                        ],
                        [
                            2252,
                            5327
                        ],
                        [
                            2319,
                            5275
                        ],
                        [
                            2314,
                            5235
                        ],
                        [
                            2275,
                            5188
                        ],
                        [
                            2216,
                            5153
                        ],
                        [
                            2219,
                            5112
                        ],
                        [
                            2190,
                            5088
                        ],
                        [
                            2180,
                            5027
                        ],
                        [
                            2217,
                            4998
                        ],
                        [
                            2216,
                            4958
                        ],
                        [
                            2196,
                            4934
                        ],
                        [
                            2162,
                            4929
                        ],
                        [
                            2109,
                            4991
                        ],
                        [
                            2074,
                            4984
                        ],
                        [
                            2051,
                            4955
                        ],
                        [
                            1998,
                            4974
                        ],
                        [
                            1974,
                            4952
                        ],
                        [
                            1961,
                            4967
                        ],
                        [
                            1821,
                            5031
                        ],
                        [
                            1718,
                            5041
                        ],
                        [
                            1683,
                            5023
                        ],
                        [
                            1670,
                            5042
                        ],
                        [
                            1679,
                            5075
                        ],
                        [
                            1667,
                            5109
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.RT",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.35,
                "hc-middle-y": 0.56,
                "hc-key": "th-rt",
                "hc-a2": "RT",
                "labelrank": "7",
                "hasc": "TH.RT",
                "alt-name": null,
                "woe-id": "2347176",
                "subregion": null,
                "fips": "TH52",
                "postal-code": "RT",
                "name": "Ratchaburi",
                "name-TH": "ราชบุรี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Western",
                "longitude": "99.61279999999999",
                "woe-name": "Ratchaburi",
                "latitude": "13.4964",
                "woe-label": "Ratchaburi, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            751,
                            4634
                        ],
                        [
                            679,
                            4636
                        ],
                        [
                            640,
                            4621
                        ],
                        [
                            614,
                            4587
                        ],
                        [
                            611,
                            4549
                        ],
                        [
                            554,
                            4533
                        ],
                        [
                            515,
                            4538
                        ],
                        [
                            459,
                            4526
                        ],
                        [
                            384,
                            4559
                        ],
                        [
                            367,
                            4518
                        ],
                        [
                            329,
                            4500
                        ],
                        [
                            318,
                            4522
                        ],
                        [
                            269,
                            4547
                        ],
                        [
                            259,
                            4613
                        ],
                        [
                            269,
                            4633
                        ],
                        [
                            270,
                            4705
                        ],
                        [
                            244,
                            4819
                        ],
                        [
                            240,
                            4923
                        ],
                        [
                            281,
                            4928
                        ],
                        [
                            312,
                            4953
                        ],
                        [
                            389,
                            4944
                        ],
                        [
                            478,
                            4976
                        ],
                        [
                            527,
                            4949
                        ],
                        [
                            548,
                            4970
                        ],
                        [
                            628,
                            4996
                        ],
                        [
                            706,
                            4991
                        ],
                        [
                            765,
                            5086
                        ],
                        [
                            809,
                            5072
                        ],
                        [
                            823,
                            5012
                        ],
                        [
                            814,
                            4940
                        ],
                        [
                            827,
                            4920
                        ],
                        [
                            873,
                            4935
                        ],
                        [
                            884,
                            4903
                        ],
                        [
                            908,
                            4895
                        ],
                        [
                            891,
                            4840
                        ],
                        [
                            879,
                            4763
                        ],
                        [
                            836,
                            4754
                        ],
                        [
                            793,
                            4767
                        ],
                        [
                            751,
                            4634
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.YS",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.30,
                "hc-middle-y": 0.28,
                "hc-key": "th-ys",
                "hc-a2": "YS",
                "labelrank": "7",
                "hasc": "TH.YS",
                "alt-name": null,
                "woe-id": "2347195",
                "subregion": null,
                "fips": "TH72",
                "postal-code": "YS",
                "name": "Yasothon",
                "name-TH": "ยโสธร",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "104.324",
                "woe-name": "Yasothon",
                "latitude": "16.0225",
                "woe-label": "Yasothon, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            4258,
                            6789
                        ],
                        [
                            4255,
                            6767
                        ],
                        [
                            4120,
                            6734
                        ],
                        [
                            4083,
                            6701
                        ],
                        [
                            4041,
                            6610
                        ],
                        [
                            4017,
                            6578
                        ],
                        [
                            3991,
                            6436
                        ],
                        [
                            4005,
                            6375
                        ],
                        [
                            4056,
                            6336
                        ],
                        [
                            4043,
                            6300
                        ],
                        [
                            3980,
                            6294
                        ],
                        [
                            3966,
                            6224
                        ],
                        [
                            3973,
                            6197
                        ],
                        [
                            4008,
                            6163
                        ],
                        [
                            3995,
                            6115
                        ],
                        [
                            3975,
                            6137
                        ],
                        [
                            3906,
                            6155
                        ],
                        [
                            3876,
                            6173
                        ],
                        [
                            3800,
                            6269
                        ],
                        [
                            3784,
                            6316
                        ],
                        [
                            3841,
                            6348
                        ],
                        [
                            3808,
                            6406
                        ],
                        [
                            3780,
                            6417
                        ],
                        [
                            3781,
                            6480
                        ],
                        [
                            3738,
                            6522
                        ],
                        [
                            3739,
                            6503
                        ],
                        [
                            3694,
                            6486
                        ],
                        [
                            3698,
                            6617
                        ],
                        [
                            3761,
                            6623
                        ],
                        [
                            3759,
                            6706
                        ],
                        [
                            3846,
                            6761
                        ],
                        [
                            3883,
                            6823
                        ],
                        [
                            3912,
                            6831
                        ],
                        [
                            3931,
                            6878
                        ],
                        [
                            3964,
                            6895
                        ],
                        [
                            4031,
                            6894
                        ],
                        [
                            4076,
                            6870
                        ],
                        [
                            4096,
                            6830
                        ],
                        [
                            4129,
                            6804
                        ],
                        [
                            4155,
                            6820
                        ],
                        [
                            4187,
                            6804
                        ],
                        [
                            4258,
                            6789
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.MS",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.47,
                "hc-middle-y": 0.49,
                "hc-key": "th-ms",
                "hc-a2": "MS",
                "labelrank": "7",
                "hasc": "TH.MS",
                "alt-name": null,
                "woe-id": "2347149",
                "subregion": null,
                "fips": "TH24",
                "postal-code": "MS",
                "name": "Maha Sarakham",
                "name-TH": "มหาสารคาม",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "103.188",
                "woe-name": "Maha Sarakham",
                "latitude": "15.9151",
                "woe-label": "Maha Sarakham, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            3062,
                            6240
                        ],
                        [
                            3041,
                            6254
                        ],
                        [
                            3040,
                            6290
                        ],
                        [
                            2961,
                            6377
                        ],
                        [
                            2983,
                            6417
                        ],
                        [
                            2938,
                            6463
                        ],
                        [
                            2930,
                            6518
                        ],
                        [
                            2907,
                            6570
                        ],
                        [
                            2911,
                            6606
                        ],
                        [
                            2876,
                            6658
                        ],
                        [
                            2866,
                            6821
                        ],
                        [
                            2897,
                            6848
                        ],
                        [
                            2936,
                            6922
                        ],
                        [
                            2924,
                            6945
                        ],
                        [
                            2974,
                            6960
                        ],
                        [
                            3030,
                            6996
                        ],
                        [
                            3079,
                            7093
                        ],
                        [
                            3104,
                            7087
                        ],
                        [
                            3093,
                            7060
                        ],
                        [
                            3102,
                            7019
                        ],
                        [
                            3091,
                            6988
                        ],
                        [
                            3107,
                            6941
                        ],
                        [
                            3097,
                            6895
                        ],
                        [
                            3122,
                            6888
                        ],
                        [
                            3181,
                            6917
                        ],
                        [
                            3231,
                            6851
                        ],
                        [
                            3265,
                            6830
                        ],
                        [
                            3292,
                            6766
                        ],
                        [
                            3343,
                            6780
                        ],
                        [
                            3309,
                            6721
                        ],
                        [
                            3304,
                            6683
                        ],
                        [
                            3326,
                            6575
                        ],
                        [
                            3308,
                            6526
                        ],
                        [
                            3289,
                            6420
                        ],
                        [
                            3245,
                            6411
                        ],
                        [
                            3219,
                            6391
                        ],
                        [
                            3191,
                            6334
                        ],
                        [
                            3213,
                            6298
                        ],
                        [
                            3294,
                            6265
                        ],
                        [
                            3278,
                            6204
                        ],
                        [
                            3226,
                            6184
                        ],
                        [
                            3145,
                            6217
                        ],
                        [
                            3062,
                            6240
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.UN",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.53,
                "hc-middle-y": 0.57,
                "hc-key": "th-un",
                "hc-a2": "UN",
                "labelrank": "7",
                "hasc": "TH.UN",
                "alt-name": null,
                "woe-id": "2347200",
                "subregion": null,
                "fips": "TH76",
                "postal-code": "UN",
                "name": "Udon Thani",
                "name-TH": "อุดรธานี",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "102.882",
                "woe-name": "Udon Thani",
                "latitude": "17.4511",
                "woe-label": "Udon Thani, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2280,
                            8140
                        ],
                        [
                            2320,
                            8119
                        ],
                        [
                            2347,
                            8072
                        ],
                        [
                            2384,
                            8090
                        ],
                        [
                            2444,
                            8059
                        ],
                        [
                            2515,
                            8001
                        ],
                        [
                            2529,
                            7965
                        ],
                        [
                            2576,
                            7900
                        ],
                        [
                            2623,
                            7898
                        ],
                        [
                            2673,
                            7854
                        ],
                        [
                            2675,
                            7802
                        ],
                        [
                            2709,
                            7787
                        ],
                        [
                            2763,
                            7790
                        ],
                        [
                            2850,
                            7884
                        ],
                        [
                            2840,
                            7946
                        ],
                        [
                            2864,
                            8001
                        ],
                        [
                            2909,
                            7996
                        ],
                        [
                            2937,
                            7957
                        ],
                        [
                            2984,
                            8005
                        ],
                        [
                            3062,
                            7945
                        ],
                        [
                            3098,
                            7990
                        ],
                        [
                            3131,
                            8003
                        ],
                        [
                            3170,
                            7971
                        ],
                        [
                            3226,
                            7996
                        ],
                        [
                            3205,
                            7936
                        ],
                        [
                            3227,
                            7909
                        ],
                        [
                            3228,
                            7797
                        ],
                        [
                            3190,
                            7786
                        ],
                        [
                            3149,
                            7707
                        ],
                        [
                            3142,
                            7676
                        ],
                        [
                            3158,
                            7639
                        ],
                        [
                            3128,
                            7588
                        ],
                        [
                            3145,
                            7553
                        ],
                        [
                            3193,
                            7542
                        ],
                        [
                            3235,
                            7520
                        ],
                        [
                            3290,
                            7520
                        ],
                        [
                            3347,
                            7483
                        ],
                        [
                            3373,
                            7480
                        ],
                        [
                            3417,
                            7441
                        ],
                        [
                            3417,
                            7395
                        ],
                        [
                            3369,
                            7436
                        ],
                        [
                            3316,
                            7393
                        ],
                        [
                            3318,
                            7355
                        ],
                        [
                            3302,
                            7330
                        ],
                        [
                            3299,
                            7287
                        ],
                        [
                            3268,
                            7233
                        ],
                        [
                            3242,
                            7288
                        ],
                        [
                            3126,
                            7329
                        ],
                        [
                            3059,
                            7324
                        ],
                        [
                            3039,
                            7290
                        ],
                        [
                            2929,
                            7235
                        ],
                        [
                            2889,
                            7259
                        ],
                        [
                            2842,
                            7259
                        ],
                        [
                            2833,
                            7322
                        ],
                        [
                            2808,
                            7360
                        ],
                        [
                            2765,
                            7382
                        ],
                        [
                            2741,
                            7376
                        ],
                        [
                            2730,
                            7307
                        ],
                        [
                            2644,
                            7388
                        ],
                        [
                            2612,
                            7444
                        ],
                        [
                            2622,
                            7466
                        ],
                        [
                            2658,
                            7481
                        ],
                        [
                            2668,
                            7512
                        ],
                        [
                            2611,
                            7496
                        ],
                        [
                            2584,
                            7521
                        ],
                        [
                            2585,
                            7572
                        ],
                        [
                            2554,
                            7584
                        ],
                        [
                            2557,
                            7629
                        ],
                        [
                            2522,
                            7709
                        ],
                        [
                            2505,
                            7801
                        ],
                        [
                            2485,
                            7791
                        ],
                        [
                            2403,
                            7812
                        ],
                        [
                            2375,
                            7789
                        ],
                        [
                            2348,
                            7792
                        ],
                        [
                            2330,
                            7770
                        ],
                        [
                            2290,
                            7847
                        ],
                        [
                            2269,
                            7834
                        ],
                        [
                            2261,
                            7879
                        ],
                        [
                            2278,
                            7947
                        ],
                        [
                            2258,
                            8061
                        ],
                        [
                            2280,
                            8140
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "id": "TH.NB",
            "properties": {
                "hc-group": "admin1",
                "hc-middle-x": 0.40,
                "hc-middle-y": 0.39,
                "hc-key": "th-nb",
                "hc-a2": "NB",
                "labelrank": "7",
                "hasc": "TH.NB",
                "alt-name": "Nong Bua Lamphu",
                "woe-id": "2347202",
                "subregion": null,
                "fips": "TH79",
                "postal-code": "NB",
                "name": "Nong Bua Lam Phu",
                "name-TH": "หนองบัวลำภู",
                "country": "Thailand",
                "type-en": "Province",
                "region": "Northeastern",
                "longitude": "102.311",
                "woe-name": "Nong Bua Lam Phu",
                "latitude": "17.2392",
                "woe-label": "Nong Bua Lam Phu, TH, Thailand",
                "type": "Changwat"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2730,
                            7307
                        ],
                        [
                            2687,
                            7179
                        ],
                        [
                            2653,
                            7172
                        ],
                        [
                            2623,
                            7192
                        ],
                        [
                            2559,
                            7190
                        ],
                        [
                            2492,
                            7212
                        ],
                        [
                            2462,
                            7254
                        ],
                        [
                            2427,
                            7261
                        ],
                        [
                            2398,
                            7239
                        ],
                        [
                            2303,
                            7257
                        ],
                        [
                            2277,
                            7301
                        ],
                        [
                            2355,
                            7353
                        ],
                        [
                            2313,
                            7418
                        ],
                        [
                            2235,
                            7448
                        ],
                        [
                            2212,
                            7485
                        ],
                        [
                            2236,
                            7541
                        ],
                        [
                            2264,
                            7574
                        ],
                        [
                            2263,
                            7607
                        ],
                        [
                            2240,
                            7637
                        ],
                        [
                            2242,
                            7670
                        ],
                        [
                            2300,
                            7673
                        ],
                        [
                            2345,
                            7715
                        ],
                        [
                            2330,
                            7770
                        ],
                        [
                            2348,
                            7792
                        ],
                        [
                            2375,
                            7789
                        ],
                        [
                            2403,
                            7812
                        ],
                        [
                            2485,
                            7791
                        ],
                        [
                            2505,
                            7801
                        ],
                        [
                            2522,
                            7709
                        ],
                        [
                            2557,
                            7629
                        ],
                        [
                            2554,
                            7584
                        ],
                        [
                            2585,
                            7572
                        ],
                        [
                            2584,
                            7521
                        ],
                        [
                            2611,
                            7496
                        ],
                        [
                            2668,
                            7512
                        ],
                        [
                            2658,
                            7481
                        ],
                        [
                            2622,
                            7466
                        ],
                        [
                            2612,
                            7444
                        ],
                        [
                            2644,
                            7388
                        ],
                        [
                            2730,
                            7307
                        ]
                    ]
                ]
            }
        }
    ]
}

export default mapDataThailand;